{
  "level": "bs07",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs07",
    "objects": "AREAS.E3:bs07.e3",
    "mesh": "TREES.E3:bs07.e3"
  },
  "spawn_point": {
    "position": [
      -2589.3645764252824,
      -4547.961913557033,
      1013.8104248046875
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2589.3645764252824,
      -4447.961913557033,
      1013.8104248046875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4007.749267578125,
      -5045.98291015625,
      989.8104248046875
    ],
    "bbox_max": [
      -2214.77978515625,
      -3619.7685546875,
      1402.623779296875
    ],
    "vertex_count": 1449,
    "vertices": [
      [
        -2654.999755859375,
        -4362.7685546875,
        1023.0237426757812
      ],
      [
        -2655.0,
        -4353.7685546875,
        1052.623779296875
      ],
      [
        -2679.999755859375,
        -4367.96875,
        1030.623779296875
      ],
      [
        -2654.999755859375,
        -4362.7685546875,
        1023.0237426757812
      ],
      [
        -2654.999755859375,
        -4367.96875,
        1023.0237426757812
      ],
      [
        -2679.999755859375,
        -4367.96875,
        1030.623779296875
      ],
      [
        -2679.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      [
        -2654.999755859375,
        -4399.7685546875,
        1021.2237548828125
      ],
      [
        -2654.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      [
        -2654.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      [
        -2654.999755859375,
        -4429.7685546875,
        1031.2237548828125
      ],
      [
        -2654.999755859375,
        -4429.7685546875,
        1031.2237548828125
      ],
      [
        -2654.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      [
        -2654.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      [
        -2654.999755859375,
        -4399.7685546875,
        1021.2237548828125
      ],
      [
        -2654.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      [
        -2433.977783203125,
        -4729.27099609375,
        989.8104248046875
      ],
      [
        -2433.977783203125,
        -4790.26611328125,
        989.8104248046875
      ],
      [
        -2397.8544921875,
        -4759.7685546875,
        1007.824462890625
      ],
      [
        -2407.26953125,
        -4782.4990234375,
        1003.1293334960938
      ],
      [
        -2429.999755859375,
        -4791.9140625,
        991.794189453125
      ],
      [
        -2407.26953125,
        -4782.4990234375,
        1003.1293334960938
      ],
      [
        -2433.977783203125,
        -4790.26611328125,
        989.8104248046875
      ],
      [
        -2429.999755859375,
        -4791.9140625,
        991.794189453125
      ],
      [
        -2452.72998046875,
        -4782.4990234375,
        1003.1292114257812
      ],
      [
        -2462.14501953125,
        -4759.7685546875,
        1007.8242797851562
      ],
      [
        -2462.14501953125,
        -4759.7685546875,
        1007.8242797851562
      ],
      [
        -2452.72998046875,
        -4737.0380859375,
        1003.1292114257812
      ],
      [
        -2452.72998046875,
        -4782.4990234375,
        1003.1292114257812
      ],
      [
        -2450.496337890625,
        -4783.42431640625,
        1002.0153198242188
      ],
      [
        -2429.999755859375,
        -4791.9140625,
        1002.0154418945312
      ],
      [
        -2429.999755859375,
        -4791.9140625,
        1002.0154418945312
      ],
      [
        -2420.9423828125,
        -4788.16259765625,
        996.3109741210938
      ],
      [
        -2409.504150390625,
        -4783.4248046875,
        1002.0150146484375
      ],
      [
        -2407.26953125,
        -4782.4990234375,
        1009.0205688476562
      ],
      [
        -2458.83154296875,
        -4767.7685546875,
        1010.9924926757812
      ],
      [
        -2458.831298828125,
        -4767.7685546875,
        1006.171875
      ],
      [
        -2407.26953125,
        -4782.4990234375,
        1009.0205688476562
      ],
      [
        -2402.874267578125,
        -4771.8876953125,
        1005.3212280273438
      ],
      [
        -2401.168212890625,
        -4767.7685546875,
        1006.1719970703125
      ],
      [
        -2401.16796875,
        -4767.7685546875,
        1010.9923706054688
      ],
      [
        -2423.8173828125,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2417.461181640625,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2414.220458984375,
        -4783.90380859375,
        1052.623779296875
      ],
      [
        -2423.8173828125,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2417.461181640625,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2407.86474609375,
        -4777.5478515625,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2436.18212890625,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2436.18212890625,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2445.77880859375,
        -4783.90380859375,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4777.5478515625,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2458.831298828125,
        -4751.7685546875,
        1006.171875
      ],
      [
        -2436.18212890625,
        -4745.22998046875,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4751.5859375,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4751.5859375,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2445.77880859375,
        -4735.6337890625,
        1052.623779296875
      ],
      [
        -2437.697509765625,
        -4743.71484375,
        1052.623779296875
      ],
      [
        -2436.18212890625,
        -4745.22998046875,
        1052.623779296875
      ],
      [
        -2445.77880859375,
        -4735.6337890625,
        1052.623779296875
      ],
      [
        -2437.697509765625,
        -4743.71484375,
        1052.623779296875
      ],
      [
        -2423.8173828125,
        -4745.22998046875,
        1052.623779296875
      ],
      [
        -2414.220703125,
        -4735.63330078125,
        1052.623779296875
      ],
      [
        -2407.86474609375,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2417.461181640625,
        -4751.5859375,
        1052.623779296875
      ],
      [
        -2414.220703125,
        -4735.63330078125,
        1052.623779296875
      ],
      [
        -2407.86474609375,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2297.499755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      [
        -2297.499755859375,
        -4440.0,
        1052.623779296875
      ],
      [
        -2302.221923828125,
        -4440.0,
        1052.623779296875
      ],
      [
        -2302.221923828125,
        -4449.7685546875,
        1052.623779296875
      ],
      [
        -2297.499755859375,
        -4440.0,
        1052.623779296875
      ],
      [
        -2302.221923828125,
        -4440.0,
        1052.623779296875
      ],
      [
        -2302.221923828125,
        -4449.7685546875,
        1052.623779296875
      ],
      [
        -2297.499755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      [
        -2621.999755859375,
        -4382.55810546875,
        1029.9490966796875
      ],
      [
        -2642.499755859375,
        -4382.55810546875,
        1029.9490966796875
      ],
      [
        -2642.499755859375,
        -4382.55810546875,
        1019.9489135742188
      ],
      [
        -2621.999755859375,
        -4382.55810546875,
        1019.9490966796875
      ],
      [
        -2642.499755859375,
        -4382.55810546875,
        1021.2237548828125
      ],
      [
        -2642.499755859375,
        -4382.55810546875,
        1019.9489135742188
      ],
      [
        -2621.999755859375,
        -4382.55810546875,
        1019.9490966796875
      ],
      [
        -2621.999755859375,
        -4382.55810546875,
        1021.2237548828125
      ],
      [
        -2639.499755859375,
        -4409.7685546875,
        1021.2237548828125
      ],
      [
        -2622.39453125,
        -4409.7685546875,
        1031.2237548828125
      ],
      [
        -2621.999755859375,
        -4382.55810546875,
        1029.9490966796875
      ],
      [
        -2622.39453125,
        -4399.7685546875,
        1031.2237548828125
      ],
      [
        -2622.39453125,
        -4409.7685546875,
        1031.2237548828125
      ],
      [
        -2639.133544921875,
        -4419.7685546875,
        1032.623779296875
      ],
      [
        -2654.999755859375,
        -4419.7685546875,
        1031.2237548828125
      ],
      [
        -2642.499755859375,
        -4382.55810546875,
        1029.9490966796875
      ],
      [
        -2639.133544921875,
        -4429.7685546875,
        1032.623779296875
      ],
      [
        -2639.133544921875,
        -4419.7685546875,
        1032.623779296875
      ],
      [
        -2639.133544921875,
        -4429.7685546875,
        1032.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      [
        -2633.72509765625,
        -4419.7685546875,
        1052.623779296875
      ],
      [
        -2633.72509765625,
        -4489.7685546875,
        1052.623779296875
      ],
      [
        -2639.575927734375,
        -4419.7685546875,
        1036.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2638.695068359375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2596.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4459.7685546875,
        1042.5999755859375
      ],
      [
        -2635.471435546875,
        -4419.7685546875,
        1036.623779296875
      ],
      [
        -2633.265625,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2629.999755859375,
        -4419.7685546875,
        1032.623779296875
      ],
      [
        -2629.999755859375,
        -4419.7685546875,
        1036.623779296875
      ],
      [
        -2629.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2596.999755859375,
        -4449.7685546875,
        1032.623779296875
      ],
      [
        -2600.0,
        -4449.7685546875,
        1032.623779296875
      ],
      [
        -2600.0,
        -4449.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4459.7685546875,
        1042.5999755859375
      ],
      [
        -2600.0,
        -4459.7685546875,
        1042.5999755859375
      ],
      [
        -2600.0,
        -4459.7685546875,
        1032.623779296875
      ],
      [
        -2596.999755859375,
        -4459.7685546875,
        1032.623779296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2609.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2614.999755859375,
        -4479.2685546875,
        1036.623779296875
      ],
      [
        -2614.999755859375,
        -4470.7685546875,
        1036.623779296875
      ],
      [
        -2614.999755859375,
        -4479.2685546875,
        1036.623779296875
      ],
      [
        -2614.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      [
        -2614.999755859375,
        -4470.7685546875,
        1036.623779296875
      ],
      [
        -2614.999755859375,
        -4470.7685546875,
        1032.623779296875
      ],
      [
        -2606.2724609375,
        -4419.7685546875,
        1052.623779296875
      ],
      [
        -2606.2724609375,
        -4489.7685546875,
        1052.623779296875
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2609.999755859375,
        -4415.91064453125,
        1052.623779296875
      ],
      [
        -2606.2724609375,
        -4419.7685546875,
        1052.623779296875
      ],
      [
        -2633.72509765625,
        -4419.7685546875,
        1052.623779296875
      ],
      [
        -2629.999755859375,
        -4415.91064453125,
        1052.623779296875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1052.623779296875
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1052.623779296875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1052.623779296875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1052.623779296875
      ],
      [
        -2606.2724609375,
        -4489.7685546875,
        1052.623779296875
      ],
      [
        -2609.999755859375,
        -4493.62646484375,
        1052.623779296875
      ],
      [
        -2629.999755859375,
        -4493.62646484375,
        1052.623779296875
      ],
      [
        -2633.72509765625,
        -4489.7685546875,
        1052.623779296875
      ],
      [
        -2629.999755859375,
        -4493.62646484375,
        1052.623779296875
      ],
      [
        -2609.999755859375,
        -4493.62646484375,
        1052.623779296875
      ],
      [
        -2609.999755859375,
        -4415.91064453125,
        1052.623779296875
      ],
      [
        -2629.999755859375,
        -4415.91064453125,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1047.5999755859375
      ],
      [
        -2654.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2596.999755859375,
        -4382.55810546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1047.5999755859375
      ],
      [
        -2596.999755859375,
        -4389.84765625,
        1047.5999755859375
      ],
      [
        -2596.999755859375,
        -4389.84765625,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4389.84765625,
        1047.5999755859375
      ],
      [
        -2537.592529296875,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4415.17578125,
        1042.5999755859375
      ],
      [
        -2487.76953125,
        -4415.17578125,
        1042.5999755859375
      ],
      [
        -2508.40673828125,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2508.40673828125,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2537.592529296875,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2559.712646484375,
        -4429.7685546875,
        1032.623779296875
      ],
      [
        -2558.22998046875,
        -4415.17578125,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4429.7685546875,
        1042.5999755859375
      ],
      [
        -2486.286865234375,
        -4429.7685546875,
        1032.623779296875
      ],
      [
        -2487.76953125,
        -4429.7685546875,
        1042.5999755859375
      ],
      [
        -2487.76953125,
        -4415.17578125,
        1042.5999755859375
      ],
      [
        -2496.65185546875,
        -4453.25,
        1042.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2579.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2522.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4444.361328125,
        1042.5999755859375
      ],
      [
        -2537.5927734375,
        -4464.9990234375,
        1042.5999755859375
      ],
      [
        -2537.5927734375,
        -4464.9990234375,
        1042.5999755859375
      ],
      [
        -2508.40673828125,
        -4464.9990234375,
        1042.5999755859375
      ],
      [
        -2497.298095703125,
        -4455.98681640625,
        1032.623779296875
      ],
      [
        -2508.40673828125,
        -4464.9990234375,
        1042.5999755859375
      ],
      [
        -2496.649658203125,
        -4453.24169921875,
        1042.5999755859375
      ],
      [
        -2569.323486328125,
        -4433.2685546875,
        1042.5999755859375
      ],
      [
        -2559.919677734375,
        -4444.7685546875,
        1032.623779296875
      ],
      [
        -2559.712646484375,
        -4444.7685546875,
        1032.623779296875
      ],
      [
        -2558.22998046875,
        -4433.26806640625,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4444.361328125,
        1042.5999755859375
      ],
      [
        -2579.999755859375,
        -4433.26806640625,
        1042.5999755859375
      ],
      [
        -2538.206787109375,
        -4469.7685546875,
        1042.5999755859375
      ],
      [
        -2538.206787109375,
        -4464.39111328125,
        1042.5999755859375
      ],
      [
        -2486.286865234375,
        -4444.7685546875,
        1032.623779296875
      ],
      [
        -2486.6435546875,
        -4429.7685546875,
        1035.0238037109375
      ],
      [
        -2486.525146484375,
        -4444.876953125,
        1034.226806640625
      ],
      [
        -2489.08056640625,
        -4447.76904296875,
        1032.623779296875
      ],
      [
        -2486.525146484375,
        -4444.876953125,
        1034.226806640625
      ],
      [
        -2487.76953125,
        -4444.361328125,
        1042.5999755859375
      ],
      [
        -2487.76953125,
        -4444.361328125,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2496.327880859375,
        -4451.87841796875,
        1047.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2580.0,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2591.999755859375,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2580.0,
        -4429.7685546875,
        1042.5999755859375
      ],
      [
        -2580.0,
        -4433.2685546875,
        1042.5999755859375
      ],
      [
        -2591.999755859375,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2580.0,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2591.999755859375,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2591.999755859375,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1047.5999755859375
      ],
      [
        -2522.999755859375,
        -4469.7685546875,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1047.5999755859375
      ],
      [
        -2488.512451171875,
        -4415.4833984375,
        1047.5999755859375
      ],
      [
        -2508.714599609375,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2508.714599609375,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2537.28466796875,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2537.284912109375,
        -4464.255859375,
        1047.5999755859375
      ],
      [
        -2508.714599609375,
        -4464.255859375,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4444.0537109375,
        1047.5999755859375
      ],
      [
        -2537.284912109375,
        -4464.255859375,
        1047.5999755859375
      ],
      [
        -2537.28466796875,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4415.4833984375,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4415.4833984375,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4444.0537109375,
        1047.5999755859375
      ],
      [
        -2508.714599609375,
        -4464.255859375,
        1047.5999755859375
      ],
      [
        -2496.324951171875,
        -4451.8662109375,
        1047.5999755859375
      ],
      [
        -2496.649658203125,
        -4453.24169921875,
        1042.5999755859375
      ],
      [
        -2488.512451171875,
        -4418.7861328125,
        1047.5999755859375
      ],
      [
        -2488.512451171875,
        -4415.4833984375,
        1047.5999755859375
      ],
      [
        -2487.76953125,
        -4415.64111328125,
        1042.5999755859375
      ],
      [
        -2556.611328125,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2558.22998046875,
        -4429.7685546875,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4433.2685546875,
        1042.5999755859375
      ],
      [
        -2557.487060546875,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2556.611328125,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2571.772705078125,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2572.8232421875,
        -4429.7685546875,
        1042.5999755859375
      ],
      [
        -2569.32373046875,
        -4433.2685546875,
        1042.5999755859375
      ],
      [
        -2568.27294921875,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2538.206787109375,
        -4464.9990234375,
        1042.5999755859375
      ],
      [
        -2538.206787109375,
        -4463.34375,
        1047.5999755859375
      ],
      [
        -2538.206787109375,
        -4464.255859375,
        1047.5999755859375
      ],
      [
        -2538.206787109375,
        -4469.7685546875,
        1047.5999755859375
      ],
      [
        -2488.512451171875,
        -4444.0537109375,
        1047.5999755859375
      ],
      [
        -2488.512451171875,
        -4444.0537109375,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2496.00244140625,
        -4450.50048828125,
        1052.623779296875
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      [
        -2522.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      [
        -2591.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2555.716552734375,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2555.716552734375,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2591.999755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2556.740478515625,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2556.740478515625,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2557.487060546875,
        -4433.2685546875,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      [
        -2591.999755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2591.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2536.975341796875,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2556.740478515625,
        -4415.79248046875,
        1052.623779296875
      ],
      [
        -2489.259033203125,
        -4415.79248046875,
        1052.623779296875
      ],
      [
        -2509.02392578125,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2509.02392578125,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2536.975341796875,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2556.740478515625,
        -4415.79248046875,
        1052.623779296875
      ],
      [
        -2489.259033203125,
        -4421.947265625,
        1052.623779296875
      ],
      [
        -2489.259033203125,
        -4415.79248046875,
        1052.623779296875
      ],
      [
        -2488.512451171875,
        -4418.7861328125,
        1047.5999755859375
      ],
      [
        -2556.740478515625,
        -4443.74462890625,
        1052.623779296875
      ],
      [
        -2536.9755859375,
        -4463.50927734375,
        1052.623779296875
      ],
      [
        -2536.9755859375,
        -4463.50927734375,
        1052.623779296875
      ],
      [
        -2509.02392578125,
        -4463.50927734375,
        1052.623779296875
      ],
      [
        -2509.02392578125,
        -4463.50927734375,
        1052.623779296875
      ],
      [
        -2495.99853515625,
        -4450.484375,
        1052.623779296875
      ],
      [
        -2496.324951171875,
        -4451.8662109375,
        1047.5999755859375
      ],
      [
        -2556.740478515625,
        -4443.74462890625,
        1052.623779296875
      ],
      [
        -2538.206787109375,
        -4469.7685546875,
        1052.623779296875
      ],
      [
        -2538.206787109375,
        -4462.291015625,
        1052.623779296875
      ],
      [
        -2489.259033203125,
        -4443.74462890625,
        1052.623779296875
      ],
      [
        -2489.259033203125,
        -4443.74462890625,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2354.91015625,
        -4155.29296875,
        1082.623779296875
      ],
      [
        -2354.909423828125,
        -4155.2939453125,
        1185.623779296875
      ],
      [
        -2354.943603515625,
        -4155.27392578125,
        1052.623779296875
      ],
      [
        -2354.943603515625,
        -4155.27392578125,
        1082.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -2714.73876953125,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1129.285400390625
      ],
      [
        -2719.46533203125,
        -4249.7685546875,
        1129.285400390625
      ],
      [
        -2741.692626953125,
        -4249.7685546875,
        1142.4732666015625
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2631.2470703125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1187.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2310.739990234375,
        -4204.36767578125,
        1082.623779296875
      ],
      [
        -2305.4853515625,
        -4210.20361328125,
        1082.623779296875
      ],
      [
        -2750.961181640625,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1185.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1185.623779296875
      ],
      [
        -2750.961181640625,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3502.938720703125,
        -4189.7685546875,
        1302.623779296875
      ],
      [
        -3170.86669921875,
        -3902.59228515625,
        1302.623779296875
      ],
      [
        -3187.577392578125,
        -3973.693603515625,
        1140.39111328125
      ],
      [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.453857421875
      ],
      [
        -3163.276611328125,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3195.9453125,
        -3979.9873046875,
        1102.623779296875
      ],
      [
        -3187.596923828125,
        -3976.37890625,
        1132.7493896484375
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.4541015625
      ],
      [
        -3068.5068359375,
        -3889.566650390625,
        1086.4215087890625
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2724.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2375.5595703125,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2375.614013671875,
        -4696.45263671875,
        1159.5908203125
      ],
      [
        -2363.673828125,
        -4708.23046875,
        1159.5906982421875
      ],
      [
        -2375.5595703125,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2378.821533203125,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2378.821533203125,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2523.17236328125,
        -4693.47509765625,
        1072.623779296875
      ],
      [
        -2528.104248046875,
        -4675.56005859375,
        1072.623779296875
      ],
      [
        -2528.118408203125,
        -4675.5087890625,
        1072.623779296875
      ],
      [
        -2514.890380859375,
        -4662.4599609375,
        1072.623779296875
      ],
      [
        -2528.118408203125,
        -4675.5087890625,
        1072.623779296875
      ],
      [
        -2514.85205078125,
        -4662.42236328125,
        1072.623779296875
      ],
      [
        -2496.611083984375,
        -4667.310546875,
        1072.623779296875
      ],
      [
        -2514.85205078125,
        -4662.42236328125,
        1072.623779296875
      ],
      [
        -2496.559326171875,
        -4667.32421875,
        1072.623779296875
      ],
      [
        -2491.626953125,
        -4685.2392578125,
        1072.623779296875
      ],
      [
        -2496.559326171875,
        -4667.32421875,
        1072.623779296875
      ],
      [
        -2491.61279296875,
        -4685.29052734375,
        1072.623779296875
      ],
      [
        -2504.879150390625,
        -4698.376953125,
        1072.623779296875
      ],
      [
        -2491.61279296875,
        -4685.29052734375,
        1072.623779296875
      ],
      [
        -2484.43994140625,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2484.38525390625,
        -4696.45263671875,
        1159.5908203125
      ],
      [
        -2484.43994140625,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2496.32568359375,
        -4708.23046875,
        1159.5906982421875
      ],
      [
        -2481.17822265625,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2481.17822265625,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2375.5595703125,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2366.39599609375,
        -4813.9921875,
        1159.5906982421875
      ],
      [
        -2378.8212890625,
        -4826.24853515625,
        1159.5968017578125
      ],
      [
        -2375.5595703125,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2363.673828125,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2363.673828125,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      [
        -2523.186767578125,
        -4826.1142578125,
        1072.623779296875
      ],
      [
        -2523.17236328125,
        -4826.06201171875,
        1072.623779296875
      ],
      [
        -2504.931640625,
        -4821.173828125,
        1072.623779296875
      ],
      [
        -2523.17236328125,
        -4826.06201171875,
        1072.623779296875
      ],
      [
        -2504.879150390625,
        -4821.16015625,
        1072.623779296875
      ],
      [
        -2491.650634765625,
        -4834.208984375,
        1072.623779296875
      ],
      [
        -2504.879150390625,
        -4821.16015625,
        1072.623779296875
      ],
      [
        -2504.9052734375,
        -4821.1669921875,
        1072.623779296875
      ],
      [
        -2504.9052734375,
        -4821.1669921875,
        1072.623779296875
      ],
      [
        -2491.61279296875,
        -4834.24658203125,
        1072.623779296875
      ],
      [
        -2496.559326171875,
        -4852.212890625,
        1072.623779296875
      ],
      [
        -2491.61279296875,
        -4834.24658203125,
        1072.623779296875
      ],
      [
        -2484.440185546875,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2484.385498046875,
        -4823.0849609375,
        1159.5908203125
      ],
      [
        -2484.440185546875,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2493.60302734375,
        -4813.99267578125,
        1159.5906982421875
      ],
      [
        -2481.17822265625,
        -4826.24853515625,
        1159.5968017578125
      ],
      [
        -2496.32568359375,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2496.32568359375,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2401.322998046875,
        -4715.9150390625,
        1165.623779296875
      ],
      [
        -2419.999755859375,
        -4738.61767578125,
        1107.7764892578125
      ],
      [
        -2419.999755859375,
        -4741.41259765625,
        1067.623779296875
      ],
      [
        -2417.46142578125,
        -4738.8740234375,
        1067.623779296875
      ],
      [
        -2396.876708984375,
        -4714.5048828125,
        1192.623779296875
      ],
      [
        -2399.380126953125,
        -4712.09326171875,
        1192.623779296875
      ],
      [
        -2400.357666015625,
        -4713.07080078125,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4716.3994140625,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4803.1376953125,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4805.0322265625,
        1192.623779296875
      ],
      [
        -2413.4638671875,
        -4726.1767578125,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4741.623046875,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4716.3994140625,
        1192.623779296875
      ],
      [
        -2400.357666015625,
        -4713.07080078125,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4803.1376953125,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4777.9140625,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4813.62939453125,
        1192.623779296875
      ],
      [
        -2413.4638671875,
        -4726.1767578125,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4732.71240234375,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4777.9140625,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4741.623046875,
        1192.623779296875
      ],
      [
        -2399.380126953125,
        -4712.09326171875,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4714.5048828125,
        1192.623779296875
      ],
      [
        -2393.5830078125,
        -4717.677734375,
        1212.623779296875
      ],
      [
        -2400.089111328125,
        -4711.41015625,
        1212.623779296875
      ],
      [
        -2399.3466796875,
        -4781.8037109375,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4737.7333984375,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4733.75634765625,
        1177.623779296875
      ],
      [
        -2408.069091796875,
        -4721.82568359375,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4730.029296875,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4737.7333984375,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4781.8037109375,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4789.5078125,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4797.71142578125,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4730.029296875,
        1177.623779296875
      ],
      [
        -2407.14111328125,
        -4720.89794921875,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4713.103515625,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4789.5078125,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4808.86083984375,
        1177.623779296875
      ],
      [
        -2408.774658203125,
        -4821.1796875,
        1177.623779296875
      ],
      [
        -2409.3857421875,
        -4807.22705078125,
        1177.623779296875
      ],
      [
        -2408.774658203125,
        -4823.16455078125,
        1177.623779296875
      ],
      [
        -2408.774658203125,
        -4821.1796875,
        1177.623779296875
      ],
      [
        -2401.322998046875,
        -4715.9150390625,
        1165.623779296875
      ],
      [
        -2401.121337890625,
        -4715.65087890625,
        1166.8472900390625
      ],
      [
        -2409.3857421875,
        -4807.22705078125,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4770.48974609375,
        1067.623779296875
      ],
      [
        -2419.999755859375,
        -4770.48974609375,
        1052.623779296875
      ],
      [
        -2419.931640625,
        -4770.421875,
        1052.623779296875
      ],
      [
        -2419.999755859375,
        -4778.12451171875,
        1067.623779296875
      ],
      [
        -2417.46142578125,
        -4780.66259765625,
        1067.623779296875
      ],
      [
        -2419.931640625,
        -4778.1923828125,
        1052.623779296875
      ],
      [
        -2419.999755859375,
        -4778.12451171875,
        1052.623779296875
      ],
      [
        -2407.87939453125,
        -4721.63623046875,
        1177.623779296875
      ],
      [
        -2407.14111328125,
        -4720.89794921875,
        1177.623779296875
      ],
      [
        -2401.121337890625,
        -4715.65087890625,
        1166.8472900390625
      ],
      [
        -2401.10498046875,
        -4715.60498046875,
        1166.9468994140625
      ],
      [
        -2419.999755859375,
        -4797.71142578125,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4812.27099609375,
        1181.2305908203125
      ],
      [
        -2407.8486328125,
        -4821.0048828125,
        1183.3941650390625
      ],
      [
        -2419.999755859375,
        -4812.27099609375,
        1181.2305908203125
      ],
      [
        -2419.999755859375,
        -4813.62939453125,
        1192.623779296875
      ],
      [
        -2407.8486328125,
        -4721.6015625,
        1177.6793212890625
      ],
      [
        -2419.999755859375,
        -4738.61767578125,
        1107.7764892578125
      ],
      [
        -2419.999755859375,
        -4729.091796875,
        1165.623779296875
      ],
      [
        -2413.039794921875,
        -4724.6455078125,
        1192.623779296875
      ],
      [
        -2411.932861328125,
        -4724.6455078125,
        1192.623779296875
      ],
      [
        -2413.039794921875,
        -4724.6455078125,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4727.11572265625,
        1177.623779296875
      ],
      [
        -2413.359130859375,
        -4727.11572265625,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4729.091796875,
        1165.623779296875
      ],
      [
        -2419.999755859375,
        -4697.26611328125,
        1181.2305908203125
      ],
      [
        -2419.999755859375,
        -4703.9345703125,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4703.9345703125,
        1212.623779296875
      ],
      [
        -2402.9931640625,
        -4708.6123046875,
        1192.623779296875
      ],
      [
        -2402.992919921875,
        -4710.55078125,
        1192.623779296875
      ],
      [
        -2402.992919921875,
        -4715.7060546875,
        1192.623779296875
      ],
      [
        -2402.992919921875,
        -4710.55078125,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4705.90771484375,
        1192.623779296875
      ],
      [
        -2402.9931640625,
        -4708.6123046875,
        1192.623779296875
      ],
      [
        -2399.657470703125,
        -4711.826171875,
        1200.450439453125
      ],
      [
        -2407.8486328125,
        -4703.9345703125,
        1181.2305908203125
      ],
      [
        -2419.999755859375,
        -4721.82568359375,
        1177.623779296875
      ],
      [
        -2409.3857421875,
        -4721.82568359375,
        1177.623779296875
      ],
      [
        -2409.3857421875,
        -4723.14208984375,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4703.9345703125,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4697.26611328125,
        1181.2305908203125
      ],
      [
        -2399.687744140625,
        -4711.796875,
        1192.623779296875
      ],
      [
        -2399.3935546875,
        -4712.080078125,
        1193.0045166015625
      ],
      [
        -2399.687744140625,
        -4711.796875,
        1192.623779296875
      ],
      [
        -2399.603759765625,
        -4712.31689453125,
        1192.623779296875
      ],
      [
        -2399.3466796875,
        -4710.67626953125,
        1177.623779296875
      ],
      [
        -2403.510986328125,
        -4717.71484375,
        1171.20263671875
      ],
      [
        -2399.978759765625,
        -4712.4482421875,
        1173.7852783203125
      ],
      [
        -2399.3466796875,
        -4710.67626953125,
        1177.623779296875
      ],
      [
        -2417.46142578125,
        -4738.8740234375,
        1067.623779296875
      ],
      [
        -2419.999755859375,
        -4741.41259765625,
        1067.623779296875
      ],
      [
        -2419.999755859375,
        -4741.412109375,
        1052.623779296875
      ],
      [
        -2419.931640625,
        -4741.34423828125,
        1052.623779296875
      ],
      [
        -2384.96484375,
        -4791.74755859375,
        1192.623779296875
      ],
      [
        -2384.043212890625,
        -4792.6689453125,
        1192.623779296875
      ],
      [
        -2384.96484375,
        -4791.74755859375,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4779.83544921875,
        1192.623779296875
      ],
      [
        -2399.3466796875,
        -4778.40966796875,
        1177.623779296875
      ],
      [
        -2394.36865234375,
        -4783.3876953125,
        1177.623779296875
      ],
      [
        -2390.90478515625,
        -4786.85107421875,
        1177.623779296875
      ],
      [
        -2385.204345703125,
        -4792.5517578125,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4806.693359375,
        1177.623779296875
      ],
      [
        -2417.983154296875,
        -4768.47314453125,
        1052.623779296875
      ],
      [
        -2390.90478515625,
        -4786.85107421875,
        1177.623779296875
      ],
      [
        -2394.36865234375,
        -4783.3876953125,
        1177.623779296875
      ],
      [
        -2393.025390625,
        -4784.70458984375,
        1178.0010986328125
      ],
      [
        -2384.043212890625,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2383.334228515625,
        -4727.55126953125,
        1212.623779296875
      ],
      [
        -2384.043212890625,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2384.964599609375,
        -4727.7900390625,
        1192.623779296875
      ],
      [
        -2384.964599609375,
        -4727.7900390625,
        1192.623779296875
      ],
      [
        -2396.876708984375,
        -4739.7021484375,
        1192.623779296875
      ],
      [
        -2399.3466796875,
        -4741.1279296875,
        1177.623779296875
      ],
      [
        -2394.36865234375,
        -4736.1494140625,
        1177.623779296875
      ],
      [
        -2399.3466796875,
        -4713.103515625,
        1177.623779296875
      ],
      [
        -2399.216796875,
        -4712.9736328125,
        1177.623779296875
      ],
      [
        -2385.20458984375,
        -4726.98583984375,
        1177.623779296875
      ],
      [
        -2390.90478515625,
        -4732.685546875,
        1177.623779296875
      ],
      [
        -2413.698486328125,
        -4736.1552734375,
        1052.623779296875
      ],
      [
        -2408.38671875,
        -4741.46728515625,
        1052.623779296875
      ],
      [
        -2393.2783203125,
        -4735.05908203125,
        1177.623779296875
      ],
      [
        -2401.10498046875,
        -4715.60546875,
        1166.9461669921875
      ],
      [
        -2394.36865234375,
        -4736.1494140625,
        1177.623779296875
      ],
      [
        -2393.025390625,
        -4734.83251953125,
        1178.0010986328125
      ],
      [
        -2393.025390625,
        -4734.83251953125,
        1178.0010986328125
      ],
      [
        -2375.77587890625,
        -4783.3193359375,
        1178.68896484375
      ],
      [
        -2375.77587890625,
        -4736.2177734375,
        1178.6890869140625
      ],
      [
        -2375.77587890625,
        -4736.2177734375,
        1178.6890869140625
      ],
      [
        -2375.77587890625,
        -4736.03662109375,
        1179.080322265625
      ],
      [
        -2376.30419921875,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2383.8662109375,
        -4791.21337890625,
        1177.623779296875
      ],
      [
        -2389.117919921875,
        -4789.0390625,
        1171.8658447265625
      ],
      [
        -2384.8544921875,
        -4791.27197265625,
        1174.046142578125
      ],
      [
        -2383.8662109375,
        -4791.21337890625,
        1177.623779296875
      ],
      [
        -2376.30419921875,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2376.01904296875,
        -4734.83251953125,
        1182.77783203125
      ],
      [
        -2383.866455078125,
        -4728.32373046875,
        1177.623779296875
      ],
      [
        -2375.77587890625,
        -4734.83251953125,
        1183.71435546875
      ],
      [
        -2377.599365234375,
        -4786.46142578125,
        1192.623779296875
      ],
      [
        -2377.599365234375,
        -4733.07568359375,
        1192.623779296875
      ],
      [
        -2375.77587890625,
        -4734.83251953125,
        1201.1968994140625
      ],
      [
        -2377.599365234375,
        -4733.07568359375,
        1192.623779296875
      ],
      [
        -2374.21826171875,
        -4784.70458984375,
        1189.708984375
      ],
      [
        -2374.21875,
        -4734.83251953125,
        1189.7099609375
      ],
      [
        -2369.927490234375,
        -4741.20947265625,
        1181.6800537109375
      ],
      [
        -2369.927490234375,
        -4778.32861328125,
        1181.6800537109375
      ],
      [
        -2375.703125,
        -4783.33642578125,
        1178.7261962890625
      ],
      [
        -2369.927490234375,
        -4778.328125,
        1181.6800537109375
      ],
      [
        -2369.927490234375,
        -4741.20947265625,
        1181.6800537109375
      ],
      [
        -2375.703857421875,
        -4736.20068359375,
        1178.7259521484375
      ],
      [
        -2374.21875,
        -4734.83251953125,
        1189.7099609375
      ],
      [
        -2375.703857421875,
        -4736.20068359375,
        1178.7259521484375
      ],
      [
        -2379.178955078125,
        -4692.93603515625,
        1177.623779296875
      ],
      [
        -2378.547607421875,
        -4693.55908203125,
        1159.596435546875
      ],
      [
        -2445.686279296875,
        -4769.7685546875,
        1086.739013671875
      ],
      [
        -2444.355712890625,
        -4769.7685546875,
        1067.623779296875
      ],
      [
        -2460.29638671875,
        -4777.00927734375,
        1192.623779296875
      ],
      [
        -2475.03466796875,
        -4791.74755859375,
        1192.623779296875
      ],
      [
        -2460.29638671875,
        -4777.00927734375,
        1192.623779296875
      ],
      [
        -2453.055908203125,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2465.630859375,
        -4783.3876953125,
        1177.623779296875
      ],
      [
        -2452.011962890625,
        -4769.7685546875,
        1177.623779296875
      ],
      [
        -2459.715087890625,
        -4807.63134765625,
        1177.623779296875
      ],
      [
        -2474.794677734375,
        -4792.55126953125,
        1177.623779296875
      ],
      [
        -2469.09375,
        -4786.8505859375,
        1177.623779296875
      ],
      [
        -2440.720947265625,
        -4769.7685546875,
        1067.623779296875
      ],
      [
        -2440.720947265625,
        -4769.7685546875,
        1052.623779296875
      ],
      [
        -2469.09375,
        -4786.8505859375,
        1177.623779296875
      ],
      [
        -2452.15087890625,
        -4816.1318359375,
        1181.2305908203125
      ],
      [
        -2452.15087890625,
        -4816.3974609375,
        1182.2528076171875
      ],
      [
        -2452.15087890625,
        -4818.01904296875,
        1188.495361328125
      ],
      [
        -2465.630859375,
        -4783.3876953125,
        1177.623779296875
      ],
      [
        -2466.97412109375,
        -4784.70458984375,
        1178.0010986328125
      ],
      [
        -2445.686279296875,
        -4769.7685546875,
        1086.739013671875
      ],
      [
        -2458.6767578125,
        -4769.7685546875,
        1165.623779296875
      ],
      [
        -2460.653076171875,
        -4769.7685546875,
        1177.623779296875
      ],
      [
        -2460.653076171875,
        -4778.40966796875,
        1177.623779296875
      ],
      [
        -2463.123046875,
        -4777.9931640625,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4779.8359375,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4777.9931640625,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2484.29638671875,
        -4783.33642578125,
        1178.7261962890625
      ],
      [
        -2458.6767578125,
        -4769.7685546875,
        1165.623779296875
      ],
      [
        -2490.072021484375,
        -4769.7685546875,
        1181.6800537109375
      ],
      [
        -2490.072021484375,
        -4778.328125,
        1181.6800537109375
      ],
      [
        -2484.2236328125,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2484.2236328125,
        -4769.7685546875,
        1212.623779296875
      ],
      [
        -2482.39990234375,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2465.630859375,
        -4769.7685546875,
        1177.623779296875
      ],
      [
        -2480.072021484375,
        -4769.7685546875,
        1181.6800537109375
      ],
      [
        -2470.88134765625,
        -4789.03857421875,
        1171.865478515625
      ],
      [
        -2476.133056640625,
        -4791.212890625,
        1177.623779296875
      ],
      [
        -2475.14501953125,
        -4791.27197265625,
        1174.0460205078125
      ],
      [
        -2476.133056640625,
        -4791.212890625,
        1177.623779296875
      ],
      [
        -2480.072021484375,
        -4769.7685546875,
        1181.6800537109375
      ],
      [
        -2482.39990234375,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2465.630859375,
        -4769.7685546875,
        1177.623779296875
      ],
      [
        -2485.781005859375,
        -4784.70458984375,
        1189.709716796875
      ],
      [
        -2490.072021484375,
        -4778.328125,
        1181.6800537109375
      ],
      [
        -2490.072021484375,
        -4769.7685546875,
        1181.6800537109375
      ],
      [
        -2484.2236328125,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2444.355712890625,
        -4769.7685546875,
        1067.623779296875
      ],
      [
        -2444.355712890625,
        -4769.7685546875,
        1052.623779296875
      ],
      [
        -2439.499755859375,
        -4762.28076171875,
        1177.623779296875
      ],
      [
        -2465.630859375,
        -4736.1494140625,
        1177.623779296875
      ],
      [
        -2423.987060546875,
        -4749.7685546875,
        1177.623779296875
      ],
      [
        -2451.930419921875,
        -4721.82568359375,
        1177.623779296875
      ],
      [
        -2469.094482421875,
        -4732.68603515625,
        1177.623779296875
      ],
      [
        -2474.794921875,
        -4726.9853515625,
        1177.623779296875
      ],
      [
        -2460.782958984375,
        -4712.9736328125,
        1177.623779296875
      ],
      [
        -2452.85888671875,
        -4720.89697265625,
        1177.623779296875
      ],
      [
        -2451.613037109375,
        -4741.4677734375,
        1052.623779296875
      ],
      [
        -2446.300537109375,
        -4736.1552734375,
        1052.623779296875
      ],
      [
        -2436.7041015625,
        -4745.751953125,
        1052.623779296875
      ],
      [
        -2442.016357421875,
        -4751.06396484375,
        1052.623779296875
      ],
      [
        -2466.721435546875,
        -4735.05908203125,
        1177.623779296875
      ],
      [
        -2431.6435546875,
        -4749.7685546875,
        1067.623779296875
      ],
      [
        -2452.1201171875,
        -4721.6357421875,
        1177.623779296875
      ],
      [
        -2452.85888671875,
        -4720.89697265625,
        1177.623779296875
      ],
      [
        -2475.03466796875,
        -4727.78955078125,
        1192.623779296875
      ],
      [
        -2459.6416015625,
        -4713.0703125,
        1192.623779296875
      ],
      [
        -2460.619384765625,
        -4712.0927734375,
        1192.623779296875
      ],
      [
        -2475.95654296875,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2459.6416015625,
        -4713.0703125,
        1192.623779296875
      ],
      [
        -2475.03466796875,
        -4727.78955078125,
        1192.623779296875
      ],
      [
        -2460.29638671875,
        -4742.52783203125,
        1192.623779296875
      ],
      [
        -2446.2109375,
        -4726.5009765625,
        1192.623779296875
      ],
      [
        -2446.2109375,
        -4726.5009765625,
        1192.623779296875
      ],
      [
        -2422.943115234375,
        -4749.7685546875,
        1192.623779296875
      ],
      [
        -2439.499755859375,
        -4763.3251953125,
        1192.623779296875
      ],
      [
        -2460.297119140625,
        -4742.52783203125,
        1192.623779296875
      ],
      [
        -2475.95654296875,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2460.619384765625,
        -4712.0927734375,
        1192.623779296875
      ],
      [
        -2459.910400390625,
        -4711.40966796875,
        1212.623779296875
      ],
      [
        -2476.665771484375,
        -4727.55126953125,
        1212.623779296875
      ],
      [
        -2423.987548828125,
        -4749.7685546875,
        1177.623779296875
      ],
      [
        -2422.943115234375,
        -4749.7685546875,
        1192.623779296875
      ],
      [
        -2439.499755859375,
        -4762.28076171875,
        1177.623779296875
      ],
      [
        -2439.499755859375,
        -4763.3251953125,
        1192.623779296875
      ],
      [
        -2465.630859375,
        -4736.1494140625,
        1177.623779296875
      ],
      [
        -2466.974365234375,
        -4734.83251953125,
        1178.0010986328125
      ],
      [
        -2466.974365234375,
        -4734.83251953125,
        1178.0010986328125
      ],
      [
        -2452.15087890625,
        -4721.60107421875,
        1177.6793212890625
      ],
      [
        -2448.066162109375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2446.74609375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2446.74609375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2419.999755859375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2446.640380859375,
        -4727.11572265625,
        1177.623779296875
      ],
      [
        -2419.999755859375,
        -4727.11572265625,
        1177.623779296875
      ],
      [
        -2450.96484375,
        -4702.94189453125,
        1178.447265625
      ],
      [
        -2446.011962890625,
        -4697.26611328125,
        1181.2305908203125
      ],
      [
        -2459.715087890625,
        -4711.90576171875,
        1177.623779296875
      ],
      [
        -2450.61376953125,
        -4704.62109375,
        1177.623779296875
      ],
      [
        -2450.61376953125,
        -4712.31005859375,
        1177.623779296875
      ],
      [
        -2452.1201171875,
        -4721.6357421875,
        1177.623779296875
      ],
      [
        -2450.61376953125,
        -4712.31005859375,
        1177.623779296875
      ],
      [
        -2456.48828125,
        -4717.71484375,
        1171.2027587890625
      ],
      [
        -2459.715087890625,
        -4711.90576171875,
        1177.623779296875
      ],
      [
        -2459.690185546875,
        -4712.94091796875,
        1173.5438232421875
      ],
      [
        -2452.15087890625,
        -4703.9345703125,
        1181.2305908203125
      ],
      [
        -2450.75732421875,
        -4703.9345703125,
        1177.96044921875
      ],
      [
        -2452.15087890625,
        -4703.9345703125,
        1181.2305908203125
      ],
      [
        -2452.15087890625,
        -4701.51806640625,
        1188.4951171875
      ],
      [
        -2446.011962890625,
        -4697.26611328125,
        1181.2305908203125
      ],
      [
        -2452.15087890625,
        -4701.51806640625,
        1188.4951171875
      ],
      [
        -2452.15087890625,
        -4703.40478515625,
        1181.2305908203125
      ],
      [
        -2450.96484375,
        -4702.94189453125,
        1178.447265625
      ],
      [
        -2452.15087890625,
        -4703.40478515625,
        1181.2305908203125
      ],
      [
        -2494.9287109375,
        -4706.85205078125,
        1177.623779296875
      ],
      [
        -2494.296875,
        -4706.22900390625,
        1159.5906982421875
      ],
      [
        -2463.123046875,
        -4741.5439453125,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4739.701171875,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4769.7685546875,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4741.5439453125,
        1192.623779296875
      ],
      [
        -2460.653076171875,
        -4769.7685546875,
        1177.623779296875
      ],
      [
        -2460.653076171875,
        -4741.12744140625,
        1177.623779296875
      ],
      [
        -2440.720947265625,
        -4769.7685546875,
        1056.587158203125
      ],
      [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2484.2236328125,
        -4736.2177734375,
        1178.6890869140625
      ],
      [
        -2484.2236328125,
        -4734.83251953125,
        1182.84619140625
      ],
      [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2482.140869140625,
        -4724.6005859375,
        1177.623779296875
      ],
      [
        -2482.140869140625,
        -4719.6396484375,
        1177.623779296875
      ],
      [
        -2442.016357421875,
        -4768.47314453125,
        1052.623779296875
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1052.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      [
        -2899.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      [
        -2920.0,
        -4609.7685546875,
        1112.623779296875
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1072.623779296875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4909.00634765625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2303.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      [
        -2303.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      [
        -2299.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      [
        -2299.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      [
        -2899.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      [
        -2920.0,
        -4605.7685546875,
        1112.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2389.999755859375,
        -4319.7685546875,
        1077.623779296875
      ],
      [
        -2389.999755859375,
        -4569.7998046875,
        1077.623779296875
      ],
      [
        -2214.77978515625,
        -4559.7685546875,
        1077.623779296875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1052.623779296875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1052.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1077.623779296875
      ],
      [
        -2214.77978515625,
        -4432.9013671875,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1052.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      [
        -2300.825927734375,
        -4449.7685546875,
        1060.161865234375
      ],
      [
        -2283.75439453125,
        -4449.7685546875,
        1056.7474365234375
      ],
      [
        -2283.75439453125,
        -4449.7685546875,
        1056.7474365234375
      ],
      [
        -2294.499755859375,
        -4440.0,
        1053.5238037109375
      ],
      [
        -2301.785400390625,
        -4440.0,
        1054.98095703125
      ],
      [
        -2300.825927734375,
        -4449.7685546875,
        1060.161865234375
      ],
      [
        -2294.49951171875,
        -4440.0,
        1053.5238037109375
      ],
      [
        -2301.785400390625,
        -4440.0,
        1054.98095703125
      ],
      [
        -2300.743408203125,
        -4449.7685546875,
        1060.608154296875
      ],
      [
        -2282.262451171875,
        -4449.7685546875,
        1057.835693359375
      ],
      [
        -2282.499755859375,
        -4448.4091796875,
        1057.123779296875
      ],
      [
        -2292.777587890625,
        -4440.0,
        1054.0404052734375
      ],
      [
        -2301.71142578125,
        -4440.0,
        1055.3804931640625
      ],
      [
        -2300.743408203125,
        -4449.7685546875,
        1060.608154296875
      ],
      [
        -2292.777099609375,
        -4440.0,
        1054.04052734375
      ],
      [
        -2301.71142578125,
        -4440.0,
        1055.3804931640625
      ],
      [
        -2282.262451171875,
        -4449.7685546875,
        1057.835693359375
      ],
      [
        -2282.499755859375,
        -4448.4091796875,
        1057.123779296875
      ],
      [
        -2282.0458984375,
        -4449.7685546875,
        1058.4854736328125
      ],
      [
        -2285.462890625,
        -4440.0,
        1056.23486328125
      ],
      [
        -2300.59521484375,
        -4440.0,
        1061.408447265625
      ],
      [
        -2282.499755859375,
        -4445.4345703125,
        1057.123779296875
      ],
      [
        -2285.462890625,
        -4440.0,
        1056.23486328125
      ],
      [
        -2300.59521484375,
        -4440.0,
        1061.408447265625
      ],
      [
        -2282.0458984375,
        -4449.7685546875,
        1058.4854736328125
      ],
      [
        -2282.499755859375,
        -4445.4345703125,
        1057.123779296875
      ],
      [
        -2287.54931640625,
        -4462.3154296875,
        1067.9439697265625
      ],
      [
        -2281.078857421875,
        -4449.7685546875,
        1061.3863525390625
      ],
      [
        -2282.265380859375,
        -4449.7685546875,
        1061.963623046875
      ],
      [
        -2286.227783203125,
        -4440.0,
        1058.5189208984375
      ],
      [
        -2283.031982421875,
        -4440.0,
        1056.964111328125
      ],
      [
        -2296.76806640625,
        -4440.0,
        1060.0999755859375
      ],
      [
        -2281.078857421875,
        -4449.7685546875,
        1061.3863525390625
      ],
      [
        -2282.499755859375,
        -4440.76123046875,
        1057.123779296875
      ],
      [
        -2282.499755859375,
        -4440.76123046875,
        1057.123779296875
      ],
      [
        -2283.031982421875,
        -4440.0,
        1056.964111328125
      ],
      [
        -2292.905029296875,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2284.123046875,
        -4449.7685546875,
        1062.867431640625
      ],
      [
        -2287.54931640625,
        -4462.3154296875,
        1067.9439697265625
      ],
      [
        -2292.905029296875,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2299.999755859375,
        -4445.71435546875,
        1064.623779296875
      ],
      [
        -2290.94140625,
        -4440.0,
        1060.8121337890625
      ],
      [
        -2300.35693359375,
        -4440.0,
        1062.6951904296875
      ],
      [
        -2299.999755859375,
        -4445.71435546875,
        1064.623779296875
      ],
      [
        -2300.35693359375,
        -4440.0,
        1062.6951904296875
      ],
      [
        -2310.0,
        -4435.251953125,
        1067.47265625
      ],
      [
        -2317.990478515625,
        -4433.26123046875,
        1070.2652587890625
      ],
      [
        -2305.584228515625,
        -4435.583984375,
        1065.5069580078125
      ],
      [
        -2303.66162109375,
        -4436.8310546875,
        1065.257568359375
      ],
      [
        -2310.0,
        -4435.251953125,
        1067.47265625
      ],
      [
        -2305.584228515625,
        -4435.583984375,
        1065.5069580078125
      ],
      [
        -2287.7333984375,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2287.7333984375,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2293.462890625,
        -4440.0,
        1062.038818359375
      ],
      [
        -2297.0751953125,
        -4440.0,
        1062.038818359375
      ],
      [
        -2298.7763671875,
        -4440.0,
        1064.623779296875
      ],
      [
        -2298.776611328125,
        -4440.0,
        1064.623779296875
      ],
      [
        -2324.739013671875,
        -4431.57958984375,
        1072.623779296875
      ],
      [
        -2370.47412109375,
        -4400.0,
        1077.5052490234375
      ],
      [
        -2350.0,
        -4418.84912109375,
        1077.9114990234375
      ],
      [
        -2370.47412109375,
        -4400.0,
        1077.5052490234375
      ],
      [
        -2389.999755859375,
        -4373.85302734375,
        1072.623779296875
      ],
      [
        -2338.220947265625,
        -4428.220703125,
        1077.33544921875
      ],
      [
        -2350.0,
        -4418.84912109375,
        1077.9114990234375
      ],
      [
        -2338.220947265625,
        -4428.220703125,
        1077.33544921875
      ],
      [
        -2280.696533203125,
        -4440.0,
        1062.533935546875
      ],
      [
        -2280.696533203125,
        -4440.0,
        1062.533935546875
      ],
      [
        -2290.53125,
        -4440.0,
        1060.6124267578125
      ],
      [
        -2285.517578125,
        -4449.7685546875,
        1063.5457763671875
      ],
      [
        -2281.0439453125,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2283.230712890625,
        -4440.0,
        1062.038818359375
      ],
      [
        -2291.102783203125,
        -4440.0,
        1060.8905029296875
      ],
      [
        -2284.612060546875,
        -4440.0,
        1062.038818359375
      ],
      [
        -2281.0439453125,
        -4449.7685546875,
        1064.623779296875
      ],
      [
        -2285.949462890625,
        -4449.7685546875,
        1063.7559814453125
      ],
      [
        -2279.999755859375,
        -4448.8447265625,
        1064.623779296875
      ],
      [
        -2279.999755859375,
        -4448.8447265625,
        1064.623779296875
      ],
      [
        -2280.62646484375,
        -4440.0,
        1062.743896484375
      ],
      [
        -2280.62646484375,
        -4440.0,
        1062.743896484375
      ],
      [
        -2280.595703125,
        -4440.0,
        1062.836181640625
      ],
      [
        -2291.366943359375,
        -4440.0,
        1061.01904296875
      ],
      [
        -2280.60400390625,
        -4440.31689453125,
        1062.811279296875
      ],
      [
        -2280.595703125,
        -4440.0,
        1062.836181640625
      ],
      [
        -2280.303466796875,
        -4444.55712890625,
        1063.71240234375
      ],
      [
        -2310.0,
        -4426.66650390625,
        1072.623779296875
      ],
      [
        -2310.0,
        -4426.66650390625,
        1072.623779296875
      ],
      [
        -2324.7392578125,
        -4431.57958984375,
        1072.623779296875
      ],
      [
        -2274.318603515625,
        -4329.7685546875,
        1072.623779296875
      ],
      [
        -2350.0,
        -4352.87744140625,
        1080.267822265625
      ],
      [
        -2350.0,
        -4352.87744140625,
        1080.267822265625
      ],
      [
        -2369.99853515625,
        -4360.0,
        1077.6241455078125
      ],
      [
        -2389.999755859375,
        -4548.92236328125,
        1072.623779296875
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1187.623779296875
      ],
      [
        -2269.969970703125,
        -4307.7685546875,
        1187.623779296875
      ],
      [
        -2269.969970703125,
        -4307.7685546875,
        1052.623779296875
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1052.623779296875
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1104.3970947265625
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1116.3970947265625
      ],
      [
        -2307.839599609375,
        -4295.1162109375,
        1105.6470947265625
      ],
      [
        -2307.839599609375,
        -4295.1162109375,
        1117.6470947265625
      ],
      [
        -2307.839599609375,
        -4295.1162109375,
        1117.6470947265625
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1116.3970947265625
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1104.3970947265625
      ],
      [
        -2307.839599609375,
        -4295.1162109375,
        1105.6470947265625
      ],
      [
        -2339.999755859375,
        -4319.7685546875,
        1075.123779296875
      ],
      [
        -2339.999755859375,
        -4314.7685546875,
        1075.123779296875
      ],
      [
        -2339.999755859375,
        -4314.7685546875,
        1075.123779296875
      ],
      [
        -2359.999755859375,
        -4319.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1076.48388671875
      ],
      [
        -2624.999755859375,
        -4515.96875,
        1076.48388671875
      ],
      [
        -2624.999755859375,
        -4515.96875,
        1076.48388671875
      ],
      [
        -2624.999755859375,
        -4525.96875,
        1076.48388671875
      ],
      [
        -2625.0,
        -4429.7685546875,
        1076.483154296875
      ],
      [
        -2625.0,
        -4439.7685546875,
        1076.483154296875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1076.48388671875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1076.484130859375
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1076.484130859375
      ],
      [
        -2619.09765625,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2619.09765625,
        -4429.7685546875,
        1092.623779296875
      ],
      [
        -2625.0,
        -4429.7685546875,
        1076.4830322265625
      ],
      [
        -2625.0,
        -4439.7685546875,
        1076.4830322265625
      ],
      [
        -2619.09765625,
        -4439.7685546875,
        1092.623779296875
      ],
      [
        -2623.1201171875,
        -4509.7685546875,
        1081.6239013671875
      ],
      [
        -2619.09765625,
        -4509.7685546875,
        1092.623779296875
      ],
      [
        -2623.1201171875,
        -4509.7685546875,
        1081.6239013671875
      ],
      [
        -2623.1201171875,
        -4515.96875,
        1081.6239013671875
      ],
      [
        -2623.1201171875,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2623.1201171875,
        -4515.96875,
        1081.6239013671875
      ],
      [
        -2624.999755859375,
        -4525.96875,
        1076.48388671875
      ],
      [
        -2623.1201171875,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1076.4443359375
      ],
      [
        -2614.999755859375,
        -4515.96875,
        1076.4443359375
      ],
      [
        -2615.0,
        -4439.7685546875,
        1076.4451904296875
      ],
      [
        -2615.0,
        -4429.7685546875,
        1076.4451904296875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1076.4443359375
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1076.4443359375
      ],
      [
        -2615.0,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2613.23388671875,
        -4515.96875,
        1071.6239013671875
      ],
      [
        -2613.23388671875,
        -4525.96875,
        1071.6239013671875
      ],
      [
        -2613.23388671875,
        -4525.96875,
        1071.6239013671875
      ],
      [
        -2615.0,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2615.0,
        -4525.96875,
        1076.4449462890625
      ],
      [
        -2614.999755859375,
        -4515.96875,
        1076.4443359375
      ],
      [
        -2613.23388671875,
        -4515.96875,
        1071.6239013671875
      ],
      [
        -2620.01171875,
        -4499.7685546875,
        1090.1243896484375
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1076.4443359375
      ],
      [
        -2615.0,
        -4429.7685546875,
        1076.4449462890625
      ],
      [
        -2620.01171875,
        -4429.7685546875,
        1090.1243896484375
      ],
      [
        -2615.0,
        -4439.7685546875,
        1076.4449462890625
      ],
      [
        -2620.01171875,
        -4439.7685546875,
        1090.1243896484375
      ],
      [
        -2616.897216796875,
        -4509.7685546875,
        1081.6239013671875
      ],
      [
        -2620.01171875,
        -4509.7685546875,
        1090.1243896484375
      ],
      [
        -2616.897216796875,
        -4509.7685546875,
        1081.6239013671875
      ],
      [
        -2616.897216796875,
        -4515.96875,
        1081.6239013671875
      ],
      [
        -2616.897216796875,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2616.897216796875,
        -4515.96875,
        1081.6239013671875
      ],
      [
        -2616.897216796875,
        -4525.96875,
        1081.6239013671875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1062.69482421875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1058.5526123046875
      ],
      [
        -2625.0,
        -4429.7685546875,
        1062.6949462890625
      ],
      [
        -2625.0,
        -4439.7685546875,
        1062.6949462890625
      ],
      [
        -2625.0,
        -4429.7685546875,
        1062.6949462890625
      ],
      [
        -2625.0,
        -4439.7685546875,
        1062.6949462890625
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1058.5526123046875
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1058.5526123046875
      ],
      [
        -2614.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      [
        -2614.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      [
        -2614.999755859375,
        -4525.96875,
        1076.4443359375
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1062.69482421875
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1062.69482421875
      ],
      [
        -2614.999755859375,
        -4509.7685546875,
        1058.5526123046875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1062.69482421875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1058.5528564453125
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1058.5528564453125
      ],
      [
        -2624.999755859375,
        -4499.7685546875,
        1058.5528564453125
      ],
      [
        -2620.0,
        -4499.7685546875,
        1060.6239013671875
      ],
      [
        -2620.0,
        -4509.7685546875,
        1060.6239013671875
      ],
      [
        -2624.999755859375,
        -4509.7685546875,
        1058.5528564453125
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1052.695068359375
      ],
      [
        -2614.999755859375,
        -4499.83984375,
        1052.623779296875
      ],
      [
        -2614.999755859375,
        -4499.7685546875,
        1052.695068359375
      ],
      [
        -2615.171630859375,
        -4499.7685546875,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2639.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      [
        -2639.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1064.623779296875
      ],
      [
        -2639.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      [
        -2495.80810546875,
        -4449.677734375,
        1055.623779296875
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1055.623779296875
      ],
      [
        -2570.999755859375,
        -4469.7685546875,
        1055.623779296875
      ],
      [
        -2522.999755859375,
        -4469.7685546875,
        1055.623779296875
      ],
      [
        -2556.294677734375,
        -4415.97705078125,
        1055.623779296875
      ],
      [
        -2555.551513671875,
        -4416.28515625,
        1060.623779296875
      ],
      [
        -2555.551513671875,
        -4443.251953125,
        1060.623779296875
      ],
      [
        -2556.294677734375,
        -4443.56005859375,
        1055.623779296875
      ],
      [
        -2536.791015625,
        -4463.0634765625,
        1055.623779296875
      ],
      [
        -2536.483154296875,
        -4462.3203125,
        1060.623779296875
      ],
      [
        -2509.516357421875,
        -4462.3203125,
        1060.623779296875
      ],
      [
        -2509.20849609375,
        -4463.0634765625,
        1055.623779296875
      ],
      [
        -2556.294677734375,
        -4443.56005859375,
        1055.623779296875
      ],
      [
        -2555.551513671875,
        -4443.251953125,
        1060.623779296875
      ],
      [
        -2536.483154296875,
        -4462.3203125,
        1060.623779296875
      ],
      [
        -2536.791015625,
        -4463.0634765625,
        1055.623779296875
      ],
      [
        -2489.704833984375,
        -4415.97705078125,
        1055.623779296875
      ],
      [
        -2490.447998046875,
        -4416.28515625,
        1060.623779296875
      ],
      [
        -2509.516357421875,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2509.20849609375,
        -4396.4736328125,
        1055.623779296875
      ],
      [
        -2536.790771484375,
        -4396.4736328125,
        1055.623779296875
      ],
      [
        -2536.48291015625,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2555.551513671875,
        -4416.28515625,
        1060.623779296875
      ],
      [
        -2556.294677734375,
        -4415.97705078125,
        1055.623779296875
      ],
      [
        -2509.20849609375,
        -4396.4736328125,
        1055.623779296875
      ],
      [
        -2509.516357421875,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2536.48291015625,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2536.790771484375,
        -4396.4736328125,
        1055.623779296875
      ],
      [
        -2509.20849609375,
        -4463.0634765625,
        1055.623779296875
      ],
      [
        -2509.516357421875,
        -4462.3203125,
        1060.623779296875
      ],
      [
        -2495.478515625,
        -4448.28271484375,
        1060.623779296875
      ],
      [
        -2495.8037109375,
        -4449.65869140625,
        1055.623779296875
      ],
      [
        -2490.447998046875,
        -4426.98193359375,
        1060.623779296875
      ],
      [
        -2490.447998046875,
        -4416.28515625,
        1060.623779296875
      ],
      [
        -2489.704833984375,
        -4415.97705078125,
        1055.623779296875
      ],
      [
        -2489.704833984375,
        -4423.83447265625,
        1055.623779296875
      ],
      [
        -2526.444580078125,
        -4396.4736328125,
        1055.623779296875
      ],
      [
        -2525.5927734375,
        -4397.21630859375,
        1060.623779296875
      ],
      [
        -2531.97021484375,
        -4391.6533203125,
        1055.623779296875
      ],
      [
        -2531.4091796875,
        -4392.142578125,
        1060.623779296875
      ],
      [
        -2489.704833984375,
        -4443.56005859375,
        1055.623779296875
      ],
      [
        -2490.447998046875,
        -4443.251953125,
        1060.623779296875
      ],
      [
        -2490.447998046875,
        -4443.251953125,
        1060.623779296875
      ],
      [
        -2489.704833984375,
        -4443.56005859375,
        1055.623779296875
      ],
      [
        -2570.999755859375,
        -4429.7685546875,
        1055.623779296875
      ],
      [
        -2570.999755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2570.999755859375,
        -4433.2685546875,
        1055.623779296875
      ],
      [
        -2570.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2495.8037109375,
        -4449.65869140625,
        1055.623779296875
      ],
      [
        -2495.99853515625,
        -4450.484375,
        1052.623779296875
      ],
      [
        -2489.704833984375,
        -4423.8349609375,
        1055.623779296875
      ],
      [
        -2489.259033203125,
        -4421.947265625,
        1052.623779296875
      ],
      [
        -2556.294677734375,
        -4429.7685546875,
        1055.623779296875
      ],
      [
        -2556.74072265625,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2556.294677734375,
        -4433.2685546875,
        1055.623779296875
      ],
      [
        -2556.74072265625,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2570.086181640625,
        -4429.7685546875,
        1055.623779296875
      ],
      [
        -2570.716552734375,
        -4429.7685546875,
        1052.623779296875
      ],
      [
        -2566.586181640625,
        -4433.2685546875,
        1055.623779296875
      ],
      [
        -2567.216552734375,
        -4433.2685546875,
        1052.623779296875
      ],
      [
        -2538.206787109375,
        -4463.0634765625,
        1055.623779296875
      ],
      [
        -2538.206787109375,
        -4463.50927734375,
        1052.623779296875
      ],
      [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2516.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2516.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2516.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      [
        -2559.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      [
        -2596.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      [
        -2559.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2542.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4410.0,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2542.0,
        -4454.3076171875,
        1072.5
      ],
      [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2542.0,
        -4454.2822265625,
        1072.623779296875
      ],
      [
        -2542.0,
        -4405.2294921875,
        1072.5
      ],
      [
        -2542.0,
        -4405.2548828125,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2504.0,
        -4410.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2492.23095703125,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2492.23095703125,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2504.0,
        -4454.30810546875,
        1072.5
      ],
      [
        -2504.0,
        -4454.28271484375,
        1072.623779296875
      ],
      [
        -2492.23095703125,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2504.0,
        -4405.22900390625,
        1072.5
      ],
      [
        -2492.23095703125,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2504.0,
        -4405.25439453125,
        1072.623779296875
      ],
      [
        -2504.0,
        -4410.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4410.0,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2535.744384765625,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2535.744384765625,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2504.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2526.199951171875,
        -4450.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2526.199951171875,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2526.199951171875,
        -4450.0,
        1072.623779296875
      ],
      [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2526.199951171875,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2512.0,
        -4430.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4438.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4416.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4442.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4430.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4430.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4438.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4438.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4442.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4442.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4424.0,
        1072.623779296875
      ],
      [
        -2512.0,
        -4416.0,
        1072.623779296875
      ],
      [
        -2504.0,
        -4416.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4423.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4423.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4431.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4423.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4431.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4431.0,
        1072.623779296875
      ],
      [
        -2542.0,
        -4418.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4418.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4418.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4410.0,
        1072.623779296875
      ],
      [
        -2535.96826171875,
        -4461.0771484375,
        1068.9908447265625
      ],
      [
        -2510.03125,
        -4461.0771484375,
        1068.9908447265625
      ],
      [
        -2535.968017578125,
        -4398.4599609375,
        1068.9908447265625
      ],
      [
        -2554.30810546875,
        -4416.80029296875,
        1068.9908447265625
      ],
      [
        -2554.30810546875,
        -4442.73681640625,
        1068.9908447265625
      ],
      [
        -2535.96826171875,
        -4461.0771484375,
        1068.9908447265625
      ],
      [
        -2510.03125,
        -4461.0771484375,
        1068.9908447265625
      ],
      [
        -2491.69140625,
        -4442.73681640625,
        1068.9908447265625
      ],
      [
        -2491.69140625,
        -4416.80029296875,
        1068.9908447265625
      ],
      [
        -2510.03125,
        -4398.4599609375,
        1068.9910888671875
      ],
      [
        -2554.30810546875,
        -4416.80029296875,
        1068.9908447265625
      ],
      [
        -2554.30810546875,
        -4442.73681640625,
        1068.9908447265625
      ],
      [
        -2491.69140625,
        -4442.73681640625,
        1068.9908447265625
      ],
      [
        -2491.69140625,
        -4416.80029296875,
        1068.9908447265625
      ],
      [
        -2510.03125,
        -4398.4599609375,
        1068.9910888671875
      ],
      [
        -2535.968017578125,
        -4398.4599609375,
        1068.9908447265625
      ],
      [
        -2500.50244140625,
        -4407.271484375,
        1065.5755615234375
      ],
      [
        -2509.60400390625,
        -4397.42822265625,
        1062.047607421875
      ],
      [
        -2509.60400390625,
        -4397.42822265625,
        1062.047607421875
      ],
      [
        -2545.496826171875,
        -4452.26611328125,
        1065.5755615234375
      ],
      [
        -2555.33984375,
        -4443.16455078125,
        1062.0474853515625
      ],
      [
        -2555.33984375,
        -4443.16455078125,
        1062.0474853515625
      ],
      [
        -2555.551513671875,
        -4439.4912109375,
        1060.623779296875
      ],
      [
        -2513.27734375,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2490.65966796875,
        -4416.37255859375,
        1062.0474853515625
      ],
      [
        -2490.65966796875,
        -4416.37255859375,
        1062.0474853515625
      ],
      [
        -2493.107177734375,
        -4413.6259765625,
        1060.623779296875
      ],
      [
        -2490.65966796875,
        -4443.16455078125,
        1062.0474853515625
      ],
      [
        -2490.65966796875,
        -4443.16455078125,
        1062.0474853515625
      ],
      [
        -2490.447998046875,
        -4439.4912109375,
        1060.623779296875
      ],
      [
        -2589.999755859375,
        -4509.7685546875,
        1075.623779296875
      ],
      [
        -2589.999755859375,
        -4506.7685546875,
        1075.623779296875
      ],
      [
        -2589.999755859375,
        -4506.7685546875,
        1075.623779296875
      ],
      [
        -2589.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      [
        -2519.9892578125,
        -4422.5,
        1094.623779296875
      ],
      [
        -2526.010986328125,
        -4422.5,
        1094.623779296875
      ],
      [
        -2514.8115234375,
        -4410.0,
        1086.623779296875
      ],
      [
        -2531.188232421875,
        -4410.0,
        1086.623779296875
      ],
      [
        -2526.0107421875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2519.989013671875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2526.0107421875,
        -4422.5,
        1094.623779296875
      ],
      [
        -2519.989013671875,
        -4422.5,
        1094.623779296875
      ],
      [
        -2519.989013671875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2526.0107421875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2531.188232421875,
        -4410.0,
        1082.623779296875
      ],
      [
        -2531.188232421875,
        -4410.0,
        1086.623779296875
      ],
      [
        -2514.8115234375,
        -4410.0,
        1086.623779296875
      ],
      [
        -2514.8115234375,
        -4410.0,
        1082.623779296875
      ],
      [
        -2514.8115234375,
        -4410.0,
        1072.623779296875
      ],
      [
        -2531.1884765625,
        -4410.0,
        1072.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1086.623779296875
      ],
      [
        -2504.0,
        -4421.89892578125,
        1086.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1086.623779296875
      ],
      [
        -2504.0,
        -4410.0,
        1082.623779296875
      ],
      [
        -2504.0,
        -4421.89892578125,
        1086.623779296875
      ],
      [
        -2504.0,
        -4421.89892578125,
        1082.623779296875
      ],
      [
        -2504.0,
        -4410.0,
        1082.623779296875
      ],
      [
        -2514.8115234375,
        -4410.0,
        1082.623779296875
      ],
      [
        -2504.0,
        -4421.89892578125,
        1072.623779296875
      ],
      [
        -2509.072998046875,
        -4424.0,
        1081.0999755859375
      ],
      [
        -2504.0,
        -4421.8984375,
        1081.0999755859375
      ],
      [
        -2509.072998046875,
        -4424.0,
        1081.0999755859375
      ],
      [
        -2509.072998046875,
        -4424.0,
        1072.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1086.623779296875
      ],
      [
        -2504.0,
        -4437.638671875,
        1086.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1086.623779296875
      ],
      [
        -2504.0,
        -4437.638671875,
        1086.623779296875
      ],
      [
        -2504.0,
        -4437.638671875,
        1082.623779296875
      ],
      [
        -2504.0,
        -4421.89892578125,
        1082.623779296875
      ],
      [
        -2504.0,
        -4437.63818359375,
        1072.623779296875
      ],
      [
        -2512.0,
        -4434.32421875,
        1081.0999755859375
      ],
      [
        -2504.0,
        -4437.63818359375,
        1081.0999755859375
      ],
      [
        -2512.0,
        -4434.32421875,
        1081.0999755859375
      ],
      [
        -2512.0,
        -4434.32421875,
        1072.623779296875
      ],
      [
        -2528.5,
        -4427.49072265625,
        1094.623779296875
      ],
      [
        -2528.5,
        -4427.49072265625,
        1086.623779296875
      ],
      [
        -2542.0,
        -4421.89892578125,
        1086.623779296875
      ],
      [
        -2528.5,
        -4427.49072265625,
        1094.623779296875
      ],
      [
        -2528.5,
        -4427.49072265625,
        1086.623779296875
      ],
      [
        -2542.0,
        -4421.8984375,
        1086.623779296875
      ],
      [
        -2542.0,
        -4410.0,
        1082.623779296875
      ],
      [
        -2542.0,
        -4421.8984375,
        1082.623779296875
      ],
      [
        -2542.0,
        -4410.0,
        1082.623779296875
      ],
      [
        -2531.188232421875,
        -4410.0,
        1082.623779296875
      ],
      [
        -2542.0,
        -4421.8984375,
        1072.623779296875
      ],
      [
        -2539.339599609375,
        -4423.0,
        1081.0999755859375
      ],
      [
        -2539.339599609375,
        -4423.0,
        1072.623779296875
      ],
      [
        -2534.0,
        -4425.2119140625,
        1081.0999755859375
      ],
      [
        -2534.0,
        -4425.2119140625,
        1072.623779296875
      ],
      [
        -2539.339599609375,
        -4423.0,
        1081.0999755859375
      ],
      [
        -2534.0,
        -4425.2119140625,
        1081.0999755859375
      ],
      [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1086.623779296875
      ],
      [
        -2514.619384765625,
        -4450.0,
        1086.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1086.623779296875
      ],
      [
        -2504.0,
        -4450.0,
        1082.623779296875
      ],
      [
        -2504.0,
        -4437.638671875,
        1082.623779296875
      ],
      [
        -2504.0,
        -4450.0,
        1082.623779296875
      ],
      [
        -2514.61962890625,
        -4450.0,
        1083.116455078125
      ],
      [
        -2514.61962890625,
        -4450.0,
        1082.623779296875
      ],
      [
        -2514.61962890625,
        -4450.0,
        1083.116455078125
      ],
      [
        -2514.619384765625,
        -4450.0,
        1086.623779296875
      ],
      [
        -2514.61962890625,
        -4450.0,
        1072.623779296875
      ],
      [
        -2528.5,
        -4432.04638671875,
        1094.623779296875
      ],
      [
        -2528.5,
        -4432.046875,
        1086.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1086.623779296875
      ],
      [
        -2528.5,
        -4432.04638671875,
        1094.623779296875
      ],
      [
        -2528.5,
        -4432.046875,
        1086.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1086.623779296875
      ],
      [
        -2542.0,
        -4421.8984375,
        1082.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1082.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1072.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      [
        -2556.13671875,
        -4509.7685546875,
        1075.623779296875
      ],
      [
        -2540.313720703125,
        -4471.568359375,
        1075.623779296875
      ],
      [
        -2553.32958984375,
        -4442.33154296875,
        1075.623779296875
      ],
      [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2542.0,
        -4450.0,
        1075.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1075.623779296875
      ],
      [
        -2542.0,
        -4450.0,
        1075.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1072.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1075.623779296875
      ],
      [
        -2540.313720703125,
        -4471.568359375,
        1075.623779296875
      ],
      [
        -2540.313720703125,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1086.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1086.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1086.623779296875
      ],
      [
        -2542.0,
        -4450.0,
        1082.623779296875
      ],
      [
        -2542.0,
        -4437.638671875,
        1082.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1083.515869140625
      ],
      [
        -2542.0,
        -4450.0,
        1082.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1082.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1086.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1083.515869140625
      ],
      [
        -2518.0,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1075.623779296875
      ],
      [
        -2518.0,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2516.999755859375,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2516.999755859375,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1075.623779296875
      ],
      [
        -2516.999755859375,
        -4450.0,
        1072.623779296875
      ],
      [
        -2516.999755859375,
        -4450.0,
        1075.623779296875
      ],
      [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2526.199951171875,
        -4450.0,
        1075.623779296875
      ],
      [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2526.199951171875,
        -4450.0,
        1075.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1075.623779296875
      ],
      [
        -2510.436767578125,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2514.61962890625,
        -4450.0,
        1075.623779296875
      ],
      [
        -2516.111328125,
        -4450.0,
        1082.623779296875
      ],
      [
        -2514.61962890625,
        -4450.0,
        1082.623779296875
      ],
      [
        -2528.33154296875,
        -4450.0,
        1082.623779296875
      ],
      [
        -2531.3798828125,
        -4450.0,
        1082.623779296875
      ],
      [
        -2516.111328125,
        -4450.0,
        1082.623779296875
      ],
      [
        -2528.33154296875,
        -4450.0,
        1082.623779296875
      ],
      [
        -2867.999755859375,
        -4319.7685546875,
        1098.1436767578125
      ],
      [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2795.0,
        -4319.7685546875,
        1075.9237060546875
      ],
      [
        -2795.0,
        -4330.0,
        1075.9237060546875
      ],
      [
        -2657.999755859375,
        -4356.7685546875,
        1058.623779296875
      ],
      [
        -2655.0,
        -4353.7685546875,
        1055.6241455078125
      ],
      [
        -2739.999755859375,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1052.623779296875
      ],
      [
        -2699.999755859375,
        -4319.7685546875,
        1109.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -2919.999755859375,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -2919.999755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1056.00244140625
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1145.6505126953125
      ],
      [
        -2701.179931640625,
        -4292.8291015625,
        1052.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1056.00244140625
      ],
      [
        -2869.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2750.961181640625,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1060.39111328125
      ],
      [
        -2739.999755859375,
        -4303.23046875,
        1066.3548583984375
      ],
      [
        -2739.999755859375,
        -4303.23046875,
        1052.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1060.39111328125
      ],
      [
        -2693.868408203125,
        -4289.6865234375,
        1059.5826416015625
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2919.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2739.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      [
        -2739.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2654.999755859375,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2864.999755859375,
        -4497.7685546875,
        1092.623779296875
      ],
      [
        -2764.999755859375,
        -4509.7685546875,
        1074.623779296875
      ],
      [
        -2764.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2749.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4589.7685546875,
        1112.623779296875
      ],
      [
        -2899.999755859375,
        -4589.7685546875,
        1112.623779296875
      ],
      [
        -2920.0,
        -4589.7685546875,
        1112.623779296875
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3319.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3000.410888671875,
        -4741.14697265625,
        1052.623779296875
      ],
      [
        -3001.35986328125,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3003.574462890625,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3001.35986328125,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -2955.91162109375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -2956.077392578125,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2956.077392578125,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3286.183349609375,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -3290.5458984375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2929.999755859375,
        -4919.7685546875,
        1062.337158203125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1087.22900390625
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.4810791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3295.838134765625,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.5458984375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3303.636962890625,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.837890625,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3070.100341796875,
        -4271.44384765625,
        1121.623779296875
      ],
      [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      [
        -3105.568603515625,
        -4629.7685546875,
        1101.623779296875
      ],
      [
        -3105.568603515625,
        -4679.7998046875,
        1101.623779296875
      ],
      [
        -3020.100830078125,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -3020.09814453125,
        -4261.66796875,
        1121.623779296875
      ],
      [
        -3020.09716796875,
        -4249.7685546875,
        1147.9725341796875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3556.305419921875,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3802.58349609375,
        -4310.9921875,
        1302.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3985.582763671875,
        -4213.58984375,
        1402.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -4007.749267578125,
        -4244.5771484375,
        1402.623779296875
      ],
      [
        -3835.11669921875,
        -4356.12060546875,
        1302.623779296875
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -3311.842041015625,
        -3619.7685546875,
        1402.623779296875
      ],
      [
        -3221.86962890625,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3100.0,
        -3780.262451171875,
        1322.556640625
      ],
      [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2654.999755859375,
      "bbox_min": [
        -3155.499755859375,
        -4843.06005859375,
        989.8104248046875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4362.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4367.96875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4353.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2679.999755859375,
      "bbox_min": [
        -2679.999755859375,
        -4367.96875,
        1030.623779296875
      ],
      "bbox_max": [
        -2679.999755859375,
        -4362.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1021.2237548828125,
      "bbox_min": [
        -2679.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4372.76806640625,
      "bbox_min": [
        -2679.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1031.2237548828125,
      "bbox_min": [
        -2662.499755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2662.499755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -2662.499755859375,
        -4399.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2654.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29085761308670044,
        -0.0,
        0.9567664265632629
      ],
      "plane_d": -206.56787109375,
      "bbox_min": [
        -2679.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2679.999755859375,
      "bbox_min": [
        -2679.999755859375,
        -4372.7685546875,
        1030.623779296875
      ],
      "bbox_max": [
        -2679.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1048.0,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1048.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46166881918907166,
        0.0,
        0.8870524168014526
      ],
      "plane_d": 523.0634155273438,
      "bbox_min": [
        -3155.499755859375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4569.7998046875,
      "bbox_min": [
        -2654.999755859375,
        -4843.06005859375,
        989.8104248046875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4462694823741913,
        0.0,
        0.8948986530303955
      ],
      "plane_d": -1971.989990234375,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        989.8104248046875
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -989.8103637695312,
      "bbox_min": [
        -2433.977783203125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2397.8544921875,
        -4727.623046875,
        1007.824462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238828420639038,
        0.38267549872398376,
        0.0
      ],
      "plane_d": -393.8897705078125,
      "bbox_min": [
        -2433.977783203125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2397.8544921875,
        -4759.7685546875,
        1007.824462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 3497.25048828125,
      "bbox_min": [
        -2433.977783203125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2407.26953125,
        -4782.4990234375,
        1003.1293334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 5357.06982421875,
      "bbox_min": [
        -2433.977783203125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2429.999755859375,
        -4790.26611328125,
        991.794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462694823741913,
        -0.0,
        0.8948986530303955
      ],
      "plane_d": 196.8795166015625,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        989.8104248046875
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -989.8103637695312,
      "bbox_min": [
        -2462.14501953125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2429.999755859375,
        -4729.27099609375,
        1007.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.38268354535102844,
        0.0
      ],
      "plane_d": 4096.21044921875,
      "bbox_min": [
        -2462.14501953125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2429.999755859375,
        -4737.0380859375,
        1007.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238828420639038,
        -0.38267549872398376,
        0.0
      ],
      "plane_d": 453.2867431640625,
      "bbox_min": [
        -2462.14501953125,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2429.999755859375,
        -4737.0380859375,
        1007.8242797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 5357.06982421875,
      "bbox_min": [
        -2452.72998046875,
        -4791.9140625,
        989.8104248046875
      ],
      "bbox_max": [
        -2429.999755859375,
        -4782.4990234375,
        1003.1292114257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4767.7685546875,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        991.794189453125
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.36369848251342773,
        0.878038227558136,
        0.3110823631286621
      ],
      "plane_d": 3041.15234375,
      "bbox_min": [
        -2509.9775390625,
        -4843.06005859375,
        991.794189453125
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3636971414089203,
        0.8780349493026733,
        0.31109341979026794
      ],
      "plane_d": 4808.69580078125,
      "bbox_min": [
        -2509.9775390625,
        -4843.06005859375,
        991.794189453125
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24316059052944183,
        0.5870414972305298,
        0.772175669670105
      ],
      "plane_d": 2630.20068359375,
      "bbox_min": [
        -2509.9775390625,
        -4837.37451171875,
        991.794189453125
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 5357.06982421875,
      "bbox_min": [
        -2450.496337890625,
        -4791.9140625,
        991.794189453125
      ],
      "bbox_max": [
        -2420.9423828125,
        -4783.42431640625,
        1002.0154418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 3497.25048828125,
      "bbox_min": [
        -2429.999755859375,
        -4791.9140625,
        996.3109741210938
      ],
      "bbox_max": [
        -2409.504150390625,
        -4783.4248046875,
        1002.0154418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5870413780212402,
        0.24316103756427765,
        0.7721755504608154
      ],
      "plane_d": 1829.039794921875,
      "bbox_min": [
        -2504.2919921875,
        -4819.16552734375,
        1002.0150146484375
      ],
      "bbox_max": [
        -2355.70751953125,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5870425701141357,
        0.24316082894802094,
        0.7721747159957886
      ],
      "plane_d": -1023.9840698242188,
      "bbox_min": [
        -2486.0830078125,
        -4819.16552734375,
        1002.0150146484375
      ],
      "bbox_max": [
        -2355.70751953125,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11731941252946854,
        0.2832379937171936,
        0.9518468379974365
      ],
      "plane_d": 676.5718383789062,
      "bbox_min": [
        -2486.0830078125,
        -4819.16552734375,
        1002.0150146484375
      ],
      "bbox_max": [
        -2373.91650390625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 5357.06982421875,
      "bbox_min": [
        -2458.83154296875,
        -4791.9140625,
        1002.0150146484375
      ],
      "bbox_max": [
        -2402.874267578125,
        -4767.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.38268354535102844,
        0.0
      ],
      "plane_d": 4096.21044921875,
      "bbox_min": [
        -2458.83154296875,
        -4782.4990234375,
        1003.1292114257812
      ],
      "bbox_max": [
        -2402.874267578125,
        -4767.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826789855957031,
        0.9238814115524292,
        0.0
      ],
      "plane_d": 3497.25048828125,
      "bbox_min": [
        -2429.999755859375,
        -4791.9140625,
        1005.3212280273438
      ],
      "bbox_max": [
        -2401.16796875,
        -4767.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238828420639038,
        0.38267549872398376,
        0.0
      ],
      "plane_d": -393.8897705078125,
      "bbox_min": [
        -2407.26953125,
        -4782.4990234375,
        1005.3212280273438
      ],
      "bbox_max": [
        -2401.16796875,
        -4767.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2832379639148712,
        0.11732105165719986,
        0.951846718788147
      ],
      "plane_d": 290.0277099609375,
      "bbox_min": [
        -2486.0830078125,
        -4801.7685546875,
        1010.9923706054688
      ],
      "bbox_max": [
        -2373.91650390625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28323787450790405,
        0.11732090264558792,
        0.9518466591835022
      ],
      "plane_d": -1086.509033203125,
      "bbox_min": [
        -2452.134765625,
        -4801.7685546875,
        1010.9923706054688
      ],
      "bbox_max": [
        -2373.91650390625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238828420639038,
        0.38267549872398376,
        0.0
      ],
      "plane_d": -393.8897705078125,
      "bbox_min": [
        -2407.26953125,
        -4782.4990234375,
        1010.9923706054688
      ],
      "bbox_max": [
        -2401.16796875,
        -4767.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5080.85400390625,
      "bbox_min": [
        -2417.461181640625,
        -4777.5478515625,
        1027.623779296875
      ],
      "bbox_max": [
        -2407.86474609375,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 5098.61767578125,
      "bbox_min": [
        -2452.134765625,
        -4783.90380859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": -1653.3482666015625,
      "bbox_min": [
        -2452.134765625,
        -4783.90380859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1644.3154296875,
      "bbox_min": [
        -2452.134765625,
        -4777.5478515625,
        1027.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3636971414089203,
        -0.8780349493026733,
        0.31109341979026794
      ],
      "plane_d": -5317.3583984375,
      "bbox_min": [
        -2509.9775390625,
        -4767.7685546875,
        1003.1292114257812
      ],
      "bbox_max": [
        -2350.02197265625,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36369848251342773,
        -0.878038227558136,
        0.3110823631286621
      ],
      "plane_d": -3549.791015625,
      "bbox_min": [
        -2509.9775390625,
        -4767.7685546875,
        1003.1292114257812
      ],
      "bbox_max": [
        -2350.02197265625,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1014.623779296875,
      "bbox_min": [
        -2509.9775390625,
        -4767.7685546875,
        1003.1292114257812
      ],
      "bbox_max": [
        -2350.02197265625,
        -4682.16259765625,
        1052.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4751.7685546875,
      "bbox_min": [
        -2462.14501953125,
        -4767.7685546875,
        1003.1292114257812
      ],
      "bbox_max": [
        -2397.8544921875,
        -4737.0380859375,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.38268354535102844,
        0.0
      ],
      "plane_d": 4096.21044921875,
      "bbox_min": [
        -2462.14501953125,
        -4767.7685546875,
        1006.171875
      ],
      "bbox_max": [
        -2397.8544921875,
        -4751.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238828420639038,
        -0.38267549872398376,
        0.0
      ],
      "plane_d": 453.2867431640625,
      "bbox_min": [
        -2462.14501953125,
        -4767.7685546875,
        1006.171875
      ],
      "bbox_max": [
        -2397.8544921875,
        -4751.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238828420639038,
        0.38267549872398376,
        0.0
      ],
      "plane_d": -393.8897705078125,
      "bbox_min": [
        -2401.168212890625,
        -4767.7685546875,
        1006.1719970703125
      ],
      "bbox_max": [
        -2397.8544921875,
        -4759.7685546875,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238828420639038,
        -0.38267549872398376,
        0.0
      ],
      "plane_d": 453.2867431640625,
      "bbox_min": [
        -2458.83154296875,
        -4751.7685546875,
        1003.1292114257812
      ],
      "bbox_max": [
        -2452.72998046875,
        -4737.0380859375,
        1014.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24316059052944183,
        -0.5870414972305298,
        0.772175669670105
      ],
      "plane_d": -4139.9228515625,
      "bbox_min": [
        -2509.9775390625,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2350.02197265625,
        -4682.16259765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2431621104478836,
        -0.5870451331138611,
        0.7721723318099976
      ],
      "plane_d": -2958.172607421875,
      "bbox_min": [
        -2509.9775390625,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2350.02197265625,
        -4682.16259765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8780379891395569,
        -0.36369600892066956,
        0.31108608841896057
      ],
      "plane_d": 148.19976806640625,
      "bbox_min": [
        -2509.9775390625,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2350.02197265625,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8780390620231628,
        -0.36369645595550537,
        0.311082661151886
      ],
      "plane_d": -4119.0654296875,
      "bbox_min": [
        -2504.2919921875,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2350.02197265625,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5870425701141357,
        -0.24316082894802094,
        0.7721747159957886
      ],
      "plane_d": -485.73590087890625,
      "bbox_min": [
        -2504.2919921875,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2355.70751953125,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5870413780212402,
        -0.24316103756427765,
        0.7721755504608154
      ],
      "plane_d": -3338.761474609375,
      "bbox_min": [
        -2486.0830078125,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2355.70751953125,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11731941252946854,
        -0.2832379937171936,
        0.9518468379974365
      ],
      "plane_d": -2589.89501953125,
      "bbox_min": [
        -2486.0830078125,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2373.91650390625,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11732035875320435,
        -0.28324025869369507,
        0.9518460035324097
      ],
      "plane_d": -2019.73046875,
      "bbox_min": [
        -2486.0830078125,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2373.91650390625,
        -4700.37158203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28323787450790405,
        -0.11732090264558792,
        0.9518466591835022
      ],
      "plane_d": -826.8137817382812,
      "bbox_min": [
        -2486.0830078125,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2373.91650390625,
        -4717.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2832379639148712,
        -0.11732105165719986,
        0.951846718788147
      ],
      "plane_d": -2203.3505859375,
      "bbox_min": [
        -2452.134765625,
        -4751.7685546875,
        1014.623779296875
      ],
      "bbox_max": [
        -2373.91650390625,
        -4717.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        -0.7071203589439392,
        0.0
      ],
      "plane_d": -1632.8409423828125,
      "bbox_min": [
        -2452.134765625,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2407.86474609375,
        -4735.63330078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -4.315837941248901e-06
      ],
      "plane_d": -5087.01025390625,
      "bbox_min": [
        -2452.134765625,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4735.6337890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2452.134765625,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4735.6337890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070580124855042,
        0.7071555852890015,
        0.0
      ],
      "plane_d": 5078.13818359375,
      "bbox_min": [
        -2446.07373046875,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4735.6337890625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49997302889823914,
        0.5000114440917969,
        -0.7071178555488586
      ],
      "plane_d": 1881.295166015625,
      "bbox_min": [
        -2446.07373046875,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4741.69482421875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        0.7071129083633423,
        0.0
      ],
      "plane_d": 1641.5303955078125,
      "bbox_min": [
        -2423.8173828125,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2407.86474609375,
        -4735.63330078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -4.928439466311829e-06
      ],
      "plane_d": -1650.47021484375,
      "bbox_min": [
        -2423.8173828125,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2407.86474609375,
        -4735.63330078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 5061.58154296875,
      "bbox_min": [
        -2423.8173828125,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2407.86474609375,
        -4735.63330078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499982625246048,
        0.500001847743988,
        -0.7071178555488586
      ],
      "plane_d": 4311.1416015625,
      "bbox_min": [
        -2423.8173828125,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2413.92578125,
        -4741.6943359375,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2464.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2297.499755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2302.499755859375,
        -4449.7685546875,
        1051.123779296875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4440.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832820892333984,
        0.0,
        -0.18208926916122437
      ],
      "plane_d": 2455.4052734375,
      "bbox_min": [
        -2302.499755859375,
        -4449.7685546875,
        1051.123779296875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4440.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2302.499755859375,
        -4449.7685546875,
        1051.123779296875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4440.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2302.499755859375,
        -4449.7685546875,
        1051.123779296875
      ],
      "bbox_max": [
        -2297.499755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1019.9489135742188
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.0,
        -0.0738627165555954,
        -0.9972684383392334
      ],
      "plane_d": 703.427978515625,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1019.9489135742188
      ],
      "bbox_max": [
        -2619.999755859375,
        -4382.55810546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1021.2237548828125,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1019.9489135742188
      ],
      "bbox_max": [
        -2619.999755859375,
        -4382.55810546875,
        1032.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0738716870546341,
        0.9972678422927856
      ],
      "plane_d": -693.415283203125,
      "bbox_min": [
        -2642.499755859375,
        -4399.7685546875,
        1019.9489135742188
      ],
      "bbox_max": [
        -2621.999755859375,
        -4382.55810546875,
        1021.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2642.499755859375,
      "bbox_min": [
        -2642.499755859375,
        -4399.7685546875,
        1019.9489135742188
      ],
      "bbox_max": [
        -2621.999755859375,
        -4382.55810546875,
        1021.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2621.999755859375,
      "bbox_min": [
        -2621.999755859375,
        -4399.7685546875,
        1019.9490966796875
      ],
      "bbox_max": [
        -2621.999755859375,
        -4382.55810546875,
        1021.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5046973824501038,
        0.0,
        0.8632963299751282
      ],
      "plane_d": -2213.767333984375,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2619.999755859375,
        -4382.55810546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -2639.499755859375,
        -4409.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4382.55810546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2621.999755859375,
      "bbox_min": [
        -2622.39453125,
        -4409.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4382.55810546875,
        1031.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1031.2237548828125,
      "bbox_min": [
        -2622.39453125,
        -4409.7685546875,
        1031.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4419.76806640625,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2619.999755859375,
        -4382.55810546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1031.2237548828125,
      "bbox_min": [
        -2654.999755859375,
        -4419.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2622.39453125,
        -4382.55810546875,
        1031.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4419.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2622.39453125,
        -4382.55810546875,
        1031.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2652.499755859375,
      "bbox_min": [
        -2652.499755859375,
        -4419.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2652.499755859375,
        -4409.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2642.499755859375,
      "bbox_min": [
        -2654.999755859375,
        -4399.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2642.499755859375,
        -4382.55810546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4399.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2642.499755859375,
        -4399.7685546875,
        1031.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1021.2237548828125
      ],
      "bbox_max": [
        -2619.999755859375,
        -4419.7685546875,
        1032.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1031.2237548828125,
      "bbox_min": [
        -2654.999755859375,
        -4429.7685546875,
        1031.2237548828125
      ],
      "bbox_max": [
        -2639.133544921875,
        -4419.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375624775886536,
        0.0,
        -0.6752789616584778
      ],
      "plane_d": 2643.8349609375,
      "bbox_min": [
        -2639.499755859375,
        -4429.7685546875,
        1032.2237548828125
      ],
      "bbox_max": [
        -2639.133544921875,
        -4419.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2596.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4404.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2639.999755859375,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2638.695068359375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5999755859375,
      "bbox_min": [
        -2639.575927734375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2629.999755859375,
      "bbox_min": [
        -2639.575927734375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375624775886536,
        0.0,
        -0.6752789616584778
      ],
      "plane_d": 2643.8349609375,
      "bbox_min": [
        -2639.575927734375,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2639.575927734375,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2633.265625,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4419.76806640625,
      "bbox_min": [
        -2639.133544921875,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2635.471435546875,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2639.133544921875,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2609.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2600.0,
      "bbox_min": [
        -2609.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2600.0,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4459.7685546875,
      "bbox_min": [
        -2600.0,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4459.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4479.7685546875,
      "bbox_min": [
        -2609.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2609.999755859375,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4459.7685546875,
      "bbox_min": [
        -2609.999755859375,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1041.623779296875,
      "bbox_min": [
        -2609.999755859375,
        -4459.7685546875,
        1041.623779296875
      ],
      "bbox_max": [
        -2608.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2608.999755859375,
      "bbox_min": [
        -2608.999755859375,
        -4459.7685546875,
        1041.623779296875
      ],
      "bbox_max": [
        -2608.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2609.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4479.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1041.623779296875,
      "bbox_min": [
        -2609.999755859375,
        -4489.7685546875,
        1041.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4479.7685546875,
        1042.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4489.7685546875,
      "bbox_min": [
        -2609.999755859375,
        -4489.7685546875,
        1041.623779296875
      ],
      "bbox_max": [
        -2600.0,
        -4489.7685546875,
        1042.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4489.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4499.7685546875,
        1042.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2629.999755859375,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2614.19970703125,
      "bbox_min": [
        -2614.19970703125,
        -4489.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.19970703125,
        -4485.2685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1040.623779296875,
      "bbox_min": [
        -2629.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4431.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4431.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4447.7685546875,
      "bbox_min": [
        -2614.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4431.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4431.7685546875,
      "bbox_min": [
        -2614.999755859375,
        -4431.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4431.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1036.623779296875,
      "bbox_min": [
        -2614.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4468.2685546875,
        1040.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4479.2685546875,
      "bbox_min": [
        -2614.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4468.2685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4468.2685546875,
      "bbox_min": [
        -2614.999755859375,
        -4470.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4468.2685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -9.765625145519152e-05,
        -0.0
      ],
      "plane_d": -2615.0361328125,
      "bbox_min": [
        -2614.999755859375,
        -4470.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.599609375,
        -4468.2685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4470.7685546875,
      "bbox_min": [
        -2614.999755859375,
        -4470.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.599609375,
        -4470.7685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1040.123779296875,
      "bbox_min": [
        -2614.599609375,
        -4476.2685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4470.7685546875,
        1040.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.599609375,
      "bbox_min": [
        -2614.599609375,
        -4476.2685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4470.7685546875,
        1040.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4476.2685546875,
      "bbox_min": [
        -2614.599609375,
        -4476.2685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4470.7685546875,
        1040.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4470.7685546875,
      "bbox_min": [
        -2614.599609375,
        -4470.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4470.7685546875,
        1040.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2619.499755859375,
      "bbox_min": [
        -2629.999755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4435.7685546875,
        1037.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1036.623779296875,
      "bbox_min": [
        -2619.499755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4470.7685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4470.7685546875,
      "bbox_min": [
        -2619.499755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4470.7685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4479.2685546875,
      "bbox_min": [
        -2619.499755859375,
        -4479.2685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4479.2685546875,
        1036.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1037.0238037109375,
      "bbox_min": [
        -2629.999755859375,
        -4443.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2624.999755859375,
        -4435.7685546875,
        1037.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2624.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4443.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2624.999755859375,
        -4435.7685546875,
        1037.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4443.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2624.999755859375,
        -4435.7685546875,
        1037.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4443.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4443.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2624.999755859375,
        -4443.7685546875,
        1037.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9389656186103821,
        -0.0,
        -0.344011127948761
      ],
      "plane_d": -2085.0859375,
      "bbox_min": [
        -2637.390625,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4411.7685546875,
      "bbox_min": [
        -2637.390625,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2637.390625,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7025595307350159,
        -0.6498375535011292,
        -0.2900365889072418
      ],
      "plane_d": -4398.22119140625,
      "bbox_min": [
        -2612.9287109375,
        -4419.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1049.69482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.695679783821106,
        -0.6717967987060547,
        -0.2543984055519104
      ],
      "plane_d": -869.1712036132812,
      "bbox_min": [
        -2637.390625,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7029120326042175,
        -0.6493913531303406,
        -0.2901820242404938
      ],
      "plane_d": -713.7620849609375,
      "bbox_min": [
        -2637.390625,
        -4419.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2627.07080078125,
        -4411.7685546875,
        1049.69482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4497.76806640625,
      "bbox_min": [
        -2637.390625,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2614.999755859375,
        -4497.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2624.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2614.999755859375,
        -4497.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1047.5999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4499.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2614.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954364776611328,
        0.6719008684158325,
        -0.2547887861728668
      ],
      "plane_d": 1472.3792724609375,
      "bbox_min": [
        -2637.390625,
        -4497.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7025595903396606,
        0.6498375535011292,
        -0.29003655910491943
      ],
      "plane_d": 1391.530517578125,
      "bbox_min": [
        -2612.9287109375,
        -4497.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2602.60009765625,
        -4489.7685546875,
        1049.69482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.695679783821106,
        0.6717967987060547,
        -0.2543984055519104
      ],
      "plane_d": 5116.22705078125,
      "bbox_min": [
        -2637.390625,
        -4497.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2609.999755859375,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7029120922088623,
        0.6493913531303406,
        -0.2901820242404938
      ],
      "plane_d": 5072.0146484375,
      "bbox_min": [
        -2637.390625,
        -4497.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2627.07080078125,
        -4489.7685546875,
        1049.69482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810884416103363,
        -0.6785971522331238,
        -0.6785979866981506
      ],
      "plane_d": -1543.053466796875,
      "bbox_min": [
        -2629.999755859375,
        -4415.91064453125,
        1049.69482421875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4411.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1047.5999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4444.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2639.999755859375,
        -4444.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.157990500330925,
        0.9874406456947327
      ],
      "plane_d": -1721.8858642578125,
      "bbox_min": [
        -2654.999755859375,
        -4444.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2654.999755859375,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2654.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      "bbox_max": [
        -2639.999755859375,
        -4382.55810546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1047.5999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5599077343940735,
        0.8285550475120544,
        0.0
      ],
      "plane_d": 2171.43701171875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42661547660827637,
        0.9044331312179565,
        0.0
      ],
      "plane_d": 2860.718505859375,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14761961996555328,
        0.9890442490577698,
        -0.0
      ],
      "plane_d": 4725.12158203125,
      "bbox_min": [
        -2600.0,
        -4389.84765625,
        1042.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21972408890724182,
        0.9755620956420898,
        0.0
      ],
      "plane_d": 3713.39794921875,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2610.60009765625,
        -4394.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0422564260661602,
        0.9991068840026855,
        0.0
      ],
      "plane_d": 4282.189453125,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2621.699951171875,
        -4396.89990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1047.5999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4529.7685546875,
        1047.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1047.5999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1042.5999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2559.712646484375,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2559.712646484375,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2559.712646484375,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2487.76953125,
        -4429.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4414.5615234375,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2496.649658203125,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2570.999755859375,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2596.999755859375,
        -4469.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2496.649658203125,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2569.323486328125,
        -4466.4814453125,
        1032.623779296875
      ],
      "bbox_max": [
        -2496.649658203125,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2569.323486328125,
        -4466.4814453125,
        1032.623779296875
      ],
      "bbox_max": [
        -2496.649658203125,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2559.712646484375,
        -4444.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2558.22998046875,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2559.712646484375,
        -4444.9755859375,
        1032.623779296875
      ],
      "bbox_max": [
        -2558.22998046875,
        -4433.26806640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2579.999755859375,
      "bbox_min": [
        -2579.999755859375,
        -4444.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2579.999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4469.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2538.206787109375,
        -4433.26806640625,
        1042.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4449.7685546875,
        1042.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4459.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4459.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4459.7685546875,
        1042.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2538.206787109375,
      "bbox_min": [
        -2538.206787109375,
        -4469.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2538.206787109375,
        -4464.39111328125,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4847588539123535,
        0.8746479153633118
      ],
      "plane_d": -3059.277587890625,
      "bbox_min": [
        -2497.298095703125,
        -4455.98681640625,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2474.999755859375,
      "bbox_min": [
        -2489.08056640625,
        -4447.76904296875,
        1032.623779296875
      ],
      "bbox_max": [
        -2474.999755859375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15799206495285034,
        0.9874404072761536
      ],
      "plane_d": -1721.892578125,
      "bbox_min": [
        -2489.08056640625,
        -4447.76904296875,
        1032.623779296875
      ],
      "bbox_max": [
        -2474.999755859375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2486.6435546875,
        -4444.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4429.7685546875,
        1035.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2489.08056640625,
        -4447.76904296875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4429.7685546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2489.08056640625,
        -4447.76904296875,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.286865234375,
        -4444.876953125,
        1034.226806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2497.298095703125,
        -4455.98681640625,
        1032.623779296875
      ],
      "bbox_max": [
        -2486.525146484375,
        -4444.361328125,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.756009618882672e-06,
        0.0
      ],
      "plane_d": 2580.0166015625,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4469.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4469.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2579.999755859375,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8324896693229675,
        0.5540405511856079,
        0.0
      ],
      "plane_d": 4588.24365234375,
      "bbox_min": [
        -2596.999755859375,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2580.0,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2580.0,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2580.0,
        -4429.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2591.999755859375,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2591.999755859375,
        -4429.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124804377555847,
        0.8586989045143127,
        -0.0
      ],
      "plane_d": 5099.046875,
      "bbox_min": [
        -2596.999755859375,
        -4394.10009765625,
        1042.5999755859375
      ],
      "bbox_max": [
        -2587.10009765625,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14761961996555328,
        0.9890442490577698,
        -0.0
      ],
      "plane_d": 4725.12158203125,
      "bbox_min": [
        -2596.999755859375,
        -4390.39990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2593.300048828125,
        -4389.84765625,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2580.0,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2570.999755859375,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2570.999755859375,
        -4469.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2580.0,
        -4469.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2580.0,
        -4469.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2580.0,
        -4469.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2580.0,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2572.8232421875,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2572.8232421875,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4415.17578125,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2558.22998046875,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4415.17578125,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2558.22998046875,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4415.17578125,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2558.22998046875,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2556.611328125,
        -4429.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2569.32373046875,
        -4433.2685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2557.487060546875,
        -4433.2685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2580.0,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2538.206787109375,
        -4429.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2580.0,
        -4429.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2571.772705078125,
        -4429.7685546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2538.206787109375,
      "bbox_min": [
        -2538.206787109375,
        -4464.9990234375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2538.206787109375,
        -4463.34375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2538.206787109375,
      "bbox_min": [
        -2538.206787109375,
        -4469.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2538.206787109375,
        -4464.255859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2496.649658203125,
        -4453.24169921875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4415.64111328125,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2496.649658203125,
        -4453.24169921875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2487.76953125,
        -4444.0537109375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2509.999755859375,
      "bbox_min": [
        -2509.999755859375,
        -4569.7998046875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2509.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732266068458557,
        -0.22984769940376282,
        -5.612131985799351e-07
      ],
      "plane_d": 1406.2392578125,
      "bbox_min": [
        -2591.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2591.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2570.999755859375,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2591.999755859375,
        -4469.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2556.740478515625,
        -4429.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2591.999755859375,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2591.999755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2557.487060546875,
        -4429.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4415.4833984375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2489.259033203125,
        -4421.947265625,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4415.4833984375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2557.487060546875,
        -4469.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2495.99853515625,
        -4433.2685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2557.487060546875,
        -4464.255859375,
        1047.5999755859375
      ],
      "bbox_max": [
        -2495.99853515625,
        -4433.2685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2557.487060546875,
        -4464.255859375,
        1047.5999755859375
      ],
      "bbox_max": [
        -2495.99853515625,
        -4433.2685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2557.487060546875,
        -4444.0537109375,
        1047.5999755859375
      ],
      "bbox_max": [
        -2556.740478515625,
        -4433.2685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2538.206787109375,
      "bbox_min": [
        -2538.206787109375,
        -4469.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2538.206787109375,
        -4462.291015625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2496.324951171875,
        -4451.8662109375,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4418.7861328125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2496.324951171875,
        -4451.8662109375,
        1047.5999755859375
      ],
      "bbox_max": [
        -2488.512451171875,
        -4443.74462890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1576450914144516,
        0.9874958395957947
      ],
      "plane_d": -1720.451904296875,
      "bbox_min": [
        -2654.999755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2464.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4362.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0738716870546341,
        0.9972678422927856
      ],
      "plane_d": -693.415283203125,
      "bbox_min": [
        -2654.999755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4372.76806640625,
      "bbox_min": [
        -2654.999755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2642.499755859375,
      "bbox_min": [
        -2642.499755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4372.7685546875,
        1029.9490966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2621.999755859375,
      "bbox_min": [
        -2621.999755859375,
        -4382.55810546875,
        1019.2240600585938
      ],
      "bbox_max": [
        -2621.999755859375,
        -4372.7685546875,
        1029.9490966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.954650077910628e-06,
        0.0,
        -1.0
      ],
      "plane_d": 1029.2083740234375,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6738377809524536,
        0.0,
        -0.738879382610321
      ],
      "plane_d": -1020.1437377929688,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1029.22412109375
      ],
      "bbox_max": [
        -2642.499755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29085761308670044,
        -0.0,
        0.9567664265632629
      ],
      "plane_d": -206.56787109375,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1029.2239990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2621.999755859375,
      "bbox_min": [
        -2621.999755859375,
        -4372.7685546875,
        1019.2240600585938
      ],
      "bbox_max": [
        -2621.999755859375,
        -4362.7685546875,
        1029.2239990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6477890014648438,
        -0.7618198394775391,
        0.0
      ],
      "plane_d": -1617.9864501953125,
      "bbox_min": [
        -2375.241943359375,
        -4155.2939453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2354.909423828125,
        -4138.85302734375,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2369.712646484375,
        -4155.2939453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2354.909423828125,
        -4138.85302734375,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7435131669044495,
        -0.6687213778495789,
        0.0
      ],
      "plane_d": -4529.65234375,
      "bbox_min": [
        -2369.712646484375,
        -4155.27392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -2354.943603515625,
        -4138.85302734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": 173.8419189453125,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4049.25439453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7892688512802124,
        -0.45568472146987915,
        0.411590039730072
      ],
      "plane_d": -262.6591796875,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2564.874267578125,
        -4065.557373046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6481265425682068,
        -0.648120105266571,
        0.3998405635356903
      ],
      "plane_d": -1443.3369140625,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2693.412353515625,
        -4221.44189453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2741.692626953125,
        -4249.7685546875,
        1129.285400390625
      ],
      "bbox_max": [
        -2719.46533203125,
        -4240.640625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999916553497314,
        -0.8660259246826172,
        -1.847579596869764e-06
      ],
      "plane_d": -4828.642578125,
      "bbox_min": [
        -2615.536865234375,
        -4094.807373046875,
        1121.623779296875
      ],
      "bbox_max": [
        -2564.874267578125,
        -4065.557373046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8351679444313049,
        -0.5499951243400574,
        0.0
      ],
      "plane_d": -295.2088623046875,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4049.25439453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4049.25439453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.428466796875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660209774971008,
        -0.5000078082084656,
        0.0
      ],
      "plane_d": 61.19921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7570425868034363,
        -0.43707743287086487,
        0.4856437146663666
      ],
      "plane_d": -410.84649658203125,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2487.43701171875,
        -4049.25439453125,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999934434890747,
        -0.8660258054733276,
        0.0
      ],
      "plane_d": -4828.64453125,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4049.25439453125,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1124.623779296875,
      "bbox_min": [
        -2564.874267578125,
        -4104.33154296875,
        1124.623779296875
      ],
      "bbox_max": [
        -2522.078125,
        -4049.25439453125,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745972871780396,
        -0.4472154378890991,
        0.44721055030822754
      ],
      "plane_d": -333.14947509765625,
      "bbox_min": [
        -2642.794189453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4947.84423828125,
      "bbox_min": [
        -2624.4736328125,
        -4208.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -2607.1533203125,
        -4198.03662109375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7492330074310303,
        -0.43257012963294983,
        0.5015307664871216
      ],
      "plane_d": -428.611328125,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -149.793212890625,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2999916970729828,
        -0.5196143984794617,
        0.8000036478042603
      ],
      "plane_d": -3776.464599609375,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4143.20458984375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5252299308776855,
        -0.7097760438919067,
        0.46941617131233215
      ],
      "plane_d": -2115.96728515625,
      "bbox_min": [
        -2552.267578125,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4156.35693359375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2368.212646484375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4155.27392578125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2310.823486328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790370345115662,
        0.7341040372848511,
        0.0
      ],
      "plane_d": 1525.21728515625,
      "bbox_min": [
        -2368.212646484375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.27392578125,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.27392578125,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144690990448,
        -0.669130802154541,
        0.0
      ],
      "plane_d": -4530.486328125,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.27392578125,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7428241968154907,
        -0.6694865226745605,
        -0.0
      ],
      "plane_d": -4531.232421875,
      "bbox_min": [
        -2323.849609375,
        -4210.20361328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4189.80859375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2310.739990234375,
        -4210.20361328125,
        1082.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4204.36767578125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.4853515625,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1086575984954834,
        -0.09783578664064407,
        0.989253044128418
      ],
      "plane_d": -1738.352294921875,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10966189205646515,
        -0.10024439543485641,
        0.9889010190963745
      ],
      "plane_d": -1750.394775390625,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.738088846206665,
        -0.6747035980224609,
        0.0
      ],
      "plane_d": -4562.05419921875,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075810432434082,
        0.706632137298584,
        0.0
      ],
      "plane_d": 1271.5703125,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6949717998504639,
        -0.7190370559692383,
        0.0
      ],
      "plane_d": -1397.6177978515625,
      "bbox_min": [
        -2338.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4189.80859375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880243301391602,
        -0.45979657769203186,
        0.0
      ],
      "plane_d": -3990.13525390625,
      "bbox_min": [
        -2323.89990234375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.800048828125,
        -4189.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2823.6796875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9752788543701172,
        -0.22097784280776978,
        0.0
      ],
      "plane_d": 1913.418701171875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2845.2509765625,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2823.6796875,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3903.140869140625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2772.9892578125,
        -3918.51513671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2823.6796875,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2739.973876953125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23722945153713226,
        -0.8853526711463928,
        0.3998410999774933
      ],
      "plane_d": -3568.94140625,
      "bbox_min": [
        -2750.961181640625,
        -4249.7685546875,
        1142.4732666015625
      ],
      "bbox_max": [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3599.999755859375,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6980487108230591,
        0.6980504989624023,
        0.15954118967056274
      ],
      "plane_d": 5042.2138671875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3429.320556640625,
        -4126.39453125,
        1102.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6224409937858582,
        -0.7379052639007568,
        0.2608889639377594
      ],
      "plane_d": -5213.8037109375,
      "bbox_min": [
        -3301.525146484375,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -3979.9873046875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3195.9453125,
        -3979.9873046875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3195.9453125,
        -3979.9873046875,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1132.7493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3068.5068359375,
        -3889.566650390625,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1098.4541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -3984.973388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3187.577392578125,
        -3884.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3187.596923828125,
        -3976.37890625,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3502.938720703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3479.999755859375,
        -4189.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3083.468505859375,
        -4249.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3051.571044921875,
        -4249.7685546875,
        1147.9725341796875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3749.999755859375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4919.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4609.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1102.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1195.5255126953125
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4615.7685546875,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4619.7685546875,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2249.999755859375,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1085.623779296875,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2245.999755859375,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2245.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2245.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22678354382514954,
        -0.8463547229766846,
        0.4819263815879822
      ],
      "plane_d": -3959.3359375,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22678926587104797,
        0.8463535308837891,
        0.4819256365299225
      ],
      "plane_d": 2897.25927734375,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6153361797332764,
        0.6237964630126953,
        0.48191219568252563
      ],
      "plane_d": 3834.527099609375,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6153339743614197,
        -0.6237942576408386,
        0.48191797733306885
      ],
      "plane_d": -4896.94189453125,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4658.3115234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447829484939575,
        0.2325933277606964,
        0.48191502690315247
      ],
      "plane_d": -1427.938232421875,
      "bbox_min": [
        -2380.729248046875,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4658.3115234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8447859287261963,
        -0.23257121443748474,
        0.4819205403327942
      ],
      "plane_d": 365.61279296875,
      "bbox_min": [
        -2336.809326171875,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4672.2021484375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2548328936100006,
        0.9510114789009094,
        0.17503531277179718
      ],
      "plane_d": 3648.627685546875,
      "bbox_min": [
        -2368.411376953125,
        -4698.4013671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4662.39794921875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914238333702087,
        -0.7009251713752747,
        0.1750343292951584
      ],
      "plane_d": -5109.36474609375,
      "bbox_min": [
        -2368.411376953125,
        -4698.4013671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4662.39794921875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6914238333702087,
        0.7009251713752747,
        0.1750343292951584
      ],
      "plane_d": 4701.732421875,
      "bbox_min": [
        -2368.411376953125,
        -4693.4931640625,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4662.39794921875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9492396712303162,
        0.26135846972465515,
        0.17503103613853455
      ],
      "plane_d": -1211.3905029296875,
      "bbox_min": [
        -2368.411376953125,
        -4693.4931640625,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4667.30615234375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9492457509040833,
        -0.2613345682621002,
        0.1750335395336151
      ],
      "plane_d": 803.8890991210938,
      "bbox_min": [
        -2343.30615234375,
        -4693.4931640625,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4675.50244140625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2495473474264145,
        0.931351900100708,
        -0.2651599645614624
      ],
      "plane_d": 4061.17236328125,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296196699142456,
        0.25593090057373047,
        -0.265154093503952
      ],
      "plane_d": -698.5534057617188,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771124601364136,
        -0.6864485144615173,
        -0.2651548683643341
      ],
      "plane_d": -4515.83935546875,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6771124601364136,
        0.6864485144615173,
        -0.2651548683643341
      ],
      "plane_d": 5092.4775390625,
      "bbox_min": [
        -2347.496826171875,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296206831932068,
        -0.2559264004230499,
        -0.26515480875968933
      ],
      "plane_d": 1275.214599609375,
      "bbox_min": [
        -2343.30615234375,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4674.60205078125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2382.96875,
        -4712.88525390625,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23148757219314575,
        0.8639536499977112,
        -0.44721078872680664
      ],
      "plane_d": 4000.243408203125,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6281111240386963,
        0.6367729902267456,
        -0.44720974564552307
      ],
      "plane_d": 4956.916015625,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8623470664024353,
        -0.23740020394325256,
        -0.44721224904060364
      ],
      "plane_d": 1415.924560546875,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4656.67626953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623456358909607,
        0.23740917444229126,
        -0.44721004366874695
      ],
      "plane_d": -415.03887939453125,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4656.67626953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13553127646446228,
        -0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 170.5274658203125,
      "bbox_min": [
        -2375.614013671875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4686.197265625,
        1159.5908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7162401676177979,
        0.6266971230506897,
        -0.3070029616355896
      ],
      "plane_d": 1593.462890625,
      "bbox_min": [
        -2382.96875,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2371.770751953125,
        -4686.197265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13687992095947266,
        -0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 169.6212158203125,
      "bbox_min": [
        -2378.821533203125,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2371.770751953125,
        -4686.197265625,
        1159.596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.614443838596344,
        -0.622891902923584,
        0.48421511054039
      ],
      "plane_d": -1906.813232421875,
      "bbox_min": [
        -2540.4609375,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2479.270263671875,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.843557596206665,
        0.2322559654712677,
        0.4842187762260437
      ],
      "plane_d": 2670.66162109375,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2479.270263671875,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22646257281303406,
        0.8451343774795532,
        0.4842134118080139
      ],
      "plane_d": 3990.55517578125,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2487.608642578125,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.614443838596344,
        0.622891902923584,
        0.48421511054039
      ],
      "plane_d": 839.6099853515625,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2514.8583984375,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8435620069503784,
        -0.23223426938056946,
        0.48422130942344666
      ],
      "plane_d": -3737.784912109375,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2523.17236328125,
        -4672.2021484375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.14306640625,
        -4693.4931640625,
        1072.5
      ],
      "bbox_max": [
        -2523.17236328125,
        -4675.50244140625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2528.14306640625,
        -4675.56005859375,
        1072.5
      ],
      "bbox_max": [
        -2514.8583984375,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.14306640625,
        -4675.56005859375,
        1072.5
      ],
      "bbox_max": [
        -2528.104248046875,
        -4675.50244140625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.254854291677475,
        0.9510912895202637,
        0.17457003891468048
      ],
      "plane_d": 4888.0625,
      "bbox_min": [
        -2514.890380859375,
        -4667.310546875,
        1072.5
      ],
      "bbox_max": [
        -2496.54150390625,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2514.890380859375,
        -4662.4599609375,
        1072.5
      ],
      "bbox_max": [
        -2514.85205078125,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9493189454078674,
        0.26138031482696533,
        0.1745675802230835
      ],
      "plane_d": 3402.732666015625,
      "bbox_min": [
        -2496.611083984375,
        -4685.296875,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4667.30615234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.254854291677475,
        0.9510912895202637,
        0.17457003891468048
      ],
      "plane_d": 4888.0625,
      "bbox_min": [
        -2496.611083984375,
        -4667.32421875,
        1072.5
      ],
      "bbox_max": [
        -2496.54150390625,
        -4667.30615234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6914816498756409,
        -0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": -1748.656494140625,
      "bbox_min": [
        -2504.879150390625,
        -4698.4013671875,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4685.2392578125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9493189454078674,
        0.26138031482696533,
        0.1745675802230835
      ],
      "plane_d": 3402.732666015625,
      "bbox_min": [
        -2491.626953125,
        -4685.296875,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4685.2392578125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.254854291677475,
        0.9510912895202637,
        0.17457003891468048
      ],
      "plane_d": 4888.0625,
      "bbox_min": [
        -2528.118408203125,
        -4698.376953125,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4662.42236328125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2528.118408203125,
        -4698.376953125,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4662.42236328125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6914816498756409,
        -0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": -1748.656494140625,
      "bbox_min": [
        -2528.118408203125,
        -4698.376953125,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4667.32421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9493189454078674,
        0.26138031482696533,
        0.1745675802230835
      ],
      "plane_d": 3402.732666015625,
      "bbox_min": [
        -2528.118408203125,
        -4693.47509765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4667.32421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.118408203125,
        -4693.47509765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4675.5087890625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24954763054847717,
        0.9313529133796692,
        -0.2651560604572296
      ],
      "plane_d": 5273.9736328125,
      "bbox_min": [
        -2531.50244140625,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929618239402771,
        0.25593051314353943,
        -0.2651594579219818
      ],
      "plane_d": 3819.3984375,
      "bbox_min": [
        -2531.50244140625,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771115660667419,
        0.6864476203918457,
        -0.2651596665382385
      ],
      "plane_d": 1801.715087890625,
      "bbox_min": [
        -2531.50244140625,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6771115660667419,
        -0.6864476203918457,
        -0.2651596665382385
      ],
      "plane_d": -1225.0654296875,
      "bbox_min": [
        -2531.50244140625,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4674.60205078125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296203851699829,
        -0.25592634081840515,
        -0.2651558518409729
      ],
      "plane_d": -3242.7392578125,
      "bbox_min": [
        -2531.50244140625,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4674.60205078125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2542.700439453125,
        -4712.88525390625,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2314876914024353,
        0.8639540672302246,
        -0.4472099244594574
      ],
      "plane_d": 5125.27392578125,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6281108260154724,
        0.6367726922035217,
        -0.4472106397151947
      ],
      "plane_d": 1904.2965087890625,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623447418212891,
        -0.23739954829216003,
        -0.44721701741218567
      ],
      "plane_d": -2775.067138671875,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4656.67626953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8623453378677368,
        0.2374090850353241,
        -0.4472106695175171
      ],
      "plane_d": 3775.9599609375,
      "bbox_min": [
        -2503.989501953125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4656.67626953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1355312615633011,
        -0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 829.209228515625,
      "bbox_min": [
        -2503.989501953125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.38525390625,
        -4686.197265625,
        1159.5908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7162401676177979,
        0.6266971230506897,
        -0.3070029318332672
      ],
      "plane_d": 5074.39013671875,
      "bbox_min": [
        -2488.228759765625,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4686.197265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13687990605831146,
        -0.13688243925571442,
        -0.9810847640037537
      ],
      "plane_d": 834.857421875,
      "bbox_min": [
        -2488.228759765625,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4686.197265625,
        1159.596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22677364945411682,
        0.8463587164878845,
        0.48192381858825684
      ],
      "plane_d": 4097.568359375,
      "bbox_min": [
        -2380.729248046875,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6153347492218018,
        0.6237949728965759,
        0.4819159507751465
      ],
      "plane_d": 1041.29443359375,
      "bbox_min": [
        -2380.729248046875,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447805047035217,
        -0.2325926423072815,
        0.4819195866584778
      ],
      "plane_d": -3642.11474609375,
      "bbox_min": [
        -2380.729248046875,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4817.04931640625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8447850942611694,
        0.23257099092006683,
        0.4819221794605255
      ],
      "plane_d": 2579.578369140625,
      "bbox_min": [
        -2336.809326171875,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2319.53857421875,
        -4817.04931640625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25482672452926636,
        0.9510129690170288,
        0.17503613233566284
      ],
      "plane_d": 4997.3642578125,
      "bbox_min": [
        -2368.411376953125,
        -4852.23095703125,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4821.1357421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914235949516296,
        0.7009249329566956,
        0.175035759806633
      ],
      "plane_d": 1563.116455078125,
      "bbox_min": [
        -2368.411376953125,
        -4852.23095703125,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4821.1357421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9492392539978027,
        -0.2613583505153656,
        0.17503304779529572
      ],
      "plane_d": -3699.40283203125,
      "bbox_min": [
        -2368.411376953125,
        -4852.23095703125,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4826.0439453125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9492454528808594,
        0.26133444905281067,
        0.17503561079502106
      ],
      "plane_d": 3291.669921875,
      "bbox_min": [
        -2343.30615234375,
        -4844.03466796875,
        1072.623779296875
      ],
      "bbox_max": [
        -2331.8564453125,
        -4826.0439453125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2495647817850113,
        0.9313490390777588,
        -0.2651534676551819
      ],
      "plane_d": 5381.97216796875,
      "bbox_min": [
        -2371.770751953125,
        -4854.68408203125,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.929618239402771,
        -0.25593051314353943,
        -0.2651594579219818
      ],
      "plane_d": -3134.885498046875,
      "bbox_min": [
        -2371.770751953125,
        -4854.68408203125,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771115660667419,
        0.6864476203918457,
        -0.2651596665382385
      ],
      "plane_d": 2018.83642578125,
      "bbox_min": [
        -2371.770751953125,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296203851699829,
        0.25592634081840515,
        -0.2651558518409729
      ],
      "plane_d": 3711.515625,
      "bbox_min": [
        -2343.30615234375,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2328.4970703125,
        -4823.59130859375,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2382.96875,
        -4871.623046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8623447418212891,
        0.23739954829216003,
        -0.44721701741218567
      ],
      "plane_d": 3675.86181640625,
      "bbox_min": [
        -2378.8212890625,
        -4847.935546875,
        1157.623779296875
      ],
      "bbox_max": [
        -2317.299072265625,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23149678111076355,
        0.8639527559280396,
        -0.44720783829689026
      ],
      "plane_d": 5225.453125,
      "bbox_min": [
        -2378.8212890625,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2326.251953125,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1355312615633011,
        0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 1478.51171875,
      "bbox_min": [
        -2378.8212890625,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4813.9921875,
        1159.5968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13687990605831146,
        0.13688243925571442,
        -0.9810847640037537
      ],
      "plane_d": 1472.6785888671875,
      "bbox_min": [
        -2378.8212890625,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2371.770751953125,
        -4823.03125,
        1159.5968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.554774284362793,
        0.7588759660720825,
        -0.3410758674144745
      ],
      "plane_d": 5357.99853515625,
      "bbox_min": [
        -2366.39599609375,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1355312615633011,
        0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 1478.51171875,
      "bbox_min": [
        -2366.39599609375,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4811.306640625,
        1159.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8435600399971008,
        -0.23225662112236023,
        0.4842142164707184
      ],
      "plane_d": 459.70013427734375,
      "bbox_min": [
        -2540.4609375,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2479.270263671875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6144431829452515,
        0.6228911876678467,
        0.4842171370983124
      ],
      "plane_d": 4022.822265625,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2479.270263671875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2264551967382431,
        0.8451293706893921,
        0.4842255413532257
      ],
      "plane_d": 2987.91015625,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2501.633544921875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84356290102005,
        0.23223452270030975,
        0.48421967029571533
      ],
      "plane_d": -1527.021240234375,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2523.186767578125,
        -4817.04931640625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2528.14306640625,
        -4844.03466796875,
        1072.5
      ],
      "bbox_max": [
        -2523.186767578125,
        -4826.0439453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2523.190185546875,
        -4826.1142578125,
        1072.5
      ],
      "bbox_max": [
        -2504.872802734375,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2523.190185546875,
        -4826.1142578125,
        1072.5
      ],
      "bbox_max": [
        -2523.17236328125,
        -4826.0439453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.69148188829422,
        0.7009840607643127,
        0.17456886172294617
      ],
      "plane_d": 4924.38818359375,
      "bbox_min": [
        -2504.931640625,
        -4834.240234375,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2504.931640625,
        -4821.173828125,
        1072.5
      ],
      "bbox_max": [
        -2504.872802734375,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9493192434310913,
        -0.2613804042339325,
        0.17456556856632233
      ],
      "plane_d": 914.5152587890625,
      "bbox_min": [
        -2496.559326171875,
        -4852.23095703125,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4834.208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.69148188829422,
        0.7009840607643127,
        0.17456886172294617
      ],
      "plane_d": 4924.38818359375,
      "bbox_min": [
        -2491.650634765625,
        -4834.24658203125,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4834.208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2528.118408203125,
        -4852.212890625,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4821.16015625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.69148188829422,
        0.7009840607643127,
        0.17456886172294617
      ],
      "plane_d": 4924.38818359375,
      "bbox_min": [
        -2528.118408203125,
        -4852.212890625,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4821.16015625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9493192434310913,
        -0.2613804042339325,
        0.17456556856632233
      ],
      "plane_d": 914.5152587890625,
      "bbox_min": [
        -2528.118408203125,
        -4852.212890625,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4826.06201171875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4826.06201171875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24956487119197845,
        0.9313494563102722,
        -0.2651519477367401
      ],
      "plane_d": 4169.087890625,
      "bbox_min": [
        -2531.50244140625,
        -4854.68408203125,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296196699142456,
        -0.25593090057373047,
        -0.265154093503952
      ],
      "plane_d": 1383.05419921875,
      "bbox_min": [
        -2531.50244140625,
        -4854.68408203125,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6771124601364136,
        0.6864485144615173,
        -0.2651548683643341
      ],
      "plane_d": 5309.59912109375,
      "bbox_min": [
        -2531.50244140625,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296206831932068,
        0.2559264004230499,
        -0.26515480875968933
      ],
      "plane_d": -806.4406127929688,
      "bbox_min": [
        -2531.50244140625,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4823.59130859375,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2542.700439453125,
        -4871.623046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623470664024353,
        0.23740020394325256,
        -0.44721224904060364
      ],
      "plane_d": -515.1415405273438,
      "bbox_min": [
        -2542.700439453125,
        -4862.86083984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23149581253528595,
        0.863949179649353,
        -0.44721511006355286
      ],
      "plane_d": 4100.373046875,
      "bbox_min": [
        -2533.74755859375,
        -4862.86083984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8623456358909607,
        -0.23740917444229126,
        -0.44721004366874695
      ],
      "plane_d": 1515.93505859375,
      "bbox_min": [
        -2503.989501953125,
        -4862.86083984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2477.03076171875,
        -4813.99267578125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2503.989501953125,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.385498046875,
        -4813.99267578125,
        1159.5908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.13687992095947266,
        0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 2137.914794921875,
      "bbox_min": [
        -2488.228759765625,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4823.0849609375,
        1159.5968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554774284362793,
        0.7588759660720825,
        -0.3410758674144745
      ],
      "plane_d": 2661.796142578125,
      "bbox_min": [
        -2503.989501953125,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2493.60302734375,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2503.989501953125,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2493.60302734375,
        -4811.306640625,
        1159.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2419.999755859375,
      "bbox_min": [
        -2501.044921875,
        -4830.33935546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9867103099822998,
        0.0,
        -0.16248930990695953
      ],
      "plane_d": 2558.8115234375,
      "bbox_min": [
        -2419.999755859375,
        -4830.33935546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519788742065,
        0.7062519788742065,
        -0.04915514215826988
      ],
      "plane_d": 1691.9815673828125,
      "bbox_min": [
        -2419.999755859375,
        -4823.3857421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.5830078125,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2419.999755859375,
        -4823.3857421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.5830078125,
        -4711.41015625,
        1212.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2400.089111328125,
        -4717.677734375,
        1192.623779296875
      ],
      "bbox_max": [
        -2393.5830078125,
        -4711.41015625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2419.999755859375,
        -4823.3857421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2399.3466796875,
        -4713.103515625,
        1192.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.93861323595047,
        0.04111221060156822,
        -0.3425126075744629
      ],
      "plane_d": 2862.46826171875,
      "bbox_min": [
        -2419.999755859375,
        -4823.3857421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2401.10498046875,
        -4715.60498046875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9685899019241333,
        0.0,
        -0.24866360425949097
      ],
      "plane_d": 2625.947021484375,
      "bbox_min": [
        -2409.00390625,
        -4823.3857421875,
        1176.7305908203125
      ],
      "bbox_max": [
        -2408.774658203125,
        -4821.1796875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066429853439331,
        0.7066429853439331,
        -0.03621487691998482
      ],
      "plane_d": 1677.8031005859375,
      "bbox_min": [
        -2419.999755859375,
        -4807.22705078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2401.10498046875,
        -4715.60498046875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.830085039138794,
        -0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": 1992.8173828125,
      "bbox_min": [
        -2419.999755859375,
        -4807.22705078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4749.04736328125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 1662.14501953125,
      "bbox_min": [
        -2419.999755859375,
        -4780.66259765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.461181640625,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189284324646,
        -2.4642197331559146e-06
      ],
      "plane_d": -5089.86865234375,
      "bbox_min": [
        -2419.999755859375,
        -4780.66259765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.46142578125,
        -4778.12451171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8300850987434387,
        0.13408894836902618,
        -0.5412752628326416
      ],
      "plane_d": 3269.282470703125,
      "bbox_min": [
        -2414.499755859375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2401.10498046875,
        -4715.60498046875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.830085039138794,
        -0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": 1992.8173828125,
      "bbox_min": [
        -2409.3857421875,
        -4823.16455078125,
        1177.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4797.71142578125,
        1183.3941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9685899019241333,
        0.0,
        -0.24866360425949097
      ],
      "plane_d": 2625.947021484375,
      "bbox_min": [
        -2408.774658203125,
        -4823.16455078125,
        1177.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4812.27099609375,
        1183.3941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2407.8486328125,
      "bbox_min": [
        -2407.8486328125,
        -4822.27099609375,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4812.27099609375,
        1183.3941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2407.8486328125,
      "bbox_min": [
        -2407.8486328125,
        -4821.0048828125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4812.27099609375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1188.5,
      "bbox_min": [
        -2419.999755859375,
        -4766.0,
        1177.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4721.6015625,
        1188.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 2418.99951171875,
      "bbox_min": [
        -2419.999755859375,
        -4766.0,
        1177.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4721.6015625,
        1188.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4754.0,
      "bbox_min": [
        -2419.999755859375,
        -4765.0,
        1177.623779296875
      ],
      "bbox_max": [
        -2418.999755859375,
        -4754.0,
        1188.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4765.0,
      "bbox_min": [
        -2419.999755859375,
        -4765.0,
        1177.623779296875
      ],
      "bbox_max": [
        -2418.999755859375,
        -4765.0,
        1187.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8300850987434387,
        0.13408894836902618,
        -0.5412752628326416
      ],
      "plane_d": 3269.282470703125,
      "bbox_min": [
        -2407.87939453125,
        -4721.82568359375,
        1177.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4721.6015625,
        1177.6793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9867106676101685,
        -0.16248691082000732
      ],
      "plane_d": 4855.64404296875,
      "bbox_min": [
        -2419.999755859375,
        -4741.41259765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2399.3466796875,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2419.999755859375,
        -4733.75634765625,
        1177.623779296875
      ],
      "bbox_max": [
        -2411.932861328125,
        -4724.6455078125,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9199437499046326,
        0.0,
        -0.392050564289093
      ],
      "plane_d": 2678.187255859375,
      "bbox_min": [
        -2419.999755859375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2399.3466796875,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4703.9345703125,
      "bbox_min": [
        -2419.999755859375,
        -4727.11572265625,
        1177.623779296875
      ],
      "bbox_max": [
        -2399.657470703125,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2419.999755859375,
        -4727.11572265625,
        1177.623779296875
      ],
      "bbox_max": [
        -2399.657470703125,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.8630385398864746,
        0.5051382780075073
      ],
      "plane_d": 3457.23681640625,
      "bbox_min": [
        -2419.999755859375,
        -4703.9345703125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2407.8486328125,
      "bbox_min": [
        -2407.8486328125,
        -4703.9345703125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2409.3857421875,
        -4723.14208984375,
        1177.623779296875
      ],
      "bbox_max": [
        -2399.3935546875,
        -4708.6123046875,
        1200.450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 1111.57177734375,
      "bbox_min": [
        -2407.14111328125,
        -4720.89794921875,
        1171.20263671875
      ],
      "bbox_max": [
        -2399.3466796875,
        -4710.67626953125,
        1193.0045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2407.14111328125,
        -4720.89794921875,
        1177.623779296875
      ],
      "bbox_max": [
        -2399.3466796875,
        -4710.67626953125,
        1193.0045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 1111.57177734375,
      "bbox_min": [
        -2403.510986328125,
        -4717.71484375,
        1166.9468994140625
      ],
      "bbox_max": [
        -2399.978759765625,
        -4712.4482421875,
        1173.7852783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7062519192695618,
        0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": 5127.1923828125,
      "bbox_min": [
        -2419.931640625,
        -4806.693359375,
        1052.623779296875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4692.93603515625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2419.931640625,
        -4806.693359375,
        1052.623779296875
      ],
      "bbox_max": [
        -2384.043212890625,
        -4767.951171875,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2419.931640625,
        -4806.693359375,
        1052.623779296875
      ],
      "bbox_max": [
        -2385.204345703125,
        -4767.951171875,
        1178.0010986328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189284324646,
        -2.4642197331559146e-06
      ],
      "plane_d": -5089.86865234375,
      "bbox_min": [
        -2419.931640625,
        -4788.44921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.6748046875,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 1662.14501953125,
      "bbox_min": [
        -2419.931640625,
        -4770.421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.461181640625,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 5447.283203125,
      "bbox_min": [
        -2394.36865234375,
        -4791.41064453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2387.1806640625,
        -4784.70458984375,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2704179883003235,
        0.0,
        0.9627430438995361
      ],
      "plane_d": -1781.2294921875,
      "bbox_min": [
        -2394.36865234375,
        -4784.70458984375,
        1177.623779296875
      ],
      "bbox_max": [
        -2393.025390625,
        -4783.3876953125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954730749130249,
        0.6954730749130249,
        -0.18064959347248077
      ],
      "plane_d": 5159.07421875,
      "bbox_min": [
        -2417.983154296875,
        -4792.6689453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4692.93603515625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7062519192695618,
        -0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": -1595.9990234375,
      "bbox_min": [
        -2417.983154296875,
        -4792.6689453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2369.927490234375,
        -4712.9736328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2413.698486328125,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2383.334228515625,
        -4712.9736328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2413.698486328125,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2384.043212890625,
        -4712.9736328125,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2413.698486328125,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2385.20458984375,
        -4712.9736328125,
        1178.0010986328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 1111.57177734375,
      "bbox_min": [
        -2401.121337890625,
        -4715.65087890625,
        1165.623779296875
      ],
      "bbox_max": [
        -2400.357666015625,
        -4714.94970703125,
        1166.9461669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2704179883003235,
        0.0,
        0.9627430438995361
      ],
      "plane_d": -1781.2294921875,
      "bbox_min": [
        -2394.36865234375,
        -4736.1494140625,
        1177.623779296875
      ],
      "bbox_max": [
        -2393.025390625,
        -4734.83251953125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16481724381446838,
        0.7927932739257812,
        -0.5867828726768494
      ],
      "plane_d": 4839.38623046875,
      "bbox_min": [
        -2394.36865234375,
        -4735.05908203125,
        1177.623779296875
      ],
      "bbox_max": [
        -2393.025390625,
        -4734.83251953125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2375.77587890625,
      "bbox_min": [
        -2417.983154296875,
        -4792.6689453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2369.927490234375,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": 2131.1787109375,
      "bbox_min": [
        -2417.983154296875,
        -4792.6689453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2704179883003235,
        0.0,
        0.9627430438995361
      ],
      "plane_d": -1781.2294921875,
      "bbox_min": [
        -2401.32275390625,
        -4792.6689453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.2130910316018344e-08,
        0.907411515712738,
        -0.4202432632446289
      ],
      "plane_d": 4793.03466796875,
      "bbox_min": [
        -2401.32275390625,
        -4792.5517578125,
        1165.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4726.98583984375,
        1182.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2379.927490234375,
        -4734.83251953125,
        1181.6800537109375
      ],
      "bbox_max": [
        -2376.01904296875,
        -4734.83251953125,
        1182.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2390.90478515625,
        -4732.685546875,
        1177.623779296875
      ],
      "bbox_max": [
        -2383.866455078125,
        -4726.98583984375,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2377.599609375,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4733.07568359375,
        1201.1968994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2377.599609375,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4733.07568359375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2399.3466796875,
        -4792.6689453125,
        1177.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2384.043212890625,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2399.3466796875,
        -4783.3876953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2394.36865234375,
        -4736.1494140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5080.85400390625,
      "bbox_min": [
        -2417.983154296875,
        -4791.41064453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2384.8544921875,
        -4737.44384765625,
        1174.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 1662.14501953125,
      "bbox_min": [
        -2417.983154296875,
        -4768.47314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.461181640625,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -4.928439466311829e-06
      ],
      "plane_d": -1650.47021484375,
      "bbox_min": [
        -2417.461181640625,
        -4791.41064453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2384.8544921875,
        -4737.44384765625,
        1174.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 5061.58154296875,
      "bbox_min": [
        -2408.38671875,
        -4741.9892578125,
        1052.623779296875
      ],
      "bbox_max": [
        -2403.319091796875,
        -4737.44384765625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 5447.283203125,
      "bbox_min": [
        -2389.117919921875,
        -4791.41064453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2384.8544921875,
        -4789.0390625,
        1174.046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819599747657776,
        -0.0,
        0.4713243842124939
      ],
      "plane_d": 1533.2265625,
      "bbox_min": [
        -2375.77587890625,
        -4784.70458984375,
        1178.68896484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": 2131.1787109375,
      "bbox_min": [
        -2375.77587890625,
        -4783.33642578125,
        1178.68896484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2375.77587890625,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2374.21875,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.2130910316018344e-08,
        0.907411515712738,
        -0.4202432632446289
      ],
      "plane_d": 4793.03466796875,
      "bbox_min": [
        -2375.77587890625,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2375.703857421875,
        -4736.03662109375,
        1179.080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13553127646446228,
        -0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 170.5274658203125,
      "bbox_min": [
        -2387.1806640625,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2363.673828125,
        -4696.50634765625,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819599747657776,
        -0.0,
        0.4713243842124939
      ],
      "plane_d": 1533.2265625,
      "bbox_min": [
        -2376.30419921875,
        -4741.20947265625,
        1178.7259521484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1189.7099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2376.30419921875,
        -4741.20947265625,
        1178.7259521484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1189.7099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": 2131.1787109375,
      "bbox_min": [
        -2376.30419921875,
        -4741.20947265625,
        1178.7259521484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.2130910316018344e-08,
        0.907411515712738,
        -0.4202432632446289
      ],
      "plane_d": 4793.03466796875,
      "bbox_min": [
        -2376.30419921875,
        -4736.20068359375,
        1178.7259521484375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2400.357666015625,
        -4830.33935546875,
        1159.5906982421875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4778.328125,
        1189.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1355312615633011,
        0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 1478.51171875,
      "bbox_min": [
        -2387.1806640625,
        -4823.03125,
        1159.5906982421875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4791.21337890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 5447.283203125,
      "bbox_min": [
        -2387.1806640625,
        -4806.65185546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2358.95458984375,
        -4791.21337890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": 2131.1787109375,
      "bbox_min": [
        -2375.703125,
        -4784.70458984375,
        1178.7261962890625
      ],
      "bbox_max": [
        -2369.927490234375,
        -4778.328125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7162401676177979,
        0.6266971230506897,
        -0.3070029616355896
      ],
      "plane_d": 1593.462890625,
      "bbox_min": [
        -2419.931640625,
        -4741.34423828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2378.547607421875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13687992095947266,
        -0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 169.6212158203125,
      "bbox_min": [
        -2400.357666015625,
        -4714.94970703125,
        1159.596435546875
      ],
      "bbox_max": [
        -2378.547607421875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2399.3466796875,
        -4713.103515625,
        1177.623779296875
      ],
      "bbox_max": [
        -2379.178955078125,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 5061.58154296875,
      "bbox_min": [
        -2414.220703125,
        -4736.1552734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.675048828125,
        -4731.087890625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -2501.044921875,
        -4830.33935546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6954730749130249,
        -0.6954730749130249,
        -0.18064959347248077
      ],
      "plane_d": -4841.50634765625,
      "bbox_min": [
        -2501.044921875,
        -4830.33935546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4769.7685546875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519192695618,
        0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": 1694.8084716796875,
      "bbox_min": [
        -2490.072021484375,
        -4818.01904296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4769.7685546875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2475.03466796875,
        -4818.01904296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2474.794677734375,
        -4818.01904296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 5098.61767578125,
      "bbox_min": [
        -2440.720947265625,
        -4774.30712890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4769.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189284324646,
        -2.4642197331559146e-06
      ],
      "plane_d": -5089.86865234375,
      "bbox_min": [
        -2423.8173828125,
        -4778.12451171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4774.30712890625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2404593825340271,
        0.9706593155860901
      ],
      "plane_d": 10.583251953125,
      "bbox_min": [
        -2466.97412109375,
        -4818.01904296875,
        1177.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4783.3876953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4816.3974609375,
        1181.2305908203125
      ],
      "bbox_max": [
        -2452.15087890625,
        -4812.27099609375,
        1182.2528076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9929671287536621,
        0.11839047819375992
      ],
      "plane_d": 4638.580078125,
      "bbox_min": [
        -2466.97412109375,
        -4818.01904296875,
        1177.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4783.3876953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4818.01904296875,
        1181.2305908203125
      ],
      "bbox_max": [
        -2452.15087890625,
        -4812.27099609375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2704179883003235,
        -0.0,
        0.9627430438995361
      ],
      "plane_d": -466.99822998046875,
      "bbox_min": [
        -2466.97412109375,
        -4784.70458984375,
        1177.623779296875
      ],
      "bbox_max": [
        -2465.630859375,
        -4783.3876953125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9867103099822998,
        0.0,
        -0.16248930990695953
      ],
      "plane_d": -2236.600341796875,
      "bbox_min": [
        -2490.072021484375,
        -4792.55126953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2444.355712890625,
        -4769.7685546875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2463.123046875,
        -4779.8359375,
        1177.623779296875
      ],
      "bbox_max": [
        -2452.011962890625,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2463.123046875,
        -4779.8359375,
        1192.623779296875
      ],
      "bbox_max": [
        -2453.055908203125,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2484.2236328125,
      "bbox_min": [
        -2490.072021484375,
        -4792.55126953125,
        1171.865478515625
      ],
      "bbox_max": [
        -2460.653076171875,
        -4769.7685546875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2482.39990234375,
        -4792.55126953125,
        1171.865478515625
      ],
      "bbox_max": [
        -2460.653076171875,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2476.133056640625,
        -4792.55126953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2469.09375,
        -4786.8505859375,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2465.630859375,
        -4783.3876953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2460.653076171875,
        -4769.7685546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819599747657776,
        0.0,
        0.4713243842124939
      ],
      "plane_d": -2753.0986328125,
      "bbox_min": [
        -2490.072021484375,
        -4784.70458984375,
        1181.6800537109375
      ],
      "bbox_max": [
        -2484.2236328125,
        -4769.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1644.3154296875,
      "bbox_min": [
        -2475.14501953125,
        -4791.41064453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2444.355712890625,
        -4769.7685546875,
        1174.0460205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 2919.10107421875,
      "bbox_min": [
        -2475.14501953125,
        -4791.41064453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2470.88134765625,
        -4789.03857421875,
        1174.0460205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2501.044921875,
        -4830.33935546875,
        1159.5906982421875
      ],
      "bbox_max": [
        -2452.15087890625,
        -4778.328125,
        1189.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554774284362793,
        0.7588759660720825,
        -0.3410758674144745
      ],
      "plane_d": 2661.796142578125,
      "bbox_min": [
        -2501.044921875,
        -4826.24853515625,
        1159.5906982421875
      ],
      "bbox_max": [
        -2459.641845703125,
        -4791.212890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2501.044921875,
        -4823.03125,
        1159.5906982421875
      ],
      "bbox_max": [
        -2472.81884765625,
        -4791.212890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 2919.10107421875,
      "bbox_min": [
        -2501.044921875,
        -4806.65185546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2472.81884765625,
        -4791.212890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2490.072021484375,
        -4822.27099609375,
        1178.7261962890625
      ],
      "bbox_max": [
        -2452.15087890625,
        -4778.328125,
        1188.495361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": -81.732666015625,
      "bbox_min": [
        -2490.072021484375,
        -4784.70458984375,
        1178.7261962890625
      ],
      "bbox_max": [
        -2484.29638671875,
        -4778.328125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519192695618,
        -0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": -5028.38330078125,
      "bbox_min": [
        -2501.044921875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954664587974548,
        0.6954793930053711,
        -0.18065086007118225
      ],
      "plane_d": 1779.1229248046875,
      "bbox_min": [
        -2494.9287109375,
        -4763.3251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7062459588050842,
        0.7062581181526184,
        -0.04915497079491615
      ],
      "plane_d": 5124.3798828125,
      "bbox_min": [
        -2476.665771484375,
        -4763.3251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2476.665771484375,
        -4763.3251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2422.943115234375,
        -4711.40966796875,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7066429853439331,
        0.7066429853439331,
        -0.03621487691998482
      ],
      "plane_d": 5112.087890625,
      "bbox_min": [
        -2466.721435546875,
        -4751.5859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2431.6435546875,
        -4714.94970703125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2466.721435546875,
        -4751.5859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2431.6435546875,
        -4731.087890625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        -0.7071203589439392,
        0.0
      ],
      "plane_d": -1632.8409423828125,
      "bbox_min": [
        -2466.721435546875,
        -4751.5859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2431.6435546875,
        -4734.83251953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16481725871562958,
        0.7927932739257812,
        -0.5867829322814941
      ],
      "plane_d": 4038.37451171875,
      "bbox_min": [
        -2466.721435546875,
        -4742.2685546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4734.83251953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1067.6236572265625,
      "bbox_min": [
        -2439.499755859375,
        -4749.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2431.6435546875,
        -4745.22998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2459.641845703125,
        -4721.82568359375,
        1165.623779296875
      ],
      "bbox_max": [
        -2452.15087890625,
        -4714.94970703125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2476.665771484375,
        -4763.3251953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2422.943115234375,
        -4711.40966796875,
        1212.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2476.665771484375,
        -4727.55126953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2459.910400390625,
        -4711.40966796875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4749.7685546875,
      "bbox_min": [
        -2466.974365234375,
        -4763.3251953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2422.943115234375,
        -4721.60107421875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2439.499755859375,
      "bbox_min": [
        -2439.499755859375,
        -4763.3251953125,
        1177.623779296875
      ],
      "bbox_max": [
        -2439.499755859375,
        -4749.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2704179883003235,
        -0.0,
        0.9627430438995361
      ],
      "plane_d": -466.99822998046875,
      "bbox_min": [
        -2466.974365234375,
        -4736.1494140625,
        1177.623779296875
      ],
      "bbox_max": [
        -2452.1201171875,
        -4721.60107421875,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16481725871562958,
        0.7927932739257812,
        -0.5867829322814941
      ],
      "plane_d": 4038.37451171875,
      "bbox_min": [
        -2466.974365234375,
        -4735.05908203125,
        1177.623779296875
      ],
      "bbox_max": [
        -2465.630859375,
        -4734.83251953125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.830085039138794,
        0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": -764.9303588867188,
      "bbox_min": [
        -2452.15087890625,
        -4721.82568359375,
        1177.623779296875
      ],
      "bbox_max": [
        -2452.1201171875,
        -4721.60107421875,
        1177.6793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9867106676101685,
        -0.16248691082000732
      ],
      "plane_d": 4855.64404296875,
      "bbox_min": [
        -2460.782958984375,
        -4749.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4749.7685546875,
      "bbox_min": [
        -2423.987548828125,
        -4749.7685546875,
        1177.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4749.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4402933716773987,
        -0.8978539705276489
      ],
      "plane_d": 3128.74755859375,
      "bbox_min": [
        -2460.782958984375,
        -4745.751953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4703.9345703125,
      "bbox_min": [
        -2460.782958984375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4697.26611328125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2460.782958984375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.830085039138794,
        0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": -764.9303588867188,
      "bbox_min": [
        -2459.715087890625,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2445.499755859375,
        -4711.90576171875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2459.715087890625,
        -4720.89697265625,
        1171.2027587890625
      ],
      "bbox_max": [
        -2452.85888671875,
        -4711.90576171875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4721.6357421875,
        1177.623779296875
      ],
      "bbox_max": [
        -2450.61376953125,
        -4703.9345703125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.830085039138794,
        0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": -764.9303588867188,
      "bbox_min": [
        -2452.15087890625,
        -4721.6357421875,
        1177.623779296875
      ],
      "bbox_max": [
        -2450.61376953125,
        -4703.9345703125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9199437499046326,
        -0.0,
        -0.392050564289093
      ],
      "plane_d": -1792.73876953125,
      "bbox_min": [
        -2452.15087890625,
        -4712.31005859375,
        1177.623779296875
      ],
      "bbox_max": [
        -2450.61376953125,
        -4703.9345703125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8630385398864746,
        0.5051382780075073
      ],
      "plane_d": 3457.23681640625,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2450.75732421875,
        -4701.51806640625,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9199437499046326,
        -0.0,
        -0.392050564289093
      ],
      "plane_d": -1792.73876953125,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2450.75732421875,
        -4702.94189453125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519788742065,
        0.7062519788742065,
        -0.04915514215826988
      ],
      "plane_d": 1691.9815673828125,
      "bbox_min": [
        -2459.690185546875,
        -4745.751953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4712.94091796875,
        1173.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071006298065186,
        0.7071129083633423,
        -8.641012755106203e-06
      ],
      "plane_d": 5078.04833984375,
      "bbox_min": [
        -2459.690185546875,
        -4745.751953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4712.94091796875,
        1173.5438232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2450.324462890625,
        -4745.751953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4731.087890625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        -0.7071203589439392,
        0.0
      ],
      "plane_d": -1632.8409423828125,
      "bbox_min": [
        -2436.7041015625,
        -4745.751953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2436.18212890625,
        -4745.22998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        0.7071129083633423,
        0.0
      ],
      "plane_d": 1641.5303955078125,
      "bbox_min": [
        -2459.690185546875,
        -4745.22998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2419.999755859375,
        -4712.94091796875,
        1173.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2459.690185546875,
        -4717.71484375,
        1165.623779296875
      ],
      "bbox_max": [
        -2456.48828125,
        -4712.94091796875,
        1173.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2494.9287109375,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2446.011962890625,
        -4689.19775390625,
        1188.4951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7162401676177979,
        0.6266971230506897,
        -0.3070029318332672
      ],
      "plane_d": 5074.39013671875,
      "bbox_min": [
        -2494.296875,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2459.641845703125,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2477.03076171875,
        -4714.94970703125,
        1165.623779296875
      ],
      "bbox_max": [
        -2459.641845703125,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4703.40478515625,
        1178.447265625
      ],
      "bbox_max": [
        -2446.011962890625,
        -4697.26611328125,
        1188.4951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4402933716773987,
        -0.8978539705276489
      ],
      "plane_d": 3128.74755859375,
      "bbox_min": [
        -2452.15087890625,
        -4703.40478515625,
        1178.447265625
      ],
      "bbox_max": [
        -2446.011962890625,
        -4697.26611328125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9199437499046326,
        -0.0,
        -0.392050564289093
      ],
      "plane_d": -1792.73876953125,
      "bbox_min": [
        -2452.15087890625,
        -4703.40478515625,
        1178.447265625
      ],
      "bbox_max": [
        -2450.96484375,
        -4697.26611328125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9867103099822998,
        0.0,
        -0.16248930990695953
      ],
      "plane_d": -2236.600341796875,
      "bbox_min": [
        -2501.044921875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2439.499755859375,
        -4706.22900390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2463.123046875,
        -4769.7685546875,
        1056.587158203125
      ],
      "bbox_max": [
        -2439.499755859375,
        -4739.701171875,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1177.623779296875,
      "bbox_min": [
        -2460.653076171875,
        -4769.7685546875,
        1056.587158203125
      ],
      "bbox_max": [
        -2439.499755859375,
        -4741.12744140625,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 5098.61767578125,
      "bbox_min": [
        -2442.538330078125,
        -4769.7685546875,
        1056.587158203125
      ],
      "bbox_max": [
        -2440.720947265625,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2439.499755859375,
      "bbox_min": [
        -2439.499755859375,
        -4769.7685546875,
        1177.623779296875
      ],
      "bbox_max": [
        -2439.499755859375,
        -4762.28076171875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": -81.732666015625,
      "bbox_min": [
        -2501.044921875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2440.720947265625,
        -4706.22900390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2484.2236328125,
      "bbox_min": [
        -2490.072021484375,
        -4769.7685546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4719.6396484375,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2484.2236328125,
        -4769.7685546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4719.6396484375,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      "bbox_max": [
        -2480.072021484375,
        -4734.83251953125,
        1182.84619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9781163930892944,
        -0.0,
        0.20805880427360535
      ],
      "plane_d": 2179.940185546875,
      "bbox_min": [
        -2484.2236328125,
        -4769.7685546875,
        1177.623779296875
      ],
      "bbox_max": [
        -2460.653076171875,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      "bbox_max": [
        -2480.072021484375,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2490.072021484375,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2484.2236328125,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9074113965034485,
        -0.42024338245391846
      ],
      "plane_d": 4793.0341796875,
      "bbox_min": [
        -2490.072021484375,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1355312615633011,
        -0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 829.209228515625,
      "bbox_min": [
        -2501.044921875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2440.720947265625,
        -4706.22900390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1177.6236572265625,
      "bbox_min": [
        -2501.044921875,
        -4724.6005859375,
        1177.623779296875
      ],
      "bbox_max": [
        -2482.140869140625,
        -4706.85205078125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        -0.7071203589439392,
        0.0
      ],
      "plane_d": -1632.8409423828125,
      "bbox_min": [
        -2442.538330078125,
        -4751.5859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.016357421875,
        -4751.06396484375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519192695618,
        0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": 1694.8084716796875,
      "bbox_min": [
        -2445.686279296875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2440.720947265625,
        -4767.951171875,
        1086.739013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 5098.61767578125,
      "bbox_min": [
        -2442.538330078125,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2440.720947265625,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 5098.61767578125,
      "bbox_min": [
        -2442.538330078125,
        -4768.47314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.016357421875,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2649.999755859375,
      "bbox_min": [
        -2724.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4819.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4869.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6507914066314697,
        -0.0,
        0.7592566609382629
      ],
      "plane_d": 892.8458862304688,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4829.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4829.83837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4669.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4669.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4669.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4619.837890625,
      "bbox_min": [
        -2649.999755859375,
        -4619.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4619.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4619.837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079594016075134,
        0.0,
        0.4190582036972046
      ],
      "plane_d": 1957.648193359375,
      "bbox_min": [
        -2724.999755859375,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": 1470.42578125,
      "bbox_min": [
        -2664.999755859375,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.2421875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4609.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4629.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7808688282966614,
        0.6246950626373291
      ],
      "plane_d": 2934.2470703125,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1090.123779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2920.0,
        -4835.04296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2920.0,
        -4835.04296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      "bbox_max": [
        -2916.584716796875,
        -4821.984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1112.623779296875,
      "bbox_min": [
        -2920.0,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2920.0,
        -4910.19970703125,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4605.7685546875,
      "bbox_min": [
        -2920.0,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1085.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2303.999755859375,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2299.999755859375,
      "bbox_min": [
        -2299.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2303.999755859375,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2299.999755859375,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2920.0,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1112.623779296875,
      "bbox_min": [
        -2920.0,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090860843658447,
        -0.9510340690612793
      ],
      "plane_d": 2445.8681640625,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1073.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": 3002.7373046875,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1073.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        0.980580747127533
      ],
      "plane_d": -1961.727783203125,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2654.999755859375,
      "bbox_min": [
        -2920.0,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2399.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2399.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2399.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2389.999755859375,
      "bbox_min": [
        -2399.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4319.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2389.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4319.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1077.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4569.7998046875,
        1077.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4559.7685546875,
        1077.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1077.6236572265625,
      "bbox_min": [
        -2224.77978515625,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2271.1962890625,
        -4435.0087890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1077.6236572265625,
      "bbox_min": [
        -2271.1962890625,
        -4435.0087890625,
        1077.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39169344305992126,
        -0.4453885853290558,
        0.8051118850708008
      ],
      "plane_d": -2005.3070068359375,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5756958723068237,
        0.8176640272140503
      ],
      "plane_d": -3502.085693359375,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12173735350370407,
        -0.5714139938354492,
        0.8115823864936829
      ],
      "plane_d": -3194.82470703125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1301383674144745,
        -0.47995108366012573,
        0.8675891160964966
      ],
      "plane_d": -3424.8876953125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4819210171699524,
        0.0,
        0.8762146830558777
      ],
      "plane_d": -2091.639892578125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43366071581840515,
        -0.4361818730831146,
        0.7884691953659058
      ],
      "plane_d": -3853.72216796875,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39214250445365906,
        0.443319171667099,
        0.8060349225997925
      ],
      "plane_d": 2011.6611328125,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33035221695899963,
        0.0,
        0.943857729434967
      ],
      "plane_d": -1801.946044921875,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4373.85302734375,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1726127415895462,
        0.47468501329421997,
        0.8630636930465698
      ],
      "plane_d": 1594.4031982421875,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4373.85302734375,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2302.221923828125,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2283.75439453125,
        -4440.0,
        1060.161865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2302.221923828125,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2283.75439453125,
        -4440.0,
        1060.161865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832820892333984,
        0.0,
        -0.18208926916122437
      ],
      "plane_d": 2455.4052734375,
      "bbox_min": [
        -2302.221923828125,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2294.49951171875,
        -4440.0,
        1060.161865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2302.221923828125,
        -4440.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2294.49951171875,
        -4440.0,
        1054.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.33035042881965637,
        0.9438584446907043
      ],
      "plane_d": 454.350830078125,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1053.5238037109375
      ],
      "bbox_max": [
        -2270.0,
        -4373.85302734375,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13031168282032013,
        0.47780948877334595,
        0.8687445521354675
      ],
      "plane_d": 1504.557861328125,
      "bbox_min": [
        -2350.0,
        -4520.0,
        1053.5238037109375
      ],
      "bbox_max": [
        -2270.0,
        -4433.26123046875,
        1100.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2301.785400390625,
        -4449.7685546875,
        1053.5238037109375
      ],
      "bbox_max": [
        -2282.262451171875,
        -4440.0,
        1060.608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2301.785400390625,
        -4449.7685546875,
        1053.5238037109375
      ],
      "bbox_max": [
        -2282.262451171875,
        -4440.0,
        1060.608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832820892333984,
        0.0,
        -0.18208926916122437
      ],
      "plane_d": 2455.4052734375,
      "bbox_min": [
        -2301.785400390625,
        -4449.7685546875,
        1053.5238037109375
      ],
      "bbox_max": [
        -2282.262451171875,
        -4440.0,
        1060.608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2301.785400390625,
        -4449.7685546875,
        1053.5238037109375
      ],
      "bbox_max": [
        -2282.262451171875,
        -4440.0,
        1057.835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2282.499755859375,
        -4449.7685546875,
        1057.123779296875
      ],
      "bbox_max": [
        -2282.262451171875,
        -4448.4091796875,
        1057.835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1854955554008484,
        0.3246172070503235,
        0.9274778366088867
      ],
      "plane_d": 882.3801879882812,
      "bbox_min": [
        -2350.0,
        -4480.0,
        1054.0404052734375
      ],
      "bbox_max": [
        -2270.0,
        -4433.26123046875,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.30710282921791077,
        0.31438666582107544,
        0.8982476592063904
      ],
      "plane_d": 1148.988525390625,
      "bbox_min": [
        -2310.0,
        -4480.0,
        1054.0404052734375
      ],
      "bbox_max": [
        -2281.078857421875,
        -4440.0,
        1078.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2301.71142578125,
        -4449.7685546875,
        1054.0404052734375
      ],
      "bbox_max": [
        -2282.0458984375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2301.71142578125,
        -4449.7685546875,
        1054.0404052734375
      ],
      "bbox_max": [
        -2282.0458984375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832820892333984,
        0.0,
        -0.18208926916122437
      ],
      "plane_d": 2455.4052734375,
      "bbox_min": [
        -2301.71142578125,
        -4449.7685546875,
        1055.3804931640625
      ],
      "bbox_max": [
        -2282.0458984375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2282.499755859375,
        -4449.7685546875,
        1057.123779296875
      ],
      "bbox_max": [
        -2282.0458984375,
        -4445.4345703125,
        1058.4854736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13730518519878387,
        0.37848222255706787,
        0.9153679013252258
      ],
      "plane_d": 1025.437744140625,
      "bbox_min": [
        -2310.0,
        -4480.0,
        1056.23486328125
      ],
      "bbox_max": [
        -2281.078857421875,
        -4440.0,
        1078.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2285.462890625,
        -4449.7685546875,
        1056.23486328125
      ],
      "bbox_max": [
        -2281.078857421875,
        -4440.0,
        1061.3863525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2285.462890625,
        -4445.4345703125,
        1056.23486328125
      ],
      "bbox_max": [
        -2282.499755859375,
        -4440.0,
        1057.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2310.0,
        -4462.3154296875,
        1058.5189208984375
      ],
      "bbox_max": [
        -2282.265380859375,
        -4440.0,
        1067.9439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2558195888996124,
        0.9667245149612427
      ],
      "plane_d": 109.1400146484375,
      "bbox_min": [
        -2299.999755859375,
        -4462.3154296875,
        1064.623779296875
      ],
      "bbox_max": [
        -2287.54931640625,
        -4449.7685546875,
        1067.9439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832820892333984,
        0.0,
        -0.18208926916122437
      ],
      "plane_d": 2455.4052734375,
      "bbox_min": [
        -2300.59521484375,
        -4449.7685546875,
        1061.408447265625
      ],
      "bbox_max": [
        -2299.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.7052001953125,
      "bbox_min": [
        -2310.0,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2303.66162109375,
        -4435.251953125,
        1067.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32444286346435547,
        -0.4866642951965332,
        0.8111071586608887
      ],
      "plane_d": -2274.8505859375,
      "bbox_min": [
        -2310.0,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2305.584228515625,
        -4435.251953125,
        1067.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2297.0751953125,
        -4449.7685546875,
        1060.8121337890625
      ],
      "bbox_max": [
        -2284.123046875,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2300.35693359375,
        -4440.0,
        1062.038818359375
      ],
      "bbox_max": [
        -2293.462890625,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.7052001953125,
      "bbox_min": [
        -2310.0,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2298.776611328125,
        -4436.8310546875,
        1065.257568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1070.2652587890625
      ],
      "bbox_max": [
        -2317.990478515625,
        -4373.85302734375,
        1077.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16903086006641388,
        -0.5070925951004028,
        0.8451542854309082
      ],
      "plane_d": -2760.80126953125,
      "bbox_min": [
        -2350.0,
        -4440.0,
        1070.2652587890625
      ],
      "bbox_max": [
        -2317.990478515625,
        -4431.57958984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23570361733436584,
        -0.23570217192173004,
        0.9428086876869202
      ],
      "plane_d": -2611.7001953125,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2324.739013671875,
        -4373.85302734375,
        1077.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24253705143928528,
        0.0,
        0.9701422452926636
      ],
      "plane_d": -1620.26123046875,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2324.739013671875,
        -4373.85302734375,
        1077.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16903086006641388,
        -0.5070925951004028,
        0.8451542854309082
      ],
      "plane_d": -2760.80126953125,
      "bbox_min": [
        -2350.0,
        -4440.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2324.739013671875,
        -4418.84912109375,
        1077.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14400461316108704,
        -0.2400076985359192,
        0.9600307941436768
      ],
      "plane_d": -2433.796875,
      "bbox_min": [
        -2350.0,
        -4440.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2338.220947265625,
        -4418.84912109375,
        1077.9114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32461899518966675,
        0.18549543619155884,
        0.927477240562439
      ],
      "plane_d": -939.6539306640625,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4480.0,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1455213725566864,
        0.19402849674224854,
        0.9701425433158875
      ],
      "plane_d": -526.9075317382812,
      "bbox_min": [
        -2350.0,
        -4520.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4480.0,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1056.964111328125
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.17092366516590118,
        0.19323012232780457,
        0.9661506414413452
      ],
      "plane_d": -558.6419677734375,
      "bbox_min": [
        -2324.7392578125,
        -4480.0,
        1056.964111328125
      ],
      "bbox_max": [
        -2224.77978515625,
        -4400.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18815985321998596,
        0.19261319935321808,
        0.963066041469574
      ],
      "plane_d": -597.2233276367188,
      "bbox_min": [
        -2291.102783203125,
        -4480.0,
        1056.964111328125
      ],
      "bbox_max": [
        -2270.0,
        -4440.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2290.53125,
        -4449.7685546875,
        1056.964111328125
      ],
      "bbox_max": [
        -2279.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578263759613037
      ],
      "plane_d": -1668.4124755859375,
      "bbox_min": [
        -2283.031982421875,
        -4440.76123046875,
        1056.964111328125
      ],
      "bbox_max": [
        -2282.499755859375,
        -4440.0,
        1057.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2558195888996124,
        0.9667245149612427
      ],
      "plane_d": 109.1400146484375,
      "bbox_min": [
        -2291.102783203125,
        -4480.0,
        1060.6124267578125
      ],
      "bbox_max": [
        -2270.0,
        -4440.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.623779296875,
      "bbox_min": [
        -2284.612060546875,
        -4449.7685546875,
        1062.038818359375
      ],
      "bbox_max": [
        -2270.0,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2284.612060546875,
        -4449.7685546875,
        1062.038818359375
      ],
      "bbox_max": [
        -2279.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2284.612060546875,
        -4440.0,
        1062.038818359375
      ],
      "bbox_max": [
        -2280.62646484375,
        -4440.0,
        1062.743896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16590309143066406,
        -0.07317177951335907,
        0.9834237098693848
      ],
      "plane_d": -1748.458984375,
      "bbox_min": [
        -2324.7392578125,
        -4480.0,
        1060.8905029296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4400.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4439.99951171875,
      "bbox_min": [
        -2291.366943359375,
        -4440.31689453125,
        1060.8905029296875
      ],
      "bbox_max": [
        -2280.595703125,
        -4440.0,
        1062.836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2280.62646484375,
        -4440.31689453125,
        1062.743896484375
      ],
      "bbox_max": [
        -2280.595703125,
        -4440.0,
        1062.836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.7052001953125,
      "bbox_min": [
        -2324.7392578125,
        -4480.0,
        1061.01904296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4400.0,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32444286346435547,
        -0.4866642951965332,
        0.8111071586608887
      ],
      "plane_d": -2274.8505859375,
      "bbox_min": [
        -2324.7392578125,
        -4480.0,
        1063.71240234375
      ],
      "bbox_max": [
        -2224.77978515625,
        -4400.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2287.7333984375,
        -4449.7685546875,
        1063.7559814453125
      ],
      "bbox_max": [
        -2281.0439453125,
        -4449.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -2499.661376953125,
      "bbox_min": [
        -2280.303466796875,
        -4448.8447265625,
        1063.71240234375
      ],
      "bbox_max": [
        -2279.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        -0.0,
        0.9284766912460327
      ],
      "plane_d": -152.849365234375,
      "bbox_min": [
        -2389.999755859375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3299831449985504,
        0.0471404492855072,
        0.9428090453147888
      ],
      "plane_d": -56.68536376953125,
      "bbox_min": [
        -2389.999755859375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24253705143928528,
        0.0,
        0.9701422452926636
      ],
      "plane_d": -1620.26123046875,
      "bbox_min": [
        -2389.999755859375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1481594443321228,
        0.04938647896051407,
        0.9877296090126038
      ],
      "plane_d": -1200.2138671875,
      "bbox_min": [
        -2389.999755859375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4202214479446411,
        0.9074215888977051
      ],
      "plane_d": 846.1397094726562,
      "bbox_min": [
        -2389.999755859375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.14400461316108704,
        -0.2400076985359192,
        0.9600307941436768
      ],
      "plane_d": -2433.796875,
      "bbox_min": [
        -2370.47412109375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4400.0,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16903086006641388,
        -0.5070925951004028,
        0.8451542854309082
      ],
      "plane_d": -2760.80126953125,
      "bbox_min": [
        -2370.47412109375,
        -4431.57958984375,
        1072.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4400.0,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23570361733436584,
        -0.23570217192173004,
        0.9428086876869202
      ],
      "plane_d": -2611.7001953125,
      "bbox_min": [
        -2370.47412109375,
        -4418.84912109375,
        1077.5052490234375
      ],
      "bbox_max": [
        -2350.0,
        -4400.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": -1311.084716796875,
      "bbox_min": [
        -2369.99853515625,
        -4400.0,
        1077.6241455078125
      ],
      "bbox_max": [
        -2310.0,
        -4352.87744140625,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09451575577259064,
        0.31264054775238037,
        0.945157527923584
      ],
      "plane_d": 117.750732421875,
      "bbox_min": [
        -2369.99853515625,
        -4360.0,
        1077.6241455078125
      ],
      "bbox_max": [
        -2310.0,
        -4352.87744140625,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2309373915195465,
        0.3055573105812073,
        0.9237438440322876
      ],
      "plane_d": -210.5400390625,
      "bbox_min": [
        -2369.99853515625,
        -4360.0,
        1077.6241455078125
      ],
      "bbox_max": [
        -2350.0,
        -4352.87744140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25765591859817505,
        0.11363762617111206,
        0.9595310688018799
      ],
      "plane_d": 47.9959716796875,
      "bbox_min": [
        -2310.0,
        -4360.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33035042881965637,
        0.0,
        0.9438583850860596
      ],
      "plane_d": -262.509521484375,
      "bbox_min": [
        -2310.0,
        -4360.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4329.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4202214479446411,
        0.9074215888977051
      ],
      "plane_d": 846.1396484375,
      "bbox_min": [
        -2310.0,
        -4360.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2271.1962890625,
        -4329.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2350.0,
        -4520.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2350.0,
        -4548.92236328125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4840677082538605,
        0.8750306367874146
      ],
      "plane_d": -3145.8154296875,
      "bbox_min": [
        -2310.0,
        -4559.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4520.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2270.0,
        -4559.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4520.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4067424237728119,
        -0.9135428071022034,
        0.0
      ],
      "plane_d": -2941.075927734375,
      "bbox_min": [
        -2342.36767578125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067084789276123,
        0.9135580062866211,
        0.0
      ],
      "plane_d": 2985.219970703125,
      "bbox_min": [
        -2342.36767578125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4307.7685546875,
      "bbox_min": [
        -2319.997314453125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4283.1005859375,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2269.969970703125,
        -4283.1005859375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9079594612121582,
        -0.419058233499527,
        0.0
      ],
      "plane_d": -3888.06494140625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1104.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079594612121582,
        0.419058233499527,
        -0.0
      ],
      "plane_d": 3895.32861328125,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1104.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3896400034427643,
        -0.9209672212600708
      ],
      "plane_d": -644.232666015625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1104.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3896400034427643,
        0.9209672212600708
      ],
      "plane_d": 655.2843017578125,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1104.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1111.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2269.969970703125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4307.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079594612121582,
        0.419058233499527,
        -0.0
      ],
      "plane_d": 3895.32861328125,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1100.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1117.6470947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9079594612121582,
        -0.419058233499527,
        0.0
      ],
      "plane_d": -3888.06494140625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1100.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1117.6470947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3896400034427643,
        -0.9209672212600708
      ],
      "plane_d": -644.232666015625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1100.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1117.6470947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3896400034427643,
        0.9209672212600708
      ],
      "plane_d": 655.2843017578125,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1100.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4281.7685546875,
      "bbox_min": [
        -2314.0,
        -4281.7685546875,
        1100.0
      ],
      "bbox_max": [
        -2306.0,
        -4281.7685546875,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.0,
        0.9363292455673218
      ],
      "plane_d": -1828.298583984375,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4299.7685546875,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1075.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4279.7685546875,
      "bbox_min": [
        -2399.999755859375,
        -4299.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2359.999755859375,
        -4299.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2339.999755859375,
      "bbox_min": [
        -2339.999755859375,
        -4299.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2339.999755859375,
      "bbox_min": [
        -2359.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4299.7685546875,
        1075.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 968.0032348632812,
      "bbox_min": [
        -2359.999755859375,
        -4319.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4299.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -2359.99951171875,
      "bbox_min": [
        -2359.999755859375,
        -4319.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4299.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2339.999755859375,
      "bbox_min": [
        -2339.999755859375,
        -4319.7685546875,
        1075.123779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4314.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2654.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2465.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": 173.8419189453125,
      "bbox_min": [
        -2654.999755859375,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.874267578125,
        -4250.69189453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        -0.8660230040550232,
        -0.0
      ],
      "plane_d": -5008.6455078125,
      "bbox_min": [
        -2654.874267578125,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745972871780396,
        -0.4472154378890991,
        0.44721055030822754
      ],
      "plane_d": -333.14947509765625,
      "bbox_min": [
        -2654.874267578125,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2654.874267578125,
        -4255.69189453125,
        1072.623779296875
      ],
      "bbox_max": [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2596.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2467.999755859375,
        -4383.7685546875,
        1120.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2639.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1104.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9391745328903198,
        0.0,
        -0.34344035387039185
      ],
      "plane_d": 2835.041015625,
      "bbox_min": [
        -2633.72509765625,
        -4525.96875,
        1052.623779296875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4411.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2625.0,
      "bbox_min": [
        -2625.0,
        -4525.96875,
        1076.4830322265625
      ],
      "bbox_max": [
        -2619.09765625,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2625.0,
        -4525.96875,
        1076.4830322265625
      ],
      "bbox_max": [
        -2619.09765625,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.7685546875,
        1076.4830322265625
      ],
      "bbox_max": [
        -2619.09765625,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.7685546875,
        1076.4830322265625
      ],
      "bbox_max": [
        -2619.09765625,
        -4439.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1076.48388671875
      ],
      "bbox_max": [
        -2619.09765625,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1081.6239013671875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1076.48388671875
      ],
      "bbox_max": [
        -2623.1201171875,
        -4509.7685546875,
        1081.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.96875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1076.48388671875
      ],
      "bbox_max": [
        -2623.1201171875,
        -4525.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9389656186103821,
        -0.0,
        -0.344011127948761
      ],
      "plane_d": -2085.0859375,
      "bbox_min": [
        -2633.72509765625,
        -4525.96875,
        1052.623779296875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4411.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2615.0,
      "bbox_min": [
        -2620.01171875,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1081.6239013671875,
      "bbox_min": [
        -2615.0,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4515.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.6239013671875,
      "bbox_min": [
        -2615.0,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4515.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.96875,
      "bbox_min": [
        -2615.0,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2604.999755859375,
        -4515.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2605.60009765625,
      "bbox_min": [
        -2605.60009765625,
        -4522.7998046875,
        1075.0
      ],
      "bbox_max": [
        -2605.0,
        -4519.7998046875,
        1077.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1077.0,
      "bbox_min": [
        -2605.60009765625,
        -4522.7998046875,
        1075.0
      ],
      "bbox_max": [
        -2605.0,
        -4519.7998046875,
        1077.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4522.7998046875,
      "bbox_min": [
        -2605.60009765625,
        -4522.7998046875,
        1075.0
      ],
      "bbox_max": [
        -2605.0,
        -4519.7998046875,
        1077.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4519.7998046875,
      "bbox_min": [
        -2605.60009765625,
        -4519.7998046875,
        1075.0
      ],
      "bbox_max": [
        -2605.0,
        -4519.7998046875,
        1077.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -2620.01171875,
        -4439.7685546875,
        1076.4449462890625
      ],
      "bbox_max": [
        -2615.0,
        -4439.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2620.01171875,
        -4525.96875,
        1076.4449462890625
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1081.6239013671875,
      "bbox_min": [
        -2616.897216796875,
        -4525.96875,
        1076.4449462890625
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1081.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.96875,
      "bbox_min": [
        -2616.897216796875,
        -4525.96875,
        1076.4449462890625
      ],
      "bbox_max": [
        -2615.0,
        -4525.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382688045501709,
        0.0,
        -0.9238776564598083
      ],
      "plane_d": -22.7559814453125,
      "bbox_min": [
        -2633.72509765625,
        -4525.96875,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.2724609375,
        -4411.7685546875,
        1090.1243896484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2625.0,
        -4525.96875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2613.23388671875,
        -4429.7685546875,
        1090.1243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.78173828125,
        1058.552734375
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1090.1243896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.78173828125,
        1058.552734375
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1090.1243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.78173828125,
      "bbox_min": [
        -2619.999755859375,
        -4439.78173828125,
        1058.552734375
      ],
      "bbox_max": [
        -2615.0,
        -4439.78173828125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2615.0,
      "bbox_min": [
        -2625.0,
        -4439.7685546875,
        1058.552734375
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1076.483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2625.0,
      "bbox_min": [
        -2625.0,
        -4439.7685546875,
        1062.6949462890625
      ],
      "bbox_max": [
        -2625.0,
        -4429.7685546875,
        1076.483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2613.23388671875,
        -4499.7685546875,
        1090.1243896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.6239013671875,
      "bbox_min": [
        -2614.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2613.23388671875,
        -4515.96875,
        1076.4443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.96875,
      "bbox_min": [
        -2614.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2613.23388671875,
        -4515.96875,
        1076.4443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4515.96875,
      "bbox_min": [
        -2614.999755859375,
        -4515.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2613.23388671875,
        -4515.96875,
        1076.4443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2624.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1090.1243896484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1090.1243896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.6239013671875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1081.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1081.6239013671875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1081.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.96875,
      "bbox_min": [
        -2624.999755859375,
        -4525.96875,
        1071.6239013671875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4525.96875,
        1081.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382688045501709,
        0.0,
        -0.9238776564598083
      ],
      "plane_d": 1982.529296875,
      "bbox_min": [
        -2633.72509765625,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.2724609375,
        -4411.7685546875,
        1062.6949462890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2625.0,
      "bbox_min": [
        -2625.0,
        -4509.7685546875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4429.7685546875,
        1062.6949462890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2625.0,
        -4509.7685546875,
        1058.5526123046875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4429.7685546875,
        1062.6949462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.78173828125,
        1058.5526123046875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4429.7685546875,
        1062.6949462890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -2625.0,
        -4439.78173828125,
        1058.5526123046875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4439.7685546875,
        1062.6949462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.78173828125,
      "bbox_min": [
        -2625.0,
        -4439.78173828125,
        1058.5526123046875
      ],
      "bbox_max": [
        -2619.999755859375,
        -4439.78173828125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1058.5528564453125
      ],
      "bbox_max": [
        -2620.0,
        -4509.7685546875,
        1062.69482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810884416103363,
        -0.6785971522331238,
        -0.6785979866981506
      ],
      "plane_d": -1543.053466796875,
      "bbox_min": [
        -2633.72509765625,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.2724609375,
        -4411.7685546875,
        1060.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1060.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1060.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4499.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1060.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810884416103363,
        0.6785971522331238,
        -0.6785979866981506
      ],
      "plane_d": 3030.029541015625,
      "bbox_min": [
        -2633.72509765625,
        -4499.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.2724609375,
        -4415.91064453125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954364776611328,
        -0.6719008684158325,
        -0.2547887861728668
      ],
      "plane_d": -4513.94677734375,
      "bbox_min": [
        -2633.72509765625,
        -4493.62646484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.2724609375,
        -4415.91064453125,
        1055.3516845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.695679783821106,
        0.6717967987060547,
        -0.2543984055519104
      ],
      "plane_d": 5116.22705078125,
      "bbox_min": [
        -2633.72509765625,
        -4493.62646484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4415.91064453125,
        1055.3516845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.695679783821106,
        -0.6717967987060547,
        -0.2543984055519104
      ],
      "plane_d": -869.1712036132812,
      "bbox_min": [
        -2633.72509765625,
        -4419.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2629.999755859375,
        -4415.91064453125,
        1055.3516845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2629.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2609.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7864406108856201,
        0.6176660060882568
      ],
      "plane_d": 2798.974365234375,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.42383554577827454,
        0.9057391881942749
      ],
      "plane_d": 876.9922485351562,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.96592116355896,
        0.25883668661117554
      ],
      "plane_d": 3986.3369140625,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4498.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2613.999755859375,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4510.7685546875,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2625.999755859375,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1098.6236572265625,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2624.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4509.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2625.0,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2625.0,
        -4449.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2615.0,
      "bbox_min": [
        -2625.0,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2615.0,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4449.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.0,
      "bbox_min": [
        -2625.0,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2625.0,
        -4449.7685546875,
        1102.0
      ],
      "bbox_max": [
        -2615.0,
        -4449.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2625.0,
        -4429.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4529.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2600.0,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2619.999755859375,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2616.999755859375,
      "bbox_min": [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4397.7685546875,
      "bbox_min": [
        -2639.999755859375,
        -4397.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.630307137966156,
        0.7763458490371704,
        0.0
      ],
      "plane_d": 1775.782958984375,
      "bbox_min": [
        -2607.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1055.6236572265625,
      "bbox_min": [
        -2607.999755859375,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6823182702064514,
        0.0,
        -0.7310552597045898
      ],
      "plane_d": -1014.9796142578125,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1080.1236572265625,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2646.999755859375,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1242.9302978515625,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812382102012634,
        -0.8137334585189819,
        0.0
      ],
      "plane_d": -5196.0810546875,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4494.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4446.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2467.999755859375,
        -4387.04248046875,
        1103.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1060.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4387.04248046875,
        1094.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1055.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2570.999755859375,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4469.7685546875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5003462433815002,
        0.8658254146575928,
        0.0
      ],
      "plane_d": 2523.86083984375,
      "bbox_min": [
        -2596.999755859375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2556.294677734375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2556.294677734375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2556.294677734375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2556.294677734375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2556.294677734375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2536.790771484375,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4391.6533203125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2526.444580078125,
        -4463.0634765625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4396.4736328125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2526.444580078125,
        -4426.98193359375,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4396.4736328125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6573646068572998,
        0.7535727620124817,
        -0.0
      ],
      "plane_d": 4973.85791015625,
      "bbox_min": [
        -2526.444580078125,
        -4399.478515625,
        1055.623779296875
      ],
      "bbox_max": [
        -2522.999755859375,
        -4396.4736328125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6573646068572998,
        0.7535727620124817,
        -0.0
      ],
      "plane_d": 4973.85791015625,
      "bbox_min": [
        -2531.97021484375,
        -4397.21630859375,
        1055.623779296875
      ],
      "bbox_max": [
        -2525.5927734375,
        -4391.6533203125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18456201255321503,
        0.9828208684921265,
        0.0
      ],
      "plane_d": 3843.395751953125,
      "bbox_min": [
        -2552.19384765625,
        -4392.142578125,
        1055.623779296875
      ],
      "bbox_max": [
        -2531.4091796875,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6573646068572998,
        0.7535727620124817,
        -0.0
      ],
      "plane_d": 4973.85791015625,
      "bbox_min": [
        -2537.255859375,
        -4392.142578125,
        1055.623779296875
      ],
      "bbox_max": [
        -2531.4091796875,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001743542612530291,
        0.9999985694885254,
        0.0
      ],
      "plane_d": 4400.234375,
      "bbox_min": [
        -2596.999755859375,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2577.956298828125,
        -4404.7353515625,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2495.8037109375,
        -4449.65869140625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4423.83447265625,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2495.8037109375,
        -4449.65869140625,
        1055.623779296875
      ],
      "bbox_max": [
        -2489.704833984375,
        -4443.251953125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2570.999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4389.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4389.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4429.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2591.999755859375,
      "bbox_min": [
        -2591.999755859375,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2591.999755859375,
        -4429.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8803223967552185,
        0.4743761122226715,
        0.0
      ],
      "plane_d": 4352.82568359375,
      "bbox_min": [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4389.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27596062421798706,
        0.9611689448356628,
        -0.0
      ],
      "plane_d": 4932.6669921875,
      "bbox_min": [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2577.999755859375,
        -4389.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27596062421798706,
        0.9611689448356628,
        0.0
      ],
      "plane_d": 3505.950927734375,
      "bbox_min": [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2584.999755859375,
        -4389.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.630307137966156,
        0.7763458490371704,
        0.0
      ],
      "plane_d": 1775.782958984375,
      "bbox_min": [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2591.999755859375,
        -4391.7783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732266068458557,
        -0.22984769940376282,
        -5.612131985799351e-07
      ],
      "plane_d": 1406.2392578125,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2570.999755859375,
        -4469.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2570.999755859375,
        -4463.50927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4396.02783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2570.999755859375,
        -4463.50927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4415.79248046875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2570.716552734375,
        -4463.50927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4415.79248046875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2556.74072265625,
        -4463.50927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4415.79248046875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2556.74072265625,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4415.79248046875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2556.74072265625,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2555.18212890625,
        -4429.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2567.216552734375,
        -4433.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2556.294677734375,
        -4433.2685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4433.2685546875,
      "bbox_min": [
        -2570.999755859375,
        -4463.50927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2538.206787109375,
        -4433.2685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.7685546875,
      "bbox_min": [
        -2570.999755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2570.086181640625,
        -4429.7685546875,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2538.206787109375,
      "bbox_min": [
        -2538.206787109375,
        -4469.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2538.206787109375,
        -4463.0634765625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2495.99853515625,
        -4450.484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4421.947265625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2495.99853515625,
        -4450.484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2489.259033203125,
        -4443.56005859375,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1072.5,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4471.568359375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1072.5
      ],
      "bbox_max": [
        -2492.212890625,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2516.999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1072.5
      ],
      "bbox_max": [
        -2516.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4506.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4506.7685546875,
        1072.5
      ],
      "bbox_max": [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2559.999755859375,
      "bbox_min": [
        -2559.999755859375,
        -4506.7685546875,
        1072.5
      ],
      "bbox_max": [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2542.0,
      "bbox_min": [
        -2553.78662109375,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2492.212890625,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9894623160362244,
        0.0,
        0.14479120075702667
      ],
      "plane_d": -2682.164306640625,
      "bbox_min": [
        -2553.78662109375,
        -4454.3076171875,
        1072.5
      ],
      "bbox_max": [
        -2542.0,
        -4405.2294921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996562480926514,
        0.6996562480926514,
        0.14478379487991333
      ],
      "plane_d": 1148.3394775390625,
      "bbox_min": [
        -2553.78662109375,
        -4417.0234375,
        1072.5
      ],
      "bbox_max": [
        -2542.0,
        -4405.2294921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6996592283248901,
        0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": 4678.76513671875,
      "bbox_min": [
        -2504.0,
        -4417.0234375,
        1072.5
      ],
      "bbox_max": [
        -2492.212890625,
        -4405.22900390625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996562480926514,
        0.6996562480926514,
        0.14478379487991333
      ],
      "plane_d": 1148.3394775390625,
      "bbox_min": [
        -2542.0,
        -4405.2548828125,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2518.0,
      "bbox_min": [
        -2542.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4450.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6996593475341797,
        -0.6996498107910156,
        0.14479993283748627
      ],
      "plane_d": -1519.806884765625,
      "bbox_min": [
        -2518.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4454.28271484375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2518.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4460.53759765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2526.199951171875,
      "bbox_min": [
        -2542.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2526.199951171875,
        -4450.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": -4568.84033203125,
      "bbox_min": [
        -2542.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2526.199951171875,
        -4454.2822265625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996592283248901,
        -0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": -5050.2880859375,
      "bbox_min": [
        -2542.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2535.74462890625,
        -4454.2822265625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2512.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4410.0,
        1072.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4430.0,
      "bbox_min": [
        -2512.0,
        -4442.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4438.0,
      "bbox_min": [
        -2512.0,
        -4442.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4438.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4442.0,
      "bbox_min": [
        -2512.0,
        -4442.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4442.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4424.0,
      "bbox_min": [
        -2512.0,
        -4424.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4416.0,
      "bbox_min": [
        -2512.0,
        -4416.0,
        1072.5
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4423.0,
      "bbox_min": [
        -2542.0,
        -4431.0,
        1072.5
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2534.0,
      "bbox_min": [
        -2542.0,
        -4431.0,
        1072.5
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4431.0,
      "bbox_min": [
        -2542.0,
        -4431.0,
        1072.5
      ],
      "bbox_max": [
        -2534.0,
        -4431.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4418.0,
      "bbox_min": [
        -2542.0,
        -4418.0,
        1072.5
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2534.0,
      "bbox_min": [
        -2534.0,
        -4418.0,
        1072.5
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        -0.0,
        0.9486833214759827
      ],
      "plane_d": -197.44366455078125,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2579.999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4459.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4428.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2570.999755859375,
      "bbox_min": [
        -2579.999755859375,
        -4459.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4428.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4459.7685546875,
      "bbox_min": [
        -2579.999755859375,
        -4459.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4428.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4428.7685546875,
      "bbox_min": [
        -2579.999755859375,
        -4428.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4428.7685546875,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2596.999755859375,
        -4454.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4434.7685546875,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4439.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4454.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4434.7685546875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4434.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4434.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4434.7685546875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4454.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4454.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4449.7685546875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4449.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4449.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2579.999755859375,
        -4449.7685546875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36142003536224365,
        -0.9324031472206116
      ],
      "plane_d": -615.5921630859375,
      "bbox_min": [
        -2563.361083984375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2555570602416992,
        -0.2555605471134186,
        -0.9324051737785339
      ],
      "plane_d": 498.11358642578125,
      "bbox_min": [
        -2563.361083984375,
        -4470.1298828125,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36142000555992126,
        0.0,
        -0.9324030876159668
      ],
      "plane_d": 1897.277587890625,
      "bbox_min": [
        -2563.361083984375,
        -4470.1298828125,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2555570602416992,
        0.2555605471134186,
        -0.9324051737785339
      ],
      "plane_d": 1472.720947265625,
      "bbox_min": [
        -2563.361083984375,
        -4470.1298828125,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36142000555992126,
        -0.0,
        -0.9324030876159668
      ],
      "plane_d": 73.5523681640625,
      "bbox_min": [
        -2563.361083984375,
        -4470.1298828125,
        1062.0474853515625
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25556325912475586,
        -0.25556325912475586,
        -0.9324026703834534
      ],
      "plane_d": -791.457763671875,
      "bbox_min": [
        -2563.361083984375,
        -4470.1298828125,
        1062.047607421875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.36142003536224365,
        -0.9324031472206116
      ],
      "plane_d": 2586.422119140625,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1062.047607421875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25556325912475586,
        0.25556325912475586,
        -0.9324026703834534
      ],
      "plane_d": 2762.28662109375,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1065.5755615234375
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994255781173706,
        -0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": -5051.04931640625,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2554.30810546875,
        -4461.0771484375,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2554.30810546875,
        -4442.73681640625,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2554.30810546875,
        -4442.73681640625,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2535.968017578125,
        -4442.73681640625,
        1068.9908447265625
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2535.968017578125,
        -4398.9814453125,
        1068.9908447265625
      ],
      "bbox_max": [
        -2510.03125,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2510.03125,
        -4416.80029296875,
        1065.5755615234375
      ],
      "bbox_max": [
        -2491.69140625,
        -4398.4599609375,
        1068.9910888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2535.968017578125,
        -4407.271484375,
        1062.047607421875
      ],
      "bbox_max": [
        -2500.50244140625,
        -4397.42822265625,
        1068.9910888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994255781173706,
        0.6994255781173706,
        0.14699529111385345
      ],
      "plane_d": 4674.8388671875,
      "bbox_min": [
        -2510.03125,
        -4407.271484375,
        1062.047607421875
      ],
      "bbox_max": [
        -2500.50244140625,
        -4397.42822265625,
        1068.9910888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9891370534896851,
        0.0,
        0.1469961553812027
      ],
      "plane_d": -2683.698486328125,
      "bbox_min": [
        -2555.33984375,
        -4452.26611328125,
        1062.0474853515625
      ],
      "bbox_max": [
        -2545.496826171875,
        -4416.80029296875,
        1068.9908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2536.48291015625,
        -4398.4599609375,
        1060.623779296875
      ],
      "bbox_max": [
        -2509.60400390625,
        -4397.216796875,
        1068.9908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2510.03125,
        -4461.0771484375,
        1060.623779296875
      ],
      "bbox_max": [
        -2490.447998046875,
        -4413.6259765625,
        1068.9908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6994260549545288,
        -0.6994260549545288,
        0.14699110388755798
      ],
      "plane_d": -1521.744384765625,
      "bbox_min": [
        -2555.551513671875,
        -4462.3203125,
        1060.623779296875
      ],
      "bbox_max": [
        -2490.447998046875,
        -4439.4912109375,
        1068.9908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": -4569.751953125,
      "bbox_min": [
        -2555.551513671875,
        -4462.3203125,
        1060.623779296875
      ],
      "bbox_max": [
        -2490.447998046875,
        -4439.4912109375,
        1068.9908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9891370534896851,
        -0.0,
        0.1469961553812027
      ],
      "plane_d": 2307.48681640625,
      "bbox_min": [
        -2555.551513671875,
        -4443.251953125,
        1060.623779296875
      ],
      "bbox_max": [
        -2490.447998046875,
        -4439.4912109375,
        1062.0474853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2516.999755859375,
      "bbox_min": [
        -2519.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4506.7685546875,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4506.7685546875,
      "bbox_min": [
        -2519.999755859375,
        -4506.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4506.7685546875,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2589.999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1082.6236572265625,
      "bbox_min": [
        -2596.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 4946.04833984375,
      "bbox_min": [
        -2596.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5812382102012634,
        -0.8137334585189819,
        0.0
      ],
      "plane_d": -2152.13671875,
      "bbox_min": [
        -2596.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4494.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1075.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4506.7685546875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2538.794921875,
        -4429.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5066525340080261,
        0.8621503710746765
      ],
      "plane_d": 1291.64892578125,
      "bbox_min": [
        -2538.794921875,
        -4422.5,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2538.794921875,
        -4422.5,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.623779296875,
      "bbox_min": [
        -2531.188232421875,
        -4422.5,
        1082.623779296875
      ],
      "bbox_max": [
        -2514.8115234375,
        -4410.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2526.0107421875,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2519.989013671875,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2531.188232421875,
        -4410.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2514.8115234375,
        -4410.0,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": 4197.337890625,
      "bbox_min": [
        -2535.744384765625,
        -4410.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4398.99951171875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2531.1884765625,
        -4410.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2514.8115234375,
        -4410.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2522.999755859375,
        -4429.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.623779296875,
      "bbox_min": [
        -2519.989013671875,
        -4426.869140625,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4410.0,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2516.0,
      "bbox_min": [
        -2519.989013671875,
        -4426.869140625,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2519.989013671875,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2514.8115234375,
        -4410.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4410.0,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2514.8115234375,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4410.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2512.0,
      "bbox_min": [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4416.0,
      "bbox_min": [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4416.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4424.0,
      "bbox_min": [
        -2512.0,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2509.072998046875,
        -4424.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5066569447517395,
        -0.0,
        0.8621476888656616
      ],
      "plane_d": 325.5936279296875,
      "bbox_min": [
        -2516.0,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2516.0,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.623779296875,
      "bbox_min": [
        -2516.0,
        -4437.638671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4421.89892578125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2516.0,
      "bbox_min": [
        -2516.0,
        -4432.66796875,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2504.0,
      "bbox_min": [
        -2504.0,
        -4437.638671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4421.89892578125,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9894623160362244,
        -0.0,
        0.14479120075702667
      ],
      "plane_d": 2310.662109375,
      "bbox_min": [
        -2512.0,
        -4442.513671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2492.23095703125,
        -4417.0234375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2504.0,
      "bbox_min": [
        -2512.0,
        -4437.638671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4421.8984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4430.0,
      "bbox_min": [
        -2512.0,
        -4437.63818359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4421.8984375,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2512.0,
        -4437.63818359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4430.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2512.0,
      "bbox_min": [
        -2512.0,
        -4434.32421875,
        1072.623779296875
      ],
      "bbox_max": [
        -2512.0,
        -4430.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4424.0,
      "bbox_min": [
        -2509.072998046875,
        -4424.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4421.8984375,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2509.072998046875,
        -4424.0,
        1081.0999755859375
      ],
      "bbox_max": [
        -2504.0,
        -4421.8984375,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4429.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.999755859375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1086.623779296875,
      "bbox_min": [
        -2542.0,
        -4427.49072265625,
        1082.623779296875
      ],
      "bbox_max": [
        -2526.0107421875,
        -4410.0,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2528.5,
      "bbox_min": [
        -2528.5,
        -4427.49072265625,
        1086.623779296875
      ],
      "bbox_max": [
        -2526.0107421875,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2528.5,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2526.0107421875,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2542.0,
        -4410.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2531.188232421875,
        -4410.0,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2542.0,
        -4425.2119140625,
        1072.623779296875
      ],
      "bbox_max": [
        -2531.188232421875,
        -4410.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4418.0,
      "bbox_min": [
        -2542.0,
        -4425.2119140625,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2534.0,
      "bbox_min": [
        -2542.0,
        -4418.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2542.0,
        -4418.0,
        1081.0999755859375
      ],
      "bbox_max": [
        -2534.0,
        -4410.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4423.0,
      "bbox_min": [
        -2539.339599609375,
        -4425.2119140625,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2534.0,
      "bbox_min": [
        -2539.339599609375,
        -4425.2119140625,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2539.339599609375,
        -4425.2119140625,
        1081.0999755859375
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2522.99951171875,
        -4467.9013671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1086.6236572265625,
      "bbox_min": [
        -2520.832763671875,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4432.66796875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.0,
      "bbox_min": [
        -2520.832763671875,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2516.0,
      "bbox_min": [
        -2516.0,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2504.0,
      "bbox_min": [
        -2514.61962890625,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4437.638671875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2514.61962890625,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4450.0,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2514.61962890625,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4434.32421875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4438.0,
      "bbox_min": [
        -2512.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4434.32421875,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2512.0,
      "bbox_min": [
        -2512.0,
        -4438.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4434.32421875,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2512.0,
        -4438.0,
        1081.0999755859375
      ],
      "bbox_max": [
        -2504.0,
        -4434.32421875,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2512.0,
      "bbox_min": [
        -2512.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4442.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4442.0,
      "bbox_min": [
        -2512.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2504.0,
        -4442.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.0999755859375,
      "bbox_min": [
        -2512.0,
        -4450.0,
        1081.0999755859375
      ],
      "bbox_max": [
        -2504.0,
        -4442.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.99951171875,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5066569447517395,
        0.0,
        0.8621476888656616
      ],
      "plane_d": -2230.9970703125,
      "bbox_min": [
        -2561.13232421875,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2528.5,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2528.5,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1086.623779296875,
      "bbox_min": [
        -2542.0,
        -4437.638671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2528.5,
        -4421.8984375,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2528.5,
      "bbox_min": [
        -2528.5,
        -4432.046875,
        1086.623779296875
      ],
      "bbox_max": [
        -2528.5,
        -4427.49072265625,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2542.0,
      "bbox_min": [
        -2542.0,
        -4437.638671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2542.0,
        -4421.8984375,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9894623160362244,
        0.0,
        0.14479120075702667
      ],
      "plane_d": -2682.164306640625,
      "bbox_min": [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4417.0234375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2542.0,
      "bbox_min": [
        -2542.0,
        -4437.638671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4421.8984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4431.0,
      "bbox_min": [
        -2542.0,
        -4431.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2534.0,
      "bbox_min": [
        -2542.0,
        -4431.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2534.0,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4423.0,
      "bbox_min": [
        -2542.0,
        -4423.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2539.339599609375,
        -4423.0,
        1081.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2589.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.99951171875,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2559.999755859375,
      "bbox_min": [
        -2589.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4437.638671875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996592283248901,
        -0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": -5050.2880859375,
      "bbox_min": [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4437.638671875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2542.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4437.638671875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4471.568359375,
      "bbox_min": [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2540.313720703125,
        -4471.568359375,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4467.9013671875,
        1075.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4432.04638671875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1086.6236572265625,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4432.04638671875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.0,
      "bbox_min": [
        -2528.5,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4432.04638671875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2528.5,
      "bbox_min": [
        -2528.5,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2528.5,
        -4432.04638671875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2542.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4437.638671875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4450.0,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2542.0,
        -4450.0,
        1075.623779296875
      ],
      "bbox_max": [
        -2531.3798828125,
        -4450.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2556.13671875,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1075.623779296875,
      "bbox_min": [
        -2556.13671875,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2516.999755859375,
      "bbox_min": [
        -2540.313720703125,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4471.568359375,
      "bbox_min": [
        -2540.313720703125,
        -4471.568359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2518.0,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2526.199951171875,
      "bbox_min": [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2526.199951171875,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": -4568.84033203125,
      "bbox_min": [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2526.199951171875,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2531.3798828125,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2526.199951171875,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2516.999755859375,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4450.0,
      "bbox_min": [
        -2516.999755859375,
        -4450.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2514.61962890625,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5066525340080261,
        0.8621503710746765
      ],
      "plane_d": -3197.05810546875,
      "bbox_min": [
        -2538.794921875,
        -4467.9013671875,
        1075.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2538.794921875,
        -4467.9013671875,
        1075.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1086.6236572265625,
      "bbox_min": [
        -2531.3798828125,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2514.619384765625,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.0,
      "bbox_min": [
        -2525.16650390625,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4449.99951171875,
      "bbox_min": [
        -2531.3798828125,
        -4450.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2514.619384765625,
        -4450.0,
        1086.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9894555807113647,
        0.1448361575603485
      ],
      "plane_d": -4568.85888671875,
      "bbox_min": [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2510.436767578125,
        -4450.0,
        1082.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4449.99951171875,
      "bbox_min": [
        -2531.3798828125,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2514.61962890625,
        -4450.0,
        1082.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.0,
      "bbox_min": [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2518.0,
        -4450.0,
        1082.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2518.0,
      "bbox_min": [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2518.0,
        -4450.0,
        1082.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2526.199951171875,
      "bbox_min": [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2526.199951171875,
        -4450.0,
        1082.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2516.999755859375,
      "bbox_min": [
        -2516.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2519.999755859375,
      "bbox_min": [
        -2519.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2516.999755859375,
      "bbox_min": [
        -2519.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2519.999755859375,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2619.999755859375,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2616.999755859375,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2619.999755859375,
        -4571.068359375,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090834319591522,
        -0.9510349035263062
      ],
      "plane_d": 2445.85693359375,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.998752236366272,
        0.04994066059589386,
        0.0
      ],
      "plane_d": 2842.950439453125,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9987521767616272,
        0.04994065687060356,
        0.0
      ],
      "plane_d": -2387.514404296875,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.19611327350139618,
        0.9805813431739807
      ],
      "plane_d": -1961.7152099609375,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4372.7685546875,
      "bbox_min": [
        -2920.0,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1122.623779296875,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.3387194871902466,
        0.0,
        -0.940887451171875
      ],
      "plane_d": 2004.677001953125,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1104.623779296875,
      "bbox_min": [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      "bbox_max": [
        -2849.999755859375,
        -4319.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2867.999755859375,
      "bbox_min": [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      "bbox_max": [
        -2867.999755859375,
        -4319.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2867.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4319.7685546875,
        1098.1436767578125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4361.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4361.83251953125,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4332.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4332.83251953125,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4329.99951171875,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3872325122356415,
        0.0,
        -0.9219821691513062
      ],
      "plane_d": 2074.29736328125,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2795.0,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1075.9237060546875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1090.623779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2795.0,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2795.0,
        -4319.7685546875,
        1075.9237060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4370.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2774.999755859375,
        -4370.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4370.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4333.0,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1097.623779296875,
      "bbox_min": [
        -2763.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4330.0,
      "bbox_min": [
        -2760.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": 1787.380126953125,
      "bbox_min": [
        -2742.999755859375,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4330.0,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 3797.795166015625,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2772.999755859375,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 3797.795166015625,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2684.999755859375,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1072.623779296875,
      "bbox_min": [
        -2684.999755859375,
        -4369.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1077.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1074.623779296875,
      "bbox_min": [
        -2684.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4334.7685546875,
        1077.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4337.76806640625,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4337.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4343.76806640625,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2681.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2681.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071461081504822,
        -0.7070674896240234,
        -0.0
      ],
      "plane_d": -4963.091796875,
      "bbox_min": [
        -2675.19580078125,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071461081504822,
        -0.7070674896240234,
        0.0
      ],
      "plane_d": -1186.931884765625,
      "bbox_min": [
        -2672.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25877800583839417,
        -0.9659368991851807,
        -0.0
      ],
      "plane_d": -4889.64111328125,
      "bbox_min": [
        -2672.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4345.96484375,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25877800583839417,
        -0.9659368991851807,
        0.0
      ],
      "plane_d": -3507.766845703125,
      "bbox_min": [
        -2669.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4345.96484375,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071461081504822,
        0.7070674896240234,
        0.0
      ],
      "plane_d": 1175.3408203125,
      "bbox_min": [
        -2675.19580078125,
        -4337.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071461081504822,
        0.7070674896240234,
        0.0
      ],
      "plane_d": 4951.5009765625,
      "bbox_min": [
        -2672.999755859375,
        -4337.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25877800583839417,
        0.9659368991851807,
        0.0
      ],
      "plane_d": 4878.0498046875,
      "bbox_min": [
        -2672.999755859375,
        -4335.572265625,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25877800583839417,
        0.9659368991851807,
        0.0
      ],
      "plane_d": 3496.175537109375,
      "bbox_min": [
        -2672.999755859375,
        -4335.572265625,
        1072.623779296875
      ],
      "bbox_max": [
        -2669.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": 1136.58642578125,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4343.76806640625,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4343.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071355581283569,
        0.0,
        0.7070780396461487
      ],
      "plane_d": -2639.4091796875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4337.76806640625,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4343.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2683.999755859375,
      "bbox_min": [
        -2684.999755859375,
        -4369.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4351.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4351.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4334.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4334.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4325.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4325.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4353.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4359.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2332.140625,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071211934089661,
        -0.7070924043655396,
        0.0
      ],
      "plane_d": -1201.1099853515625,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -2679.99951171875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2679.999755859375,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5773502588272095,
        0.5773502588272095,
        0.5773502588272095
      ],
      "plane_d": 367.85589599609375,
      "bbox_min": [
        -2660.999755859375,
        -4356.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071211934089661,
        -0.7070924043655396,
        0.0
      ],
      "plane_d": -1201.1099853515625,
      "bbox_min": [
        -2657.999755859375,
        -4356.7685546875,
        1055.6241455078125
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2628.0498046875,
      "bbox_min": [
        -2679.999755859375,
        -4353.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2660.999755859375,
      "bbox_min": [
        -2660.999755859375,
        -4353.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -2657.999755859375,
        -4353.7685546875,
        1058.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -4940.74462890625,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1173.6337890625,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.7685546875,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2306.6845703125,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -3812.9970703125,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1070.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -4949.58349609375,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1164.794921875,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -3812.9970703125,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2306.6845703125,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1059.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1136.58642578125,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4325.7685546875,
      "bbox_min": [
        -2739.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4323.7685546875,
      "bbox_min": [
        -2739.999755859375,
        -4325.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2685.999755859375,
      "bbox_min": [
        -2685.999755859375,
        -4325.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4323.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -2883.245849609375,
      "bbox_min": [
        -2685.999755859375,
        -4325.7685546875,
        1059.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4323.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.0,
      "bbox_min": [
        -2739.999755859375,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.0,
      "bbox_min": [
        -2739.999755859375,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2736.0,
      "bbox_min": [
        -2736.0,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4336.7685546875,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4334.7685546875,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2685.999755859375,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -2883.245849609375,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1059.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588219940662384,
        -0.0,
        0.9659250378608704
      ],
      "plane_d": -389.433349609375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659250378608704,
        4.449463176570134e-06,
        0.2588219940662384
      ],
      "plane_d": 2281.755126953125,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1097.002197265625,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2659.01904296875,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2686.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1097.0238037109375,
      "bbox_min": [
        -2686.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1098.0238037109375,
      "bbox_min": [
        -2686.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2684.999755859375,
      "bbox_min": [
        -2684.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2719.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1118.623779296875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4322.7685546875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2269.915283203125,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3876.636962890625,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1511.4652099609375,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3310.28662109375,
      "bbox_min": [
        -2723.999755859375,
        -4328.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2695.999755859375,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1118.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4328.7685546875,
      "bbox_min": [
        -2719.999755859375,
        -4363.7685546875,
        1118.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4328.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4363.7685546875,
      "bbox_min": [
        -2719.999755859375,
        -4363.7685546875,
        1118.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4363.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3876.636962890625,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1118.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4369.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1511.4652099609375,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1118.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4369.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2269.915283203125,
      "bbox_min": [
        -2719.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1118.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4322.7685546875,
        1109.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2699.999755859375,
      "bbox_min": [
        -2699.999755859375,
        -4322.7685546875,
        1109.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3310.28662109375,
      "bbox_min": [
        -2719.999755859375,
        -4328.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4322.7685546875,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4369.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1074.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4319.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9587745070457458,
        -0.2841680347919464
      ],
      "plane_d": 4446.4892578125,
      "bbox_min": [
        -2919.999755859375,
        -4322.732421875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -2919.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6481265425682068,
        -0.648120105266571,
        0.3998405635356903
      ],
      "plane_d": -1443.3369140625,
      "bbox_min": [
        -2719.46533203125,
        -4252.76513671875,
        1121.623779296875
      ],
      "bbox_max": [
        -2714.73876953125,
        -4249.7685546875,
        1129.285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2701.179931640625,
        -4292.8291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2695.4853515625,
        -4291.30322265625,
        1056.00244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 970.6865844726562,
      "bbox_min": [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2750.961181640625,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2693.868408203125,
        -4289.6865234375,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2739.999755859375,
        -4303.23046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2693.868408203125,
        -4289.6865234375,
        1066.3548583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2695.4853515625,
        -4291.30322265625,
        1056.00244140625
      ],
      "bbox_max": [
        -2693.868408203125,
        -4289.6865234375,
        1060.39111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2739.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4303.23046875,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2750.961181640625,
        -4306.16796875,
        1059.5826416015625
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2695.4853515625,
        -4291.30322265625,
        1059.5826416015625
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 970.6865844726562,
      "bbox_min": [
        -2869.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4306.16796875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4306.16796875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.0234375,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2733.050048828125,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4316.0,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4308.0,
      "bbox_min": [
        -2739.999755859375,
        -4308.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.0,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4316.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2736.0,
      "bbox_min": [
        -2736.0,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4316.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2920.0,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1128.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4479.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2660.0,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2739.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4446.7685546875,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.0345052689663135e-05
      ],
      "plane_d": -2659.978271484375,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2659.999755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4449.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2407.801025390625,
      "bbox_min": [
        -2884.999755859375,
        -4499.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2864.999755859375,
      "bbox_min": [
        -2864.999755859375,
        -4497.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2864.999755859375,
      "bbox_min": [
        -2864.999755859375,
        -4499.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4494.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4551.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2819.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2764.999755859375,
      "bbox_min": [
        -2764.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2764.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2819.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2715.02392578125,
      "bbox_min": [
        -2764.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2764.999755859375,
      "bbox_min": [
        -2764.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2764.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4509.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1089.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4529.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4509.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2660.0,
      "bbox_min": [
        -2660.0,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2660.0,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2659.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4526.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4526.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2759.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2659.999755859375,
      "bbox_min": [
        -2660.0,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4569.7998046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2659.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2776.999755859375,
      "bbox_min": [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1112.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2759.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4529.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2749.999755859375,
      "bbox_min": [
        -2749.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4529.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2759.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2749.999755859375,
      "bbox_min": [
        -2759.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4469.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4373.7685546875,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -4497.05322265625,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2772.999755859375,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4373.7685546875,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -4497.05322265625,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": 1971.038330078125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4575.96142578125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4444.76806640625,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4449.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4449.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4499.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1127.623779296875,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4014.522705078125,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2388.001953125,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 1214.3681640625,
      "bbox_min": [
        -2844.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2920.0,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1112.623779296875,
      "bbox_min": [
        -2920.0,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4569.7998046875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2776.999755859375,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2779.999755859375,
        -4571.068359375,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2920.0,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1112.623779296875,
      "bbox_min": [
        -2920.0,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4589.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090860843658447,
        -0.9510340690612793
      ],
      "plane_d": 2445.8681640625,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": 3002.7373046875,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        0.980580747127533
      ],
      "plane_d": -1961.727783203125,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3746.760498046875,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783878922462463,
        0.06522687524557114,
        0.1962204873561859
      ],
      "plane_d": 3718.708251953125,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4723.5966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3599.999755859375,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4719.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3339.772216796875,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 5155.2822265625,
      "bbox_min": [
        -3145.921875,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3145.921875,
        -4735.19970703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3145.921875,
        -4733.689453125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242666959762573,
        0.8449944257736206,
        0.32554891705513
      ],
      "plane_d": 2255.4482421875,
      "bbox_min": [
        -3145.921875,
        -4710.5654296875,
        1152.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4692.80419921875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4484086036682129,
        0.8938286900520325,
        0.0
      ],
      "plane_d": 5564.03759765625,
      "bbox_min": [
        -3116.6005859375,
        -4735.19970703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": 4645.59619140625,
      "bbox_min": [
        -3116.6005859375,
        -4735.19970703125,
        1092.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 4885.83447265625,
      "bbox_min": [
        -3116.6005859375,
        -4710.5654296875,
        1092.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4909895062446594,
        -0.87116539478302
      ],
      "plane_d": 3257.42919921875,
      "bbox_min": [
        -3116.6005859375,
        -4695.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 5510.220703125,
      "bbox_min": [
        -3029.098876953125,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2968.059326171875,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3580.227294921875,
        -5045.98291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.541015625,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3580.227294921875,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3347.17578125,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4919.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9056034088134766,
        0.4241255521774292,
        -0.0
      ],
      "plane_d": 4710.7529296875,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037309765815735,
        0.7593981027603149,
        0.24253521859645844
      ],
      "plane_d": 5452.6083984375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037311553955078,
        0.759398341178894,
        0.24253442883491516
      ],
      "plane_d": 1709.478515625,
      "bbox_min": [
        -3290.5458984375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3290.5458984375,
        -4980.90283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2929.999755859375,
        -4932.2685546875,
        1062.337158203125
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3290.5458984375,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 5510.220703125,
      "bbox_min": [
        -3003.574462890625,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2977.03515625,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2977.03515625,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2977.03515625,
        -4821.984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2977.03515625,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037311553955078,
        0.759398341178894,
        0.24253442883491516
      ],
      "plane_d": 1709.478515625,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037309765815735,
        0.7593981027603149,
        0.24253521859645844
      ],
      "plane_d": 5452.6083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.5458984375,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838134765625,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838134765625,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2970.626953125,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2924.617919921875,
        -4942.994140625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1195.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2946.8349609375,
        -4856.3642578125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3292.71533203125,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037309765815735,
        0.7593981027603149,
        0.24253521859645844
      ],
      "plane_d": 5452.6083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.837890625,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037311553955078,
        0.759398341178894,
        0.24253442883491516
      ],
      "plane_d": 1709.478515625,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4909.00634765625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2959.9150390625,
        -4909.00634765625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3574.965576171875,
        -4916.06201171875,
        1202.759765625
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1238.15380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3351.867919921875,
        -4916.06201171875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4746.9443359375,
        1230.0960693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3298.212890625,
        -4912.5498046875,
        1213.3753662109375
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3298.212890625,
        -4856.7685546875,
        1213.3753662109375
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3566.1171875,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3298.212890625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3070.100341796875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8526395559310913,
        -0.35317710041999817,
        0.3850606083869934
      ],
      "plane_d": 694.5632934570312,
      "bbox_min": [
        -3128.600341796875,
        -4329.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3104.5537109375,
        -4281.6142578125,
        1121.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4257.44384765625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113733768463135,
        0.0,
        0.41158080101013184
      ],
      "plane_d": 2376.92529296875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4329.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1101.6236572265625,
      "bbox_min": [
        -3128.60009765625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3105.568603515625,
        -4629.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.980980634689331,
        -0.19410614669322968,
        0.0
      ],
      "plane_d": 2113.042236328125,
      "bbox_min": [
        -3105.568603515625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1101.6236572265625,
      "bbox_min": [
        -3105.568603515625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.650367943919264e-05
      ],
      "plane_d": 3020.13916015625,
      "bbox_min": [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5580329298973083,
        0.0,
        0.8298189043998718
      ],
      "plane_d": 799.0686645507812,
      "bbox_min": [
        -3070.10009765625,
        -4629.7685546875,
        1068.0
      ],
      "bbox_max": [
        -3020.10009765625,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4379.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4419.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682324230670929,
        0.0,
        0.7310497760772705
      ],
      "plane_d": 1306.93017578125,
      "bbox_min": [
        -3058.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -3070.100341796875,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3070.100341796875,
        -4271.44384765625,
        1121.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3046.499755859375,
        -4261.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4249.7685546875,
        1147.9725341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266539573669434,
        -0.9238870739936829,
        0.0
      ],
      "plane_d": -2812.622802734375,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682324230670929,
        -0.0,
        0.7310497760772705
      ],
      "plane_d": 1306.9300537109375,
      "bbox_min": [
        -3047.487548828125,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -3020.100830078125,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9113706350326538,
        0.411586731672287
      ],
      "plane_d": -4345.6044921875,
      "bbox_min": [
        -3020.09814453125,
        -4261.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1147.9725341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.7998046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2947.301025390625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3182.88427734375,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3182.88427734375,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3254.78857421875,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3556.305419921875,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -3985.582763671875,
        -4266.263671875,
        1353.5482177734375
      ],
      "bbox_max": [
        -3900.749755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -4007.749267578125,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3900.749755859375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4266.263671875,
        1353.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -3888.191162109375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3835.11669921875,
        -4333.81396484375,
        1329.1610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3488.941650390625,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -4035.11669921875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.16748046875,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2978.129638671875,
        -4906.9423828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3573431670665741,
        0.0,
        0.9339731931686401
      ],
      "plane_d": -173.7481689453125,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -2962.83203125,
        -3780.262451171875,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -2962.83203125,
        -3780.262451171875,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3780.262451171875,
        1322.556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3311.842041015625,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -3100.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 33857,
      "centroid": [
        -2289.999755859375,
        -4444.7685546875,
        1064.623779296875
      ],
      "bbox_min": [
        -2299.999755859375,
        -4449.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2279.999755859375,
        -4439.7685546875,
        1064.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 20.0,
        "door_depth": 10.0,
        "leaf_depth": 10.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -2279.999755859375,
          -4439.7685546875,
          1064.623779296875
        ],
        [
          -2279.999755859375,
          -4449.7685546875,
          1064.623779296875
        ],
        [
          -2299.999755859375,
          -4449.7685546875,
          1064.623779296875
        ],
        [
          -2299.999755859375,
          -4439.7685546875,
          1064.623779296875
        ]
      ],
      "plane_distance": -1064.6238,
      "authentic_texture": "basegrass"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 34386,
      "centroid": [
        -2709.999755859375,
        -4321.2685546875,
        1104.623779296875
      ],
      "bbox_min": [
        -2719.999755859375,
        -4321.2685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4321.2685546875,
        1112.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 0.0,
        "height_z": 16.0,
        "door_width": 20.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2699.999755859375,
          -4321.2685546875,
          1096.623779296875
        ],
        [
          -2699.999755859375,
          -4321.2685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4321.2685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4321.2685546875,
          1096.623779296875
        ],
        [
          -2719.999755859375,
          -4321.2685546875,
          1112.623779296875
        ],
        [
          -2719.999755859375,
          -4321.2685546875,
          1112.623779296875
        ],
        [
          -2699.999755859375,
          -4321.2685546875,
          1112.623779296875
        ],
        [
          -2699.999755859375,
          -4321.2685546875,
          1112.623779296875
        ]
      ],
      "plane_distance": 4321.2686,
      "authentic_texture": "warehouswin-m"
    },
    {
      "tag": "CSlidingDoor piece: rechrg",
      "entity_class": "CSlidingDoor",
      "piece_name": "rechrg",
      "offset": 35264,
      "centroid": [
        -2339.899658203125,
        -4310.2685546875,
        1057.623779296875
      ],
      "bbox_min": [
        -2339.899658203125,
        -4311.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2339.899658203125,
        -4308.7685546875,
        1059.623779296875
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 3.0,
        "height_z": 4.0,
        "door_width": 3.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2339.899658203125,
          -4311.7685546875,
          1055.623779296875
        ],
        [
          -2339.899658203125,
          -4308.7685546875,
          1059.623779296875
        ],
        [
          -2339.899658203125,
          -4311.7685546875,
          1059.623779296875
        ],
        [
          -2339.899658203125,
          -4308.7685546875,
          1055.623779296875
        ]
      ],
      "plane_distance": 2339.8997
    },
    {
      "tag": "CSlidingDoor piece: eledor3a",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor3a",
      "offset": 35980,
      "centroid": [
        -2611.2998046875,
        -4504.7685546875,
        1037.6119384765625
      ],
      "bbox_min": [
        -2611.7998046875,
        -4509.7685546875,
        1032.6239013671875
      ],
      "bbox_max": [
        -2610.7998046875,
        -4499.7685546875,
        1042.5999755859375
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 9.97607421875,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2610.7998046875,
          -4499.7685546875,
          1042.5999755859375
        ],
        [
          -2610.7998046875,
          -4499.7685546875,
          1032.6239013671875
        ],
        [
          -2610.7998046875,
          -4509.7685546875,
          1042.5999755859375
        ],
        [
          -2610.7998046875,
          -4509.7685546875,
          1032.6239013671875
        ],
        [
          -2611.7998046875,
          -4499.7685546875,
          1032.6239013671875
        ],
        [
          -2611.7998046875,
          -4499.7685546875,
          1042.5999755859375
        ],
        [
          -2611.7998046875,
          -4509.7685546875,
          1042.5999755859375
        ],
        [
          -2611.7998046875,
          -4509.7685546875,
          1032.6239013671875
        ]
      ],
      "plane_distance": 2610.7998,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 40371,
      "centroid": [
        -2619.999755859375,
        -4497.7685546875,
        1045.0999755859375
      ],
      "bbox_min": [
        -2624.999755859375,
        -4497.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2614.999755859375,
        -4497.7685546875,
        1047.5999755859375
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 0.0,
        "height_z": 5.0,
        "door_width": 10.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -2614.999755859375,
          -4497.7685546875,
          1047.5999755859375
        ],
        [
          -2614.999755859375,
          -4497.7685546875,
          1047.5999755859375
        ],
        [
          -2614.999755859375,
          -4497.7685546875,
          1042.5999755859375
        ],
        [
          -2614.999755859375,
          -4497.7685546875,
          1042.5999755859375
        ],
        [
          -2624.999755859375,
          -4497.7685546875,
          1042.5999755859375
        ],
        [
          -2624.999755859375,
          -4497.7685546875,
          1042.5999755859375
        ],
        [
          -2624.999755859375,
          -4497.7685546875,
          1047.5999755859375
        ],
        [
          -2624.999755859375,
          -4497.7685546875,
          1047.5999755859375
        ]
      ],
      "plane_distance": -4497.7686,
      "authentic_texture": "door12"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 41200,
      "centroid": [
        -2667.4998168945312,
        -4367.7685546875,
        1052.623779296875
      ],
      "bbox_min": [
        -2679.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4362.7685546875,
        1052.623779296875
      ],
      "dimensions_source": {
        "span_x": 25.0,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 25.0,
        "door_depth": 10.0,
        "leaf_depth": 10.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -2654.999755859375,
          -4372.7685546875,
          1052.623779296875
        ],
        [
          -2654.999755859375,
          -4372.7685546875,
          1052.623779296875
        ],
        [
          -2679.999755859375,
          -4372.7685546875,
          1052.623779296875
        ],
        [
          -2679.999755859375,
          -4372.7685546875,
          1052.623779296875
        ],
        [
          -2679.999755859375,
          -4362.7685546875,
          1052.623779296875
        ],
        [
          -2679.999755859375,
          -4362.7685546875,
          1052.623779296875
        ],
        [
          -2655.0,
          -4362.7685546875,
          1052.623779296875
        ],
        [
          -2655.0,
          -4362.7685546875,
          1052.623779296875
        ]
      ],
      "plane_distance": 1052.6238
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 41950,
      "centroid": [
        -2620.0,
        -4449.16845703125,
        1097.3118896484375
      ],
      "bbox_min": [
        -2625.0,
        -4449.16845703125,
        1092.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4449.16845703125,
        1102.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 0.0,
        "height_z": 9.376220703125,
        "door_width": 10.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2625.0,
          -4449.16845703125,
          1092.623779296875
        ],
        [
          -2625.0,
          -4449.16845703125,
          1102.0
        ],
        [
          -2615.0,
          -4449.16845703125,
          1102.0
        ],
        [
          -2615.0,
          -4449.16845703125,
          1092.623779296875
        ]
      ],
      "plane_distance": -4449.1685
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 42477,
      "centroid": [
        -2619.999755859375,
        -4504.7685546875,
        1097.623779296875
      ],
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1097.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1097.623779296875
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 10.0,
        "door_depth": 10.0,
        "leaf_depth": 10.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -2614.999755859375,
          -4509.7685546875,
          1097.623779296875
        ],
        [
          -2624.999755859375,
          -4509.7685546875,
          1097.623779296875
        ],
        [
          -2624.999755859375,
          -4499.7685546875,
          1097.623779296875
        ],
        [
          -2614.999755859375,
          -4499.7685546875,
          1097.623779296875
        ]
      ],
      "plane_distance": -1097.6238,
      "authentic_texture": "warehous2-d"
    }
  ],
  "tutorial_messages": []
}